webpackJsonp([1],{

/***/ 113:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nem_sdk__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_nem_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_localforage__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_localforage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nemWrapper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper__ = __webpack_require__(28);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



//import axios from 'axios';

// EndpointをTestnetに指定します
// 第1引数はTestnet用のデフォルトのノード
// 第2引数はデフォルトのポート(7890)
var mosaicTransfer = /** @class */ (function () {
    function mosaicTransfer() {
        var _this = this;
        this.endpoint = '';
        this.address = '';
        this.toAddress = '';
        this.sendAmount = 0;
        this.sendMsg = '';
        this.password = '';
        this.publicKey = '';
        this.privateKey = '';
        this.common = '';
        this.yourMosaicNamespace = '';
        this.yourMosaicName = '';
        this.company_code = 0;
        this.minimum_unit = 25;
        this.working_hour_per_day = 8;
        this.approval_flag = 1;
        this.carry_over_flag = 1;
        this.show_kurikoshi = false;
        this.approval = false;
        this.nonapproval = false;
        this.host = '';
        this.port = '';
        this.net = '';
        this.nem = new __WEBPACK_IMPORTED_MODULE_2__nemWrapper__["a" /* default */]();
        this.helper = new __WEBPACK_IMPORTED_MODULE_3__helper__["a" /* default */]();
        // NIS設定.
        this.load()
            .then(function (result) {
            console.log(result);
            // 無ければアカウントを作成します
            if (result === null) {
                _this.nem.createAccount()
                    .then(function (wallet) {
                    _this.address = wallet.address;
                    _this.privateKey = wallet.privateKey;
                }).catch(function (error) {
                    console.error(error);
                });
            }
            else {
            }
        }).catch(function (error) {
            console.error(error);
        });
        this.host = 'https://nem02.neluta.win';
        this.port = '7891';
        //this.host = 'http://go.nem.ninja'
        //this.port = '7890'
        this.net = __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.model.network.data.mainnet.id;
        this.endpoint = __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.model.objects.create("endpoint")(this.host, this.port);
        // TODO: 自分の送金したい先のアドレスに変更してください
        // 送金先のアドレス  
        this.sendAmount = 1;
        // 送金の際に指定するメッセージ（空文字でも可）
        this.sendMsg = 'テスト私用のため';
        // TODO: 自分の送金元ウォレットのパスワードを入力してください
        // 送金元ウォレットのパスワード
        var password = 'wallet';
        //const privateKey = this.privateKey
        //const　common = nem.model.objects.create('common')(password, privateKey)
        // TODO: 送りたいモザイクのネームスペースを入力してください
        // ネームスペース
        this.yourMosaicNamespace = 'smart-uq';
        // TODO: 送りたいモザイクのモザイク名を入力してください
        // モザイク名
    }
    mosaicTransfer.prototype.sendMosaics = function (privateKey, toAmount, mosaic_message, date, amount_hd, post_message, networkTimestamp) {
        return __awaiter(this, void 0, void 0, function () {
            var host, port, net, endpoint, toAddress, password, privatekey, sendAmount, yourMosaicNamespace, yourMosaicName, common, transferTransaction, xemMozaic, yourMosaic, mosaicDefinitionMetaDataPair;
            var _this = this;
            return __generator(this, function (_a) {
                //privateKey,toAmount,massage,date,amount_hd,message
                console.log(__WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.model.nodes.defaultTestnet);
                console.log(__WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.model.network.data.mainnet.id);
                host = 'https://nem02.neluta.win';
                port = '7891';
                net = __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.model.network.data.mainnet.id;
                endpoint = __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.model.objects.create('endpoint')(host, port);
                console.log(endpoint);
                toAddress = this.toAddress;
                password = 'wallet';
                privatekey = privateKey;
                sendAmount = toAmount;
                yourMosaicNamespace = this.yourMosaicNamespace;
                yourMosaicName = this.yourMosaicName;
                common = __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.model.objects.create('common')("wallet", privatekey);
                console.log("common: ");
                console.log(common);
                transferTransaction = __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.model.objects.create('transferTransaction')(toAddress, sendAmount, mosaic_message);
                xemMozaic = __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.model.objects.create('mosaicAttachment')('nem', 'xem', 0 * 1000000);
                transferTransaction.mosaics.push(xemMozaic);
                yourMosaic = __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.model.objects.create('mosaicAttachment')(yourMosaicNamespace, yourMosaicName, 1);
                transferTransaction.mosaics.push(yourMosaic);
                console.log("PUSHmosaic" + yourMosaic);
                mosaicDefinitionMetaDataPair = __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.model.objects.get('mosaicDefinitionMetaDataPair');
                console.log("モザイクの定義を取得する");
                __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.com.requests.namespace.mosaicDefinitions(endpoint, yourMosaic.mosaicId.namespaceId).then(function (res) {
                    // モザイク定義を取得してモザイク定義オブジェクトへ格納する
                    console.log("モザイク定義を取得してモザイク定義オブジェクトへ格納する");
                    var neededDefinition = __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.utils.helpers.searchMosaicDefinitionArray(res.data, [yourMosaicName]);
                    console.log("neededDefinition" + neededDefinition);
                    // モザイク定義オブジェクトで使用するため、モザイクの名前を取得
                    var fullMosaicName = __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.utils.format.mosaicIdToName(yourMosaic.mosaicId);
                    console.log("fullMosaicName: " + fullMosaicName);
                    // モザイクの存在確認
                    if (undefined === neededDefinition[fullMosaicName]) {
                        return console.log('Mosaic not found !');
                    }
                    console.log("モザイクの存在確認OK");
                    console.log("adress: " + toAddress);
                    // モザイクの定義をモザイク定義オブジェクトへ追加する
                    mosaicDefinitionMetaDataPair[fullMosaicName] = {};
                    mosaicDefinitionMetaDataPair[fullMosaicName].mosaicDefinition = neededDefinition[fullMosaicName];
                    console.log("オブジェクト追加完了");
                    __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.com.requests.mosaic.supply(endpoint, fullMosaicName).then(function (supplyRes) {
                        // 供給量をmosaicDefinitionMetaDataPairに設定する。
                        console.log("供給量をmosaicDefinitionMetaDataPairに設定する。");
                        mosaicDefinitionMetaDataPair['nem:xem'].supply = 8999999999;
                        mosaicDefinitionMetaDataPair[fullMosaicName].supply = supplyRes.supply;
                        // 1. まず、SDKに通常通りトランザクションエンティティを作成させる
                        var transactionEntity = __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.model.transactions.prepare('mosaicTransferTransaction')(common, transferTransaction, mosaicDefinitionMetaDataPair, __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.model.network.data.mainnet.id);
                        // 2. ネットワーク時刻から、正しいタイムスタンプとデッドラインを計算する
                        var timeStamp = Math.floor(networkTimestamp / 1000);
                        var deadline = timeStamp + 3600;
                        // 3. prepare後に、作成されたエンティティの間違ったタイムスタンプを、正しい値で「上書き」する
                        transactionEntity.timeStamp = timeStamp;
                        transactionEntity.deadline = deadline;
                        console.log("署名をしてTransactionを送信する準備を完了");
                        // 4. 正しいタイムスタンプに書き換えたエンティティをネットワークに送信する
                        __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.model.transactions.send(common, transactionEntity, endpoint).then(function (sendRes) {
                            console.log('sendRes:', sendRes);
                            if (sendRes.message == "SUCCESS") {
                                console.log("SUCCESS");
                                if (date == '') {
                                    alert("送信成功しました。");
                                    window.location.href = '/';
                                }
                                else {
                                    _this.postChatWork(toAmount, date, amount_hd, post_message).then(function () {
                                        console.log("chatworkにメッセージ送信完了");
                                        alert("送信成功しました。");
                                        window.location.href = '/';
                                    });
                                }
                            }
                            else {
                                console.log("送信エラー");
                                alert("送信エラー: " + sendRes.message);
                            }
                            console.log("リクエスト結果：\n" + sendRes.message);
                        }).catch(function (err) {
                            console.log('txErr:', err);
                            console.log("送信エラー");
                        });
                    }).catch(function (supplyErr) {
                        console.log('supplyErr:', supplyErr);
                    });
                }).catch(function (e) {
                    console.log('mosaicDefinitionsError:', e);
                });
                return [2 /*return*/];
            });
        });
    };
    // ローカルストレージから取得.
    mosaicTransfer.prototype.load = function () {
        return __awaiter(this, void 0, void 0, function () {
            var key, result, key2, result2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        key = 'SmartUQ-Wallet';
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_1_localforage___default.a.getItem(key)];
                    case 1:
                        result = _a.sent();
                        if (result !== null) {
                            this.address = result.address;
                            this.privateKey = this.helper.Decrypt(result.privateKey);
                            this.publicKey = result.publicKey;
                        }
                        key2 = 'Company-Info';
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_1_localforage___default.a.getItem(key2)];
                    case 2:
                        result2 = _a.sent();
                        if (!(result2 == null)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.nem.getCompanyInfoFromAPI(this.address)];
                    case 3:
                        result2 = _a.sent();
                        _a.label = 4;
                    case 4: return [4 /*yield*/, this.setvar(result2)];
                    case 5:
                        _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    mosaicTransfer.prototype.setvar = function (result) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.yourMosaicName = result.mosaic_name;
                this.toAddress = result.address;
                console.log(result.address);
                console.log(result.mosaic_name);
                this.company_code = result.company_code;
                this.minimum_unit = result.minimum_unit;
                this.working_hour_per_day = result.working_hour_per_day;
                this.approval_flag = result.approval_flag;
                this.carry_over_flag = result.carry_over_flag;
                if (this.carry_over_flag == 1) {
                    this.show_kurikoshi = true;
                }
                else {
                    this.show_kurikoshi = false;
                }
                if (this.approval_flag == 1) {
                    this.approval = true;
                }
                else {
                    this.nonapproval = true;
                }
                return [2 /*return*/];
            });
        });
    };
    mosaicTransfer.prototype.postChatWork = function (toAmount, date, amount_hd, post_message) {
        return __awaiter(this, void 0, void 0, function () {
            var headers, access_token, uid, client, request, url, amount_date, message, request_url, params;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log("in postchatwork");
                        return [4 /*yield*/, this.helper.loadHeaders()];
                    case 1:
                        headers = _a.sent();
                        access_token = headers["access-token"];
                        uid = headers["uid"];
                        client = headers["client"];
                        request = new XMLHttpRequest();
                        url = this.helper.path + "auth_users/send_massege/" + this.address + "?message=";
                        amount_date = "&amount=" + toAmount + "&date=" + date;
                        message = post_message;
                        request_url = url + message + amount_date;
                        console.log(request_url);
                        request.open('GET', request_url);
                        request.setRequestHeader("Content-Type", "application/json");
                        request.setRequestHeader("access-token", access_token);
                        request.setRequestHeader("uid", uid);
                        request.setRequestHeader("client", client);
                        request.onreadystatechange = function () {
                            if (request.readyState != 4) {
                                // リクエスト中
                            }
                            else if (request.status != 200) {
                                // 失敗
                            }
                            else {
                                // 取得成功
                                // var result = request.responseText;
                            }
                        };
                        request.send(null);
                        console.log('tapSend', message);
                        params = "/#/outputs?amount=" + toAmount + "&amount_hd=" + amount_hd + "&massege=" + post_message + "&date=" + date;
                        return [2 /*return*/];
                }
            });
        });
    };
    return mosaicTransfer;
}());
/* harmony default export */ __webpack_exports__["a"] = (mosaicTransfer);


/***/ }),

/***/ 152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


// コンポーネントの設定
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    // クラス
    function App() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.title = 'SmartUQ(bata)';
        _this.SmartUQ_logo = './static/img/SmartUQ_logo.png';
        _this.background_img1 = './static/img/background.png';
        _this.footer_rireki = './static/img/icon_rireki_on_x2.png';
        _this.footer_settei = './static/img/icon_settei_on_x2.png';
        _this.footer_sinsei = './static/img/icon_sinsei_on_x2.png';
        _this.footer_kintai = './static/img/icon_kintai_on_x2.png';
        return _this;
    }
    App.prototype.mounted = function () { };
    App = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({
            name: 'app',
            watch: {
                '$route': function (toRoute, fromRoute) {
                    console.log("\u73FE\u5728\u306Epath\uFF1A" + toRoute.path);
                }
            },
            methods: {
                check: function () {
                }
            }
        })
        // クラス
    ], App);
    return App;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (App);


/***/ }),

/***/ 153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Wallet_vue__ = __webpack_require__(286);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var Hello = /** @class */ (function (_super) {
    __extends(Hello, _super);
    function Hello() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.title = 'SmartUQ';
        return _this;
    }
    Hello.prototype.mounted = function () { };
    Hello = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({
            name: 'hello',
            // propsは他のvueから値渡しされる時に使用する.
            components: {
                Wallet: __WEBPACK_IMPORTED_MODULE_2__pages_Wallet_vue__["a" /* default */]
            }
        })
    ], Hello);
    return Hello;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (Hello);


/***/ }),

/***/ 154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__details_Waitting_vue__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__details_Login_vue__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__details_Top_vue__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ts_getAddress__ = __webpack_require__(258);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var Wallet = /** @class */ (function (_super) {
    __extends(Wallet, _super);
    function Wallet() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.background_img = './static/img/background.png';
        return _this;
    }
    Wallet.prototype.mounted = function () {
    };
    Wallet = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({
            name: 'wallet',
            data: function () { return ({
                getAddress: new __WEBPACK_IMPORTED_MODULE_5__ts_getAddress__["a" /* default */](),
                version: 'ver1.4.6',
                address: '',
                private_key: '',
                public_key: '',
                login_page: false,
                waitting_page: false,
                top_page: false,
            }); },
            components: { Login: __WEBPACK_IMPORTED_MODULE_3__details_Login_vue__["a" /* default */], Waitting: __WEBPACK_IMPORTED_MODULE_2__details_Waitting_vue__["a" /* default */], Top: __WEBPACK_IMPORTED_MODULE_4__details_Top_vue__["a" /* default */] },
            mounted: function () {
                // ビュー全体が再レンダリングされた後にのみ実行されるコード
                this.$nextTick(function () {
                    this.$data.address = this.$data.getAddress.address;
                    this.$data.private_key = this.$data.getAddress.privateKey;
                    this.$data.public_key = this.$data.getAddress.publicKey;
                    this.$data.login_page = this.$data.getAddress.login_page;
                    this.$data.waitting_page = this.$data.getAddress.waitting_page;
                    this.$data.top_page = this.$data.getAddress.top_page;
                    console.log(this.$data.getAddress.waitting_page);
                    console.log("========-");
                });
            }
        })
    ], Wallet);
    return Wallet;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (Wallet);


/***/ }),

/***/ 155:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var Watting = /** @class */ (function (_super) {
    __extends(Watting, _super);
    function Watting() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.background_img = './static/img/background.png';
        return _this;
    }
    Watting.prototype.mounted = function () { };
    Watting = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({
            name: 'watting',
            data: function () { return ({}); },
            props: ['version']
        })
    ], Watting);
    return Watting;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (Watting);


/***/ }),

/***/ 156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConfirmationModal_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_localforage__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_localforage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ts_helper__ = __webpack_require__(28);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};





var Login = /** @class */ (function (_super) {
    __extends(Login, _super);
    function Login() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.email = '';
        _this.password = '';
        _this.background_img = './static/img/background.png';
        return _this;
    }
    Login.prototype.mounted = function () {
    };
    //modal
    Login.prototype.openModal = function () {
        this.$data.modal = true;
    };
    Login.prototype.closeModal = function () {
        this.$data.modal = false;
        this.$data.info_modal = false;
    };
    Login.prototype.signinSend = function () {
        //ログイン処理
        this.$data.signin_modal = false;
    };
    Login.prototype.setData = function (address, privateKey) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.$data.wallet.setData(address, privateKey);
                return [2 /*return*/];
            });
        });
    };
    Login.prototype.login = function () {
        return __awaiter(this, void 0, void 0, function () {
            var request, url, send, savedata, token, client, uid, Headers;
            var _this = this;
            return __generator(this, function (_a) {
                request = new XMLHttpRequest();
                url = this.$data.helper.path + "auth/sign_in";
                console.log(url);
                send = new FormData();
                send.append("email", this.email);
                send.append("password", this.password);
                savedata = [];
                request.open('POST', url);
                request.send(send);
                request.onreadystatechange = function () {
                    if (request.readyState != 4) {
                        // リクエスト中
                        console.log('リクエスト中');
                    }
                    else if (request.status != 200) {
                        // 失敗
                        console.log('失敗');
                        var result = request.responseText;
                        alert(result);
                    }
                    else {
                        // 取得成功
                        console.log('取得成功');
                        var result = request.responseText;
                        savedata = JSON.parse(result);
                        if (savedata.data.registered_status == -1) {
                            alert("ログイン情報が正しくありません。");
                        }
                        else {
                            alert("ログインしました。");
                            token = request.getResponseHeader('access-token');
                            uid = request.getResponseHeader('uid');
                            client = request.getResponseHeader('client');
                            console.log(savedata.data.registered_status);
                            console.log(token);
                            console.log(uid);
                            console.log(client);
                            console.log(savedata);
                        }
                    }
                };
                setTimeout(function () {
                    if (savedata.data.registered_status != -1) {
                        __WEBPACK_IMPORTED_MODULE_3_localforage___default.a.clear();
                        console.log(savedata);
                        Headers = {
                            'access-token': token,
                            'uid': uid,
                            'client': client
                        };
                        _this.getData(Headers, savedata.data.address);
                        console.log(savedata.data.address);
                        if (savedata.data.address) {
                            _this.$data.helper.saveData(savedata.data);
                            _this.$data.helper.save('Headers', Headers);
                        }
                    }
                }, 1500);
                this.closeModal();
                return [2 /*return*/];
            });
        });
    };
    Login.prototype.getData = function (Headers, address) {
        var _this = this;
        var access_token = Headers["access-token"];
        var uid = Headers["uid"];
        var client = Headers["client"];
        var request = new XMLHttpRequest();
        var result = "";
        var url = this.$data.helper.path + "auth_users/initial_data/" + address;
        console.log(url);
        request.open('GET', url);
        request.setRequestHeader("Content-Type", "application/json");
        request.setRequestHeader("access-token", access_token);
        request.setRequestHeader("uid", uid);
        request.setRequestHeader("client", client);
        request.onreadystatechange = function () {
            if (request.readyState != 4) {
                // リクエスト中
                console.log('リクエスト中');
            }
            else if (request.status != 200) {
                // 失敗
                console.log('失敗');
            }
            else {
                // 取得成功
                console.log('取得成功');
                result = request.response;
                console.log(request);
            }
        };
        request.send(null);
        setTimeout(function () {
            if (result != '') {
                _this.$data.helper.saveInitialData(result);
            }
        }, 1000);
    };
    Login = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({
            data: function () { return ({
                modal: false,
                helper: new __WEBPACK_IMPORTED_MODULE_4__ts_helper__["a" /* default */](),
            }); },
            components: { ConfirmationModal: __WEBPACK_IMPORTED_MODULE_2__ConfirmationModal_vue__["a" /* default */] },
            props: ['address', 'private_key', 'public_key', 'version']
        })
    ], Login);
    return Login;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (Login);


/***/ }),

/***/ 167:
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ 174:
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ 188:
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ 194:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ts_nemWrapper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ts_walletModel__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ts_mosaicTransfer__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConfirmationModal_vue__ = __webpack_require__(48);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};






var Top = /** @class */ (function (_super) {
    __extends(Top, _super);
    function Top() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isLoading = false;
        //wallet:walletModel = new walletModel()
        _this.mosaic = new __WEBPACK_IMPORTED_MODULE_4__ts_mosaicTransfer__["a" /* default */]();
        _this.toAmount = 0;
        _this.day = "";
        _this.hour = "";
        _this.min = "";
        _this.nday = 0;
        _this.nhour = 0;
        _this.nmin = 0;
        _this.amount_hd = "";
        _this.toDate = '';
        _this.toTime = '';
        _this.toAddr = '';
        _this.toMyAddr = "";
        _this.message = '';
        _this.account_name = '';
        _this.email = '';
        _this.company_code = '';
        _this.hire_year = 2018;
        _this.hire_month = 4;
        _this.hire_day = 1;
        _this.password = '';
        _this.validation = [];
        _this.background_img = './static/img/background.png';
        return _this;
    }
    Top.prototype.mounted = function () { };
    //modal
    Top.prototype.openModal = function () {
        this.$data.modal = true;
        this.nday = Number(this.day);
        this.nhour = Number(this.hour);
        this.nmin = Number(this.min);
        this.getAmount_hd(this.nday, this.nhour, this.nmin);
        this.getAmount(this.nday, this.nhour, this.nmin);
    };
    Top.prototype.closeModal = function () {
        this.$data.modal = false;
        this.$data.info_modal = false;
    };
    Top.prototype.doSend = function () {
        return __awaiter(this, void 0, void 0, function () {
            var toAmount, date, amount_hd, massage, send_massage, nodeUrl, response, timeData, networkTimestamp, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.toDate) return [3 /*break*/, 11];
                        if (this.mosaic.minimum_unit == null)
                            this.mosaic.helper.pleaseLogin();
                        toAmount = Number(this.getAmount(this.nday, this.nhour, this.nmin));
                        if (!(this.toAmount % this.mosaic.minimum_unit == 0 && this.toAmount > 0)) return [3 /*break*/, 9];
                        if (!(this.$data.message.length > 0)) return [3 /*break*/, 7];
                        this.$data.modal = false;
                        date = this.toDate;
                        this.getAmount_hd(this.nday, this.nhour, this.nmin);
                        amount_hd = String(this.amount_hd);
                        massage = this.$data.message;
                        send_massage = "[[[年次有給申請]]]有給休暇日：" + date + "<br>休暇期間：" + amount_hd + "<br>" + "【備考】<br>" + massage;
                        console.log(send_massage);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        nodeUrl = 'https://nem02.neluta.win:7891';
                        return [4 /*yield*/, fetch(nodeUrl + "/time-sync/network-time")];
                    case 2:
                        response = _a.sent();
                        if (!response.ok) {
                            throw new Error('NEMネットワーク時刻の取得に失敗しました。');
                        }
                        return [4 /*yield*/, response.json()];
                    case 3:
                        timeData = _a.sent();
                        networkTimestamp = timeData.sendTimeStamp;
                        // 2. 取得した時刻(networkTimestamp)を、7番目の引数としてsendMosaicsメソッドに渡す
                        return [4 /*yield*/, this.mosaic.sendMosaics(this.$data.wallet.privateKey, toAmount, send_massage, date, amount_hd, massage, networkTimestamp // ← 7番目の引数を追加！
                            )];
                    case 4:
                        // 2. 取得した時刻(networkTimestamp)を、7番目の引数としてsendMosaicsメソッドに渡す
                        _a.sent();
                        this.$router.push({ name: 'Output', params: { amount: String(toAmount), date: date, amount_hd: amount_hd, massege: massage } });
                        return [3 /*break*/, 6];
                    case 5:
                        error_1 = _a.sent();
                        console.error(error_1);
                        alert('トランザクションの作成または送信に失敗しました。');
                        return [3 /*break*/, 6];
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        alert('メッセージを入力してください');
                        _a.label = 8;
                    case 8: return [3 /*break*/, 10];
                    case 9:
                        alert('申請単位は' + this.mosaic.minimum_unit + 'UQです');
                        _a.label = 10;
                    case 10: return [3 /*break*/, 12];
                    case 11:
                        alert('有給休暇日を入力してください');
                        _a.label = 12;
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
    Top.prototype.doTmpSend = function () {
        return __awaiter(this, void 0, void 0, function () {
            var headers, access_token, uid, client, request_1, url, company_code, amount, when, toAmount, date, amount_hd, massage, send_message, request_url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.$data.message.length > 0)) return [3 /*break*/, 2];
                        console.log("in sotmpsend");
                        return [4 /*yield*/, this.mosaic.helper.loadHeaders()];
                    case 1:
                        headers = _a.sent();
                        access_token = headers["access-token"];
                        uid = headers["uid"];
                        client = headers["client"];
                        request_1 = new XMLHttpRequest();
                        url = this.mosaic.helper.path + "auth_users/uq_approval/" + this.$data.wallet.address;
                        company_code = "?&company_code=" + this.mosaic.company_code //保存されるようにする
                        ;
                        amount = "&amount=" + String(this.$data.toAmount);
                        when = "&date=" + this.toDate;
                        toAmount = this.toAmount;
                        date = this.toDate;
                        this.getAmount_hd(this.nday, this.nhour, this.nmin);
                        amount_hd = String(this.amount_hd);
                        massage = this.$data.message;
                        send_message = "&message=[[[年次有給申請]]]有給休暇日：" + date + "<br>休暇期間：" + amount_hd + "<br>" + "【備考】<br>" + massage;
                        request_url = url + company_code + amount + when + send_message;
                        console.log(request_url);
                        request_1.open('GET', request_url);
                        request_1.setRequestHeader("Content-Type", "application/json");
                        request_1.setRequestHeader("access-token", access_token);
                        request_1.setRequestHeader("uid", uid);
                        request_1.setRequestHeader("client", client);
                        request_1.onreadystatechange = function () {
                            if (request_1.readyState != 4) {
                                // リクエスト中
                                console.log('リクエスト中');
                            }
                            else if (request_1.status != 200) {
                                // 失敗
                                console.log('失敗');
                                var result = request_1.responseText;
                                alert("申請に失敗しました。" + result);
                            }
                            else {
                                // 取得成功
                                console.log('取得成功');
                                var result = request_1.responseText;
                                alert(result);
                            }
                        };
                        request_1.send(null);
                        this.closeModal();
                        return [3 /*break*/, 3];
                    case 2:
                        alert('メッセージを入力してください');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Top.prototype.test_send = function () {
        this.$data.modal = false;
        var toamount = String(this.getAmount(this.nday, this.nhour, this.nmin));
        var date = this.toDate;
        this.getAmount_hd(this.nday, this.nhour, this.nmin);
        var amount_hd = String(this.amount_hd);
        var send_massage = this.$data.message;
        this.$router.push({ name: 'Output', params: { amount: toamount, date: date, amount_hd: amount_hd, massege: send_massage } });
        console.log(send_massage + amount_hd);
    };
    Top.prototype.testSend = function () {
        //this.mosaic.sendMosaics(this.wallet.privateKey,this.toAmount,this.$data.message)
    };
    //
    //UQ時間換算
    Top.prototype.getAmount_hd = function (o_day, o_hour, o_min) {
        return __awaiter(this, void 0, void 0, function () {
            var working_hour_per_day, min, hour, day;
            return __generator(this, function (_a) {
                //8⇨day_uqに置き換える
                if (this.mosaic.working_hour_per_day == null) {
                    this.mosaic.helper.pleaseLogin();
                }
                else {
                    working_hour_per_day = this.mosaic.working_hour_per_day;
                    this.amount_hd = "";
                    min = o_min % 60;
                    o_hour = Number(Math.floor(o_min / 60) + Number(o_hour));
                    hour = o_hour % working_hour_per_day;
                    day = Number(Math.floor(o_hour / working_hour_per_day)) + Number(o_day);
                    if (day !== 0) {
                        this.amount_hd = this.amount_hd + String(day) + "日 ";
                    }
                    if (hour !== 0) {
                        this.amount_hd = this.amount_hd + String(hour) + "時間 ";
                    }
                    if (min !== 0) {
                        this.amount_hd = this.amount_hd + String(min) + "分";
                    }
                    console.log(day + "   " + hour + "   " + min);
                }
                return [2 /*return*/];
            });
        });
    };
    Top.prototype.getAmount = function (day, hour, min) {
        //8⇨day_uqに置き換える
        var working_hour_per_day = this.mosaic.working_hour_per_day;
        if (this.mosaic.working_hour_per_day == null) {
            this.mosaic.helper.pleaseLogin();
        }
        else {
            var sum_hour = Number(day * this.mosaic.working_hour_per_day) + Number(hour);
            var sum_min = Number(sum_hour * 60) + Number(min);
            var Amount = Math.floor(sum_min * 10 / 6);
            this.toAmount = Amount;
            return Amount;
        }
    };
    Top.prototype.getAccount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoading = true;
                        return [4 /*yield*/, this.$data.wallet.getAccount()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.$data.wallet.getUnconfirmed()];
                    case 2:
                        _a.sent();
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Top.prototype.tapSend = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('tapSend');
                        if (!(this.isValidation() === true)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.$data.wallet.sendNem(this.toAddr, this.toAmount, this.message)];
                    case 1:
                        result = _a.sent();
                        console.log('tapSend', result);
                        message = '送金しました';
                        if (result.message !== 'SUCCESS') {
                            message = "Error " + result.message;
                        }
                        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$toast(message);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    Top.prototype.isValidation = function () {
        this.validation = [];
        this.validation.push(this.$data.rules.senderAddrLimit(this.toAddr));
        this.validation.push(this.$data.rules.senderAddrInput(this.toAddr));
        this.validation.push(this.$data.rules.amountLimit(this.toAmount));
        this.validation.push(this.$data.rules.amountInput(this.toAmount));
        this.validation.push(this.$data.rules.messageRules(this.message));
        console.log(this.validation);
        var isError = false;
        this.validation.forEach(function (obj) {
            if (obj !== true) {
                isError = true;
            }
        });
        return !isError;
    };
    Top.prototype.setData = function (address, privateKey) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.$data.wallet.setData(address, privateKey);
                return [2 /*return*/];
            });
        });
    };
    Top = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({
            name: 'wallet',
            data: function () { return ({
                nem: new __WEBPACK_IMPORTED_MODULE_2__ts_nemWrapper__["a" /* default */](),
                mosaic: new __WEBPACK_IMPORTED_MODULE_4__ts_mosaicTransfer__["a" /* default */](),
                wallet: new __WEBPACK_IMPORTED_MODULE_3__ts_walletModel__["a" /* default */](),
                modal: false,
                qrJson: '',
                fmessage: 'father message',
                rules: {
                    senderAddrLimit: function (value) { return (value && (value.length === 46 || value.length === 40)) || '送金先アドレス(-除く)は40文字です。'; },
                    senderAddrInput: function (value) {
                        var pattern = /^[a-zA-Z0-9-]+$/;
                        return pattern.test(value) || '送金先の入力が不正です';
                    },
                    amountLimit: function (value) { return (value >= 0) || '数量を入力してください'; },
                    amountInput: function (value) {
                        var pattern = /^[0-9.]+$/;
                        return (pattern.test(value) && !isNaN(Number(value))) || '数量の入力が不正です';
                    },
                    messageRules: function (value) { return (value.length <= 1024) || 'メッセージの最大文字数が超えています。'; }
                },
            }); },
            watch: {
                'wallet.address': function (newVal, oldVal) {
                    this.$data.qrJson = this.$data.nem.getQRcodeJson('2', 2, '', newVal, 0, '');
                }
            },
            components: { ConfirmationModal: __WEBPACK_IMPORTED_MODULE_5__ConfirmationModal_vue__["a" /* default */] },
            methods: {
                myactionFunc: function () {
                },
                func: function (msg) {
                    console.log(msg);
                },
            },
            props: ['version']
        })
    ], Top);
    return Top;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (Top);


/***/ }),

/***/ 224:
/***/ (function(module, exports) {

function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 224;

/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_localforage__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_localforage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nemWrapper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper__ = __webpack_require__(28);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




var getAddress = /** @class */ (function () {
    function getAddress() {
        var _this = this;
        this.address = '';
        this.mosaic_balance = 0;
        this.publicKey = '';
        this.privateKey = '';
        /*ページ切り替え */
        this.signup_modal = false;
        this.login_page = true;
        this.waitting_page = false;
        this.top_page = false;
        this.nem = new __WEBPACK_IMPORTED_MODULE_1__nemWrapper__["a" /* default */]();
        this.helper = new __WEBPACK_IMPORTED_MODULE_3__helper__["a" /* default */]();
        // クラス生成時にローカルストレージからアカウント情報を取得
        this.load()
            .then(function (result) {
            console.log(result);
            // 無ければアカウントを作成します
            if (result === null) {
                _this.signup_modal = true;
                _this.nem.createAccount()
                    .then(function (wallet) {
                    _this.address = wallet.address;
                    _this.privateKey = wallet.privateKey;
                    _this.helper.save('SmartUQ-Wallet', _this.toAESJSON());
                }).catch(function (error) {
                    console.error(error);
                });
            }
            console.log(_this.address);
        }).catch(function (error) {
            console.error(error);
        })
            .then(function () {
            _this.checkAccount(_this.address);
        });
    }
    //アカウントが登録されているかのflagを切り替える
    getAddress.prototype.checkAccount = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var flag;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkAccountFromAPI(address)];
                    case 1:
                        flag = _a.sent();
                        this.login_page = false;
                        if (flag == 0) { //アドレスが存在しない
                            this.login_page = true;
                        }
                        else if (flag == 10) { //承認待ち
                            this.waitting_page = true;
                        }
                        else if (flag == 11) {
                            this.top_page = true;
                        }
                        else {
                            this.login_page = true;
                        }
                        console.log("flag:" + flag);
                        return [2 /*return*/];
                }
            });
        });
    };
    //APIでアカウントが登録されているか確認
    getAddress.prototype.checkAccountFromAPI = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.address != "")) return [3 /*break*/, 2];
                        url = this.helper.path + "users/user_exist/" + this.address;
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.data];
                    case 2: return [2 /*return*/, 0];
                }
            });
        });
    };
    // ローカルストレージから取得.
    getAddress.prototype.load = function () {
        return __awaiter(this, void 0, void 0, function () {
            var key, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        key = 'SmartUQ-Wallet';
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_localforage___default.a.getItem(key)];
                    case 1:
                        result = _a.sent();
                        if (result !== null) {
                            this.address = result.address;
                            this.privateKey = this.helper.Decrypt(result.privateKey);
                            this.publicKey = result.publicKey;
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    // ローカルストレージから削除.
    getAddress.prototype.remove = function () {
        return __awaiter(this, void 0, void 0, function () {
            var key, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        key = 'SmartUQ-Wallet';
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_localforage___default.a.removeItem(key)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    getAddress.prototype.toAESJSON = function () {
        return __awaiter(this, void 0, void 0, function () {
            var AESprivateKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.helper.Encrypt(this.privateKey)];
                    case 1:
                        AESprivateKey = _a.sent();
                        console.log("暗号化＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝");
                        console.log(AESprivateKey);
                        return [2 /*return*/, {
                                address: this.address,
                                privateKey: AESprivateKey,
                                publicKey: this.publicKey
                            }];
                }
            });
        });
    };
    return getAddress;
}());
/* harmony default export */ __webpack_exports__["a"] = (getAddress);


/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


// コンポーネントの設定
var MyTransaction = /** @class */ (function (_super) {
    __extends(MyTransaction, _super);
    function MyTransaction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MyTransaction = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({
            name: 'my_transaction',
            data: function () {
                return {
                    age: '',
                    address: ''
                };
            },
            methods: {
                check: function () {
                    alert('Your age is this.address');
                }
            }
        })
    ], MyTransaction);
    return MyTransaction;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (MyTransaction);


/***/ }),

/***/ 260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConfirmationModal_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ts_helper__ = __webpack_require__(28);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




// コンポーネントの設定
var Settings = /** @class */ (function (_super) {
    __extends(Settings, _super);
    function Settings() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.helper = new __WEBPACK_IMPORTED_MODULE_3__ts_helper__["a" /* default */]();
        return _this;
    }
    Settings.prototype.openModal = function () {
        this.$data.modal = true;
    };
    Settings.prototype.closeModal = function () {
        this.$data.modal = false;
    };
    Settings.prototype.logout = function () {
        this.helper.deleteLocalStrage();
    };
    Settings = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({
            name: 'settings',
            data: function () { return ({
                modal: false,
            }); },
            components: { ConfirmationModal: __WEBPACK_IMPORTED_MODULE_2__ConfirmationModal_vue__["a" /* default */] },
        })
    ], Settings);
    return Settings;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (Settings);


/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ts_nemWrapper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ts_walletModel__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConfirmationModal_vue__ = __webpack_require__(48);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};





// コンポーネントの設定
var MyAddress = /** @class */ (function (_super) {
    __extends(MyAddress, _super);
    function MyAddress() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.wallet = new __WEBPACK_IMPORTED_MODULE_3__ts_walletModel__["a" /* default */]();
        return _this;
    }
    MyAddress.prototype.openModal = function () {
        this.$data.modal = true;
    };
    MyAddress.prototype.closeModal = function () {
        this.$data.modal = false;
    };
    MyAddress.prototype.sendInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var headers, access_token, uid, client, request, url, publickey, privatekey, request_url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log("in sendinfo");
                        return [4 /*yield*/, this.wallet.helper.loadHeaders()];
                    case 1:
                        headers = _a.sent();
                        access_token = headers["access-token"];
                        uid = headers["uid"];
                        client = headers["client"];
                        request = new XMLHttpRequest();
                        url = this.wallet.helper.path + "auth_users/nem_key/" + this.wallet.address;
                        publickey = "?&publickey=" + this.wallet.publicKey;
                        privatekey = "&privatekey=" + this.wallet.privateKey;
                        request_url = url + publickey + privatekey;
                        console.log(request_url);
                        request.open('GET', request_url);
                        request.setRequestHeader("Content-Type", "application/json");
                        request.setRequestHeader("access-token", access_token);
                        request.setRequestHeader("uid", uid);
                        request.setRequestHeader("client", client);
                        request.onreadystatechange = function () {
                            if (request.readyState != 4) {
                                // リクエスト中
                                console.log('リクエスト中');
                            }
                            else if (request.status != 200) {
                                // 失敗
                                console.log('失敗');
                                var result = request.responseText;
                                alert(result);
                            }
                            else {
                                // 取得成功
                                console.log('取得成功');
                                var result = request.responseText;
                                alert(result);
                            }
                        };
                        request.send(null);
                        this.closeModal();
                        return [2 /*return*/];
                }
            });
        });
    };
    MyAddress = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({
            name: 'my_address',
            methods: {},
            data: function () { return ({
                nem: new __WEBPACK_IMPORTED_MODULE_2__ts_nemWrapper__["a" /* default */](),
                title: "あなたのアドレス",
                modal: false
            }); },
            components: { ConfirmationModal: __WEBPACK_IMPORTED_MODULE_4__ConfirmationModal_vue__["a" /* default */] },
        })
    ], MyAddress);
    return MyAddress;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (MyAddress);


/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ts_nemWrapper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ts_walletModel__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConfirmationModal_vue__ = __webpack_require__(48);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





// コンポーネントの設定
var MyWalletInfo = /** @class */ (function (_super) {
    __extends(MyWalletInfo, _super);
    function MyWalletInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.wallet = new __WEBPACK_IMPORTED_MODULE_3__ts_walletModel__["a" /* default */]();
        _this.qrSize = 200;
        return _this;
    }
    MyWalletInfo.prototype.openModalInfo = function () {
        this.$data.info_modal = true;
    };
    MyWalletInfo.prototype.openModalSingUp = function () {
        this.$data.signup_modal = true;
    };
    MyWalletInfo.prototype.closeModal = function () {
        this.$data.info_modal = false;
        this.$data.signup_modal = false;
    };
    MyWalletInfo = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({
            name: 'my_wallet_info',
            methods: {},
            data: function () { return ({
                nem: new __WEBPACK_IMPORTED_MODULE_2__ts_nemWrapper__["a" /* default */](),
                title: "あなたのアドレス",
                info_modal: false,
                signup_modal: false,
                qrJson: '',
            }); },
            components: { ConfirmationModal: __WEBPACK_IMPORTED_MODULE_4__ConfirmationModal_vue__["a" /* default */] }
        })
    ], MyWalletInfo);
    return MyWalletInfo;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (MyWalletInfo);


/***/ }),

/***/ 263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ts_nemWrapper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ts_walletModel__ = __webpack_require__(54);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




// コンポーネントの設定
var MyWalletPrivate = /** @class */ (function (_super) {
    __extends(MyWalletPrivate, _super);
    function MyWalletPrivate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.wallet = new __WEBPACK_IMPORTED_MODULE_3__ts_walletModel__["a" /* default */]();
        return _this;
    }
    MyWalletPrivate = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({
            name: 'my_wallet_private',
            methods: {},
            data: function () { return ({
                nem: new __WEBPACK_IMPORTED_MODULE_2__ts_nemWrapper__["a" /* default */](),
                title: "プライベートキー(秘密鍵)",
                description: "メモに書き留め厳重に保管して下さい。"
            }); }
        })
    ], MyWalletPrivate);
    return MyWalletPrivate;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (MyWalletPrivate);


/***/ }),

/***/ 264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ts_walletModel__ = __webpack_require__(54);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



// コンポーネントの設定
var MyWallet = /** @class */ (function (_super) {
    __extends(MyWallet, _super);
    function MyWallet() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.wallet = new __WEBPACK_IMPORTED_MODULE_2__ts_walletModel__["a" /* default */]();
        return _this;
    }
    MyWallet = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({
            name: 'history',
            methods: {},
            data: function () { return ({
                title: "history"
            }); }
        })
    ], MyWallet);
    return MyWallet;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (MyWallet);


/***/ }),

/***/ 265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ts_nemWrapper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ts_walletModel__ = __webpack_require__(54);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




// コンポーネントの設定
var MyAddress = /** @class */ (function (_super) {
    __extends(MyAddress, _super);
    function MyAddress() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.wallet = new __WEBPACK_IMPORTED_MODULE_3__ts_walletModel__["a" /* default */]();
        _this.publickey = "";
        _this.secretkey = "";
        return _this;
    }
    MyAddress.prototype.setData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var publickey, secretkey, res, res2;
            return __generator(this, function (_a) {
                publickey = this.publickey;
                secretkey = this.secretkey;
                res = confirm("公開鍵\n" + publickey + "\n" + "秘密鍵\n" + secretkey + "\n" + "の内容をインポートします。よろしいですか？");
                if (res == true) {
                    res2 = confirm("この作業は元に戻せません。よろしいですか？");
                    if (res == true) {
                        this.wallet.setData(publickey, secretkey);
                        alert("インポートしました。");
                        this.$router.push('/');
                    }
                    else {
                        alert("キャンセルしました。");
                        this.$router.push('/');
                    }
                }
                else {
                    alert("キャンセルしました。");
                    this.$router.push('/');
                }
                return [2 /*return*/];
            });
        });
    };
    MyAddress = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({
            name: 'restore_wallet',
            methods: {},
            data: function () { return ({
                nem: new __WEBPACK_IMPORTED_MODULE_2__ts_nemWrapper__["a" /* default */](),
                title: "アカウントを復元",
                description: "※復元作業は元に戻せません。ご注意ください。"
            }); }
        })
    ], MyAddress);
    return MyAddress;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (MyAddress);


/***/ }),

/***/ 266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ts_others__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ts_mosaicTransfer__ = __webpack_require__(113);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




// コンポーネントの設定
var MyPage = /** @class */ (function (_super) {
    __extends(MyPage, _super);
    function MyPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.others = new __WEBPACK_IMPORTED_MODULE_2__ts_others__["a" /* default */]();
        _this.address = _this.others.mosaicTransfer.address;
        return _this;
    }
    MyPage.prototype.updateStatus = function () {
        var _this = this;
        this.others.getUserInfofromAPI()
            .then(function (result) {
            console.log(result);
            _this.others.helper.save("User-Info", result);
            _this.others.setVar(result);
        });
    };
    MyPage = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({
            name: 'my_page',
            methods: {},
            data: function () { return ({
                user_title: "ユーザー情報",
                uq_title: "有給取得情報",
                balance_text: "取得可能な有給",
                sum_text: "合計申請時間",
                carry_over_text: "来年度繰越可能",
                expiration_text: "うち今年度で失効",
                uq: "UQ",
                recieve_text: "受取履歴",
                mosaic: new __WEBPACK_IMPORTED_MODULE_3__ts_mosaicTransfer__["a" /* default */](),
            }); }
        })
    ], MyPage);
    return MyPage;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (MyPage);


/***/ }),

/***/ 267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(28);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
//import nem from 'nem-sdk';
//import localForage from 'localforage';
//import nemWrapper from './nemWrapper';


var getAccountList = /** @class */ (function () {
    function getAccountList() {
        var _this = this;
        /*account data */
        this.address = '';
        this.accountList = [];
        this.errorMessage = '';
        this.company = "";
        this.helper = new __WEBPACK_IMPORTED_MODULE_1__helper__["a" /* default */]();
        this.loadAccountList("Account-List").then(function (result) {
            _this.vars(result);
        });
    }
    getAccountList.prototype.vars = function (result) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.company = result[0];
                this.accountList = result[1];
                return [2 /*return*/];
            });
        });
    };
    getAccountList.prototype.loadAccountList = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log("in loadAccountlist");
                        return [4 /*yield*/, this.getAccountListfromAPI()];
                    case 1:
                        data = _a.sent();
                        this.helper.save('Account-List', data);
                        //}
                        return [2 /*return*/, data];
                }
            });
        });
    };
    getAccountList.prototype.getAccountListfromAPI = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, tmp, url, headers, access_token, uid, client;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = [];
                        console.log("in loadAccountlistfromapi");
                        return [4 /*yield*/, this.helper.load('SmartUQ-Wallet')];
                    case 1:
                        tmp = _a.sent();
                        if (!(tmp && tmp.address)) return [3 /*break*/, 4];
                        this.address = tmp.address;
                        console.log(this.address);
                        url = this.helper.path + "auth_users/belong_users/" + this.address;
                        return [4 /*yield*/, this.helper.loadHeaders()];
                    case 2:
                        headers = _a.sent();
                        access_token = headers["access-token"];
                        uid = headers["uid"];
                        client = headers["client"];
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, {
                                headers: { "Content-Type": "application/json",
                                    "access-token": access_token,
                                    "uid": uid,
                                    "client": client },
                                data: {}
                            })
                                // thenで成功した場合の処理をかける
                                .then(function (response) {
                                console.log('status:', response.status); // 200
                                console.log(response.data);
                                result = response.data.data;
                                // catchでエラー時の挙動を定義する
                            }).catch(function (error) {
                                if (error.response && error.response.status == "401") {
                                    console.log("please login");
                                    _this.helper.pleaseLogin();
                                }
                            })];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, result];
                    case 4:
                        this.helper.pleaseLogin();
                        return [2 /*return*/];
                }
            });
        });
    };
    return getAccountList;
}());
/* harmony default export */ __webpack_exports__["a"] = (getAccountList);


/***/ }),

/***/ 268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ts_getAccountList__ = __webpack_require__(267);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



// コンポーネントの設定
var MyPage = /** @class */ (function (_super) {
    __extends(MyPage, _super);
    function MyPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getAccountList = new __WEBPACK_IMPORTED_MODULE_2__ts_getAccountList__["a" /* default */]();
        return _this;
    }
    MyPage = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({
            name: 'account_list',
            methods: {},
            data: function () { return ({
                title: "所属グループのアカウント一覧",
            }); }
        })
    ], MyPage);
    return MyPage;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (MyPage);


/***/ }),

/***/ 269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ts_kintaiKanri__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConfirmationModal_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Clock_vue__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_timepicker__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_timepicker_dist_VueTimepicker_css__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_timepicker_dist_VueTimepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_timepicker_dist_VueTimepicker_css__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};





// CommonJS


// コンポーネントの設定
var MyPage = /** @class */ (function (_super) {
    __extends(MyPage, _super);
    function MyPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.kintai = new __WEBPACK_IMPORTED_MODULE_2__ts_kintaiKanri__["a" /* default */]();
        _this.intime = "";
        _this.indate = "";
        _this.outtime = "";
        _this.outdate = "";
        _this.icon_in = './static/img/timecard/icon_in.png';
        _this.icon_out = './static/img/timecard/icon_out.png';
        return _this;
    }
    MyPage.prototype.mounted = function () {
        this.kintai.getStatus();
    };
    MyPage.prototype.setDate = function () {
        this.$data.date = new Date();
    };
    MyPage.prototype.openInModal = function () {
        this.kintai.setPlaceholder();
        this.$data.in_modal = true;
        this.getCurrentTime();
    };
    MyPage.prototype.openOutModal = function () {
        this.kintai.setPlaceholder();
        this.$data.out_modal = true;
        this.getCurrentTime();
    };
    MyPage.prototype.openResultModal = function () {
        this.$data.result_modal = true;
    };
    MyPage.prototype.getCurrentTime = function () {
        this.$data.in_date = this.kintai.today;
        this.$data.in_time.HH = this.kintai.HH;
        this.$data.in_time.mm = this.kintai.mm;
        this.$data.out_date = this.kintai.today;
        this.$data.out_time.HH = this.kintai.HH;
        this.$data.out_time.mm = this.kintai.mm;
    };
    MyPage.prototype.closeModal = function () {
        this.$data.in_modal = false;
        this.$data.out_modal = false;
        this.$data.forgetting_flag = false;
        this.$data.result_modal = false;
    };
    MyPage.prototype.sendIn = function () {
        return __awaiter(this, void 0, void 0, function () {
            var headers, access_token, uid, client, result, message, request_1, url, time, date, flag, request_url;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.intime = this.$data.in_time.HH + ":" + this.$data.in_time.mm;
                        this.indate = this.$data.in_date;
                        if (!(this.intime.length == 5 && this.indate.length == 10)) return [3 /*break*/, 2];
                        console.log("in sign in");
                        return [4 /*yield*/, this.kintai.helper.loadHeaders()];
                    case 1:
                        headers = _a.sent();
                        access_token = headers["access-token"];
                        uid = headers["uid"];
                        client = headers["client"];
                        result = "";
                        message = "";
                        request_1 = new XMLHttpRequest();
                        url = this.$data.kintai.helper.path + "auth_users/in/" + this.$data.kintai.address;
                        time = "?&in_time=" + this.intime;
                        date = "&date=" + this.indate;
                        flag = "&forgetting_flag=";
                        if (this.$data.forgetting_flag) {
                            flag = flag + 1;
                        }
                        else {
                            flag = flag + 0;
                        }
                        request_url = url + time + date + flag;
                        console.log(request_url);
                        request_1.open('GET', request_url);
                        request_1.setRequestHeader("Content-Type", "application/json");
                        request_1.setRequestHeader("access-token", access_token);
                        request_1.setRequestHeader("uid", uid);
                        request_1.setRequestHeader("client", client);
                        request_1.onreadystatechange = function () {
                            if (request_1.readyState != 4) {
                                // リクエスト中
                                console.log('リクエスト中');
                            }
                            else if (request_1.status != 200) {
                                // 失敗
                                console.log('失敗');
                                result = request_1.responseText;
                                message = request_1.response;
                            }
                            else {
                                // 取得成功
                                console.log('取得成功');
                                result = request_1.responseText;
                                message = request_1.response;
                                console.log(request_1);
                            }
                        };
                        request_1.send(null);
                        setTimeout(function () {
                            if (result == '{"errors":["アカウント登録もしくはログインしてください。"]}') {
                                _this.kintai.helper.deleteLocalStrage();
                            }
                            else {
                                _this.kintai.getStatusFromAPI()
                                    .then(function (result) {
                                    _this.kintai.setStatus(result, "TimeCard");
                                });
                            }
                            _this.closeModal();
                            _this.$data.result = message;
                            _this.openResultModal();
                        }, 1500);
                        return [3 /*break*/, 3];
                    case 2:
                        alert('時間を入力してください');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MyPage.prototype.checkSendOut = function () {
        return __awaiter(this, void 0, void 0, function () {
            var outdate_y, outdate_m, outdate_d, out_at_date, result;
            return __generator(this, function (_a) {
                this.outtime = this.$data.out_time.HH + ":" + this.$data.out_time.mm;
                this.outdate = this.$data.out_date;
                outdate_y = parseInt(this.outdate.slice(0, 4));
                outdate_m = parseInt(this.outdate.slice(5, 7));
                outdate_d = parseInt(this.outdate.slice(8, 10));
                out_at_date = new Date(outdate_y, outdate_m, outdate_d, this.$data.out_time.HH, this.$data.out_time.mm);
                console.log(out_at_date);
                console.log(this.kintai.in_at_date);
                if (this.kintai.in_at_date != "Invalid Date") { //update前対応
                    if (out_at_date.getTime() - this.kintai.in_at_date.getTime() > 86400000) {
                        console.log("一日超えてる");
                        result = confirm('勤務時間が24時間を超えています。よろしいですか？');
                        if (result) {
                            //はいを選んだときの処理
                            this.sendOut(this.outtime);
                        }
                        else {
                            this.closeModal();
                        }
                    }
                    else {
                        this.sendOut(this.outtime);
                    }
                }
                else {
                    this.sendOut(this.outtime);
                }
                return [2 /*return*/];
            });
        });
    };
    MyPage.prototype.sendOut = function (outtime) {
        return __awaiter(this, void 0, void 0, function () {
            var headers, access_token, uid, client, request_2, result, message, url, time, date, flag, request_url;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(outtime.length == 5 && this.outdate.length == 10)) return [3 /*break*/, 2];
                        console.log("in sendout");
                        return [4 /*yield*/, this.kintai.helper.loadHeaders()];
                    case 1:
                        headers = _a.sent();
                        access_token = headers["access-token"];
                        uid = headers["uid"];
                        client = headers["client"];
                        request_2 = new XMLHttpRequest();
                        result = "";
                        message = "エラー";
                        url = this.$data.kintai.helper.path + "auth_users/out/" + this.$data.kintai.address;
                        time = "?&out_time=" + this.outtime;
                        date = "&date=" + this.outdate;
                        flag = "&forgetting_flag=";
                        if (this.$data.forgetting_flag) {
                            flag = flag + 1;
                        }
                        else {
                            flag = flag + 0;
                        }
                        request_url = url + time + date + flag;
                        console.log(request_url);
                        request_2.open('GET', request_url);
                        request_2.setRequestHeader("Content-Type", "application/json");
                        request_2.setRequestHeader("access-token", access_token);
                        request_2.setRequestHeader("uid", uid);
                        request_2.setRequestHeader("client", client);
                        request_2.onreadystatechange = function () {
                            if (request_2.readyState != 4) {
                                // リクエスト中
                                console.log('リクエスト中');
                            }
                            else if (request_2.status != 200) {
                                // 失敗
                                console.log('失敗');
                                result = request_2.responseText;
                                message = request_2.response;
                            }
                            else {
                                // 取得成功
                                console.log('取得成功');
                                result = request_2.responseText;
                                message = request_2.response;
                                console.log(request_2);
                            }
                        };
                        request_2.send(null);
                        setTimeout(function () {
                            if (result == '{"errors":["アカウント登録もしくはログインしてください。"]}') {
                                _this.kintai.helper.deleteLocalStrage();
                            }
                            else {
                                _this.kintai.getStatusFromAPI()
                                    .then(function (result) {
                                    _this.kintai.setStatus(result, "TimeCard");
                                });
                            }
                            _this.closeModal();
                            _this.$data.result = message;
                            _this.openResultModal();
                        }, 1500);
                        return [3 /*break*/, 3];
                    case 2:
                        alert('時間を入力してください');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MyPage.prototype.updateStatus = function () {
        var _this = this;
        this.kintai.getStatusFromAPI()
            .then(function (result) {
            _this.kintai.setStatus(result, "TimeCard");
        });
    };
    MyPage = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({
            name: 'time_card',
            data: function () { return ({
                title: "タイムカード",
                in_modal: false,
                out_modal: false,
                result_modal: false,
                in_date: '',
                out_date: '',
                in_time: {
                    HH: '00',
                    mm: '00',
                },
                out_time: {
                    HH: '00',
                    mm: '00',
                },
                forgetting_flag: false,
                date: new Date,
                result: '',
                last_data: [],
            }); },
            methods: {
                changeCheckbox: function (event) {
                    if (this.$data.forgetting_flag) {
                        var today = new Date();
                        var year = today.getFullYear();
                        var month = ("0" + (today.getMonth() + 1)).slice(-2);
                        var day = ("0" + today.getDate()).slice(-2);
                        var date = year + "-" + month + "-" + day;
                        var HH = ('0' + today.getHours()).slice(-2);
                        var mm = ('0' + today.getMinutes()).slice(-2);
                        this.$data.in_date = date;
                        this.$data.in_time.HH = HH;
                        this.$data.in_time.mm = mm;
                        this.$data.out_date = date;
                        this.$data.out_time.HH = HH;
                        this.$data.out_time.mm = mm;
                    }
                },
            },
            watch: {
                date: function (val) {
                    //this.$data.out_time.mm = ('0' + val.getSeconds()).slice(-2)
                }
            },
            components: { VueTimepicker: __WEBPACK_IMPORTED_MODULE_5_vue2_timepicker___default.a, ConfirmationModal: __WEBPACK_IMPORTED_MODULE_3__ConfirmationModal_vue__["a" /* default */], Clock: __WEBPACK_IMPORTED_MODULE_4__Clock_vue__["a" /* default */] },
        })
    ], MyPage);
    return MyPage;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (MyPage);


/***/ }),

/***/ 270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var zeroPadding = function zeroPadding(num, digit) {
  return (Array(digit).join("0") + num).slice(-digit);
};
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["location", "diff"], // Timezone
  data: function data() {
    return {
      date: new Date()
    };
  },

  computed: {
    year: function year() {
      return this.date.getFullYear();
    },
    month: function month() {
      return zeroPadding(this.date.getMonth() + 1, 2);
    },
    day: function day() {
      return zeroPadding(this.date.getDate(), 2);
    },
    dayOfWeek: function dayOfWeek() {
      var day_of_week = this.date.getDay();
      var day_of_week_str = ["日", "月", "火", "水", "木", "金", "土"][day_of_week];
      return day_of_week_str;
    },
    hours: function hours() {
      return zeroPadding(this.date.getHours(), 2);
    },
    minutes: function minutes() {
      return zeroPadding(this.date.getMinutes(), 2);
    },
    seconds: function seconds() {
      return zeroPadding(this.date.getSeconds(), 2);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.setDate();
    setInterval(function () {
      return _this.setDate();
    }, 1000);
  },

  methods: {
    setDate: function setDate() {
      this.date = new Date();
      this.date.setHours(this.date.getHours() + this.diff); // Timezone
    }
  }
});

/***/ }),

/***/ 271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ts_helper__ = __webpack_require__(28);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



// コンポーネントの設定
var TimeCardHistroy = /** @class */ (function (_super) {
    __extends(TimeCardHistroy, _super);
    function TimeCardHistroy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.helper = new __WEBPACK_IMPORTED_MODULE_2__ts_helper__["a" /* default */]();
        return _this;
    }
    TimeCardHistroy.prototype.mounted = function () {
        this.$data.month = this.$data.date.getMonth() + 1;
        this.$data.year = this.$data.date.getFullYear();
        this.getDataFromAPI();
    };
    TimeCardHistroy.prototype.getNextMonth = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.$data.month++;
                if (this.$data.month > 12) {
                    this.$data.month = 1;
                    this.$data.year++;
                }
                this.getDataFromAPI();
                return [2 /*return*/];
            });
        });
    };
    TimeCardHistroy.prototype.getLastMonth = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.$data.month -= 1;
                if (this.$data.month < 1) {
                    this.$data.month = 12;
                    this.$data.year -= 1;
                }
                this.getDataFromAPI();
                return [2 /*return*/];
            });
        });
    };
    TimeCardHistroy.prototype.getDataFromAPI = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tmp, result, address, headers, access_token, uid, client, url, year, month, request_url, request_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.helper.load('SmartUQ-Wallet')];
                    case 1:
                        tmp = _a.sent();
                        if (!(tmp && tmp.address)) return [3 /*break*/, 4];
                        address = tmp.address;
                        return [4 /*yield*/, this.helper.loadHeaders()];
                    case 2:
                        headers = _a.sent();
                        access_token = headers["access-token"];
                        uid = headers["uid"];
                        client = headers["client"];
                        url = this.helper.path + "auth_users/timecard_history/" + address;
                        year = "?year=" + this.$data.year.toString();
                        month = "&month=" + this.$data.month.toString();
                        request_url = url + year + month;
                        console.log(request_url);
                        return [4 /*yield*/, new XMLHttpRequest()];
                    case 3:
                        request_1 = _a.sent();
                        request_1.open('GET', request_url);
                        request_1.setRequestHeader("Content-Type", "application/json");
                        request_1.setRequestHeader("access-token", access_token);
                        request_1.setRequestHeader("uid", uid);
                        request_1.setRequestHeader("client", client);
                        request_1.onreadystatechange = function () {
                            if (request_1.readyState != 4) {
                                // リクエスト中
                                console.log('リクエスト中');
                            }
                            else if (request_1.status != 200) {
                                // 失敗
                                console.log('失敗');
                                result = request_1.responseText;
                            }
                            else {
                                // 取得成功
                                console.log('取得成功');
                                result = request_1.responseText;
                            }
                        };
                        request_1.send(null);
                        setTimeout(function () {
                            console.log(result);
                            _this.setData(JSON.parse(result));
                        }, 1500);
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TimeCardHistroy.prototype.setData = function (result) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.$data.time_card_list = result.data;
                return [2 /*return*/];
            });
        });
    };
    TimeCardHistroy = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({
            name: 'time_card_history',
            data: function () { return ({
                time_card_list: [],
                date: new Date(),
                year: 2020,
                month: 1,
            }); },
        })
    ], TimeCardHistroy);
    return TimeCardHistroy;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (TimeCardHistroy);


/***/ }),

/***/ 272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ts_helper__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ts_getAddress__ = __webpack_require__(258);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




var Register = /** @class */ (function (_super) {
    __extends(Register, _super);
    function Register() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isLoading = false;
        _this.account_name = '';
        _this.email = '';
        _this.company_code = '';
        _this.hire_year = 2018;
        _this.hire_month = 4;
        _this.hire_day = 1;
        _this.password = '';
        _this.background_img = './static/img/background.png';
        _this.address = '';
        _this.private_key = '';
        _this.public_key = '';
        _this.password_confirmation = '';
        _this.get = new __WEBPACK_IMPORTED_MODULE_3__ts_getAddress__["a" /* default */]();
        return _this;
    }
    Register.prototype.mounted = function () { };
    Register.prototype.signupSend = function () {
        return __awaiter(this, void 0, void 0, function () {
            var request_1, url, account_name, email, company_code, hire_year, hire_month, hire_day, public_key, private_key, password, request_url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.$route.params.public_key || !this.$route.params.address || !this.$route.params.private_key) {
                            this.address = this.get.address;
                            this.private_key = this.get.privateKey;
                            this.public_key = this.get.publicKey;
                            console.log(this.address);
                            console.log(this.address);
                            console.log(this.private_key);
                            console.log(this.public_key);
                        }
                        else {
                            this.address = this.$route.params.address;
                            this.private_key = this.$route.params.private_key;
                            this.public_key = this.$route.params.public_key;
                        }
                        if (!(this.account_name.length != 0)) return [3 /*break*/, 8];
                        if (!(this.email.length != 0)) return [3 /*break*/, 6];
                        if (!this.checkDate(this.hire_year, this.hire_month, this.hire_day)) return [3 /*break*/, 4];
                        if (!(this.password == this.password_confirmation && this.password.length >= 6)) return [3 /*break*/, 2];
                        return [4 /*yield*/, new XMLHttpRequest()];
                    case 1:
                        request_1 = _a.sent();
                        url = this.$data.helper.path + "users/sign_up/" + this.address;
                        account_name = "?account_name=" + this.account_name;
                        email = "&email=" + this.email;
                        company_code = "&company_code=" + this.company_code;
                        hire_year = "&hire_year=" + this.hire_year;
                        hire_month = "&hire_month=" + this.hire_month;
                        hire_day = "&hire_day=" + this.hire_day;
                        public_key = "&public_key=" + this.public_key;
                        private_key = "&private_key=" + this.private_key;
                        password = "&password=" + this.password;
                        request_url = url + account_name + email + company_code + hire_year + hire_month + hire_day + public_key + private_key + password;
                        console.log(request_url);
                        request_1.open('GET', request_url);
                        request_1.onreadystatechange = function () {
                            if (request_1.readyState != 4) {
                                // リクエスト中
                                console.log('リクエスト中');
                            }
                            else if (request_1.status != 200) {
                                // 失敗
                                console.log('失敗');
                                var result = request_1.responseText;
                                alert("登録に失敗しました。" + result);
                            }
                            else {
                                // 取得成功
                                console.log('取得成功');
                                var result = request_1.responseText;
                                alert(result);
                                location.reload();
                            }
                        };
                        request_1.send(null);
                        console.log('tapsignupSend' + account_name + email);
                        this.$data.signup_modal = false;
                        return [3 /*break*/, 3];
                    case 2:
                        alert("パスワードが不正です。");
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        alert("入社日が不正です。");
                        _a.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        alert("メールアドレスを入力してください。");
                        _a.label = 7;
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        alert("アカウント名を入力してください。");
                        _a.label = 9;
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    Register.prototype.checkDate = function (y, m, d) {
        var today = new Date();
        var hire_date_last_day = new Date(this.hire_year, this.hire_month - 1, 0);
        var hire_date = new Date(this.hire_year, this.hire_month - 1, this.hire_day, 0, 0, 0, 0);
        console.log(hire_date);
        if (m < 1 || m > 12) {
            return false;
        }
        else if (hire_date_last_day.getDate() < d || d < 0) {
            return false;
        }
        else if (hire_date > today) {
            return false;
        }
        return true;
    };
    Register = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({
            name: 'register',
            data: function () { return ({
                title: "アカウント登録",
                helper: new __WEBPACK_IMPORTED_MODULE_2__ts_helper__["a" /* default */](),
            }); },
            props: ['version'],
        })
    ], Register);
    return Register;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (Register);


/***/ }),

/***/ 273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ts_nemWrapper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ts_walletModel__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ts_mosaicTransfer__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConfirmationModal_vue__ = __webpack_require__(48);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};






var ReturnUq = /** @class */ (function (_super) {
    __extends(ReturnUq, _super);
    function ReturnUq() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isLoading = false;
        _this.mosaic = new __WEBPACK_IMPORTED_MODULE_4__ts_mosaicTransfer__["a" /* default */]();
        _this.toAmount = 0;
        _this.day = "";
        _this.hour = "";
        _this.min = "";
        _this.nday = 0;
        _this.nhour = 0;
        _this.nmin = 0;
        _this.amount_hd = "";
        _this.toAddr = '';
        _this.toMyAddr = "";
        _this.message = '';
        _this.validation = [];
        _this.background_img = './static/img/background.png';
        return _this;
    }
    ReturnUq.prototype.mounted = function () { };
    //modal
    ReturnUq.prototype.openModal = function () {
        this.$data.modal = true;
        this.nday = Number(this.day);
        this.nhour = Number(this.hour);
        this.nmin = Number(this.min);
        this.getAmount_hd(this.nday, this.nhour, this.nmin);
        this.getAmount(this.nday, this.nhour, this.nmin);
    };
    ReturnUq.prototype.closeModal = function () {
        this.$data.modal = false;
        this.$data.info_modal = false;
    };
    ReturnUq.prototype.doSend = function () {
        return __awaiter(this, void 0, void 0, function () {
            var toAmount, massage, nodeUrl, response, timeData, networkTimestamp, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        toAmount = Number(this.getAmount(this.nday, this.nhour, this.nmin));
                        if (!(this.toAmount > 0)) return [3 /*break*/, 7];
                        this.$data.modal = false;
                        massage = '[[[返却]]]';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        nodeUrl = 'https://nem02.neluta.win:7891';
                        return [4 /*yield*/, fetch(nodeUrl + "/time-sync/network-time")];
                    case 2:
                        response = _a.sent();
                        if (!response.ok) {
                            throw new Error('NEMネットワーク時刻の取得に失敗しました。');
                        }
                        return [4 /*yield*/, response.json()];
                    case 3:
                        timeData = _a.sent();
                        networkTimestamp = timeData.sendTimeStamp;
                        // 3. sendMosaicsを呼び出す際に、7番目の引数として取得した時刻(networkTimestamp)を渡す
                        return [4 /*yield*/, this.mosaic.sendMosaics(this.$data.wallet.privateKey, toAmount, massage, '', // date
                            '', // amount_hd
                            '', // post_message
                            networkTimestamp // ← これが7番目の引数！
                            )];
                    case 4:
                        // 3. sendMosaicsを呼び出す際に、7番目の引数として取得した時刻(networkTimestamp)を渡す
                        _a.sent();
                        // 成功した場合の処理をここに追加できます（例：アラート、ページ遷移など）
                        alert('UQを返却しました。反映までしばらくお待ちください。');
                        return [3 /*break*/, 6];
                    case 5:
                        error_1 = _a.sent();
                        console.error('返却処理でエラーが発生しました:', error_1);
                        alert('返却処理に失敗しました。');
                        return [3 /*break*/, 6];
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        alert('UQの値が不正です');
                        _a.label = 8;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    ReturnUq.prototype.getAmount = function (day, hour, min) {
        //8⇨day_uqに置き換える
        var working_hour_per_day = this.mosaic.working_hour_per_day;
        if (this.mosaic.working_hour_per_day == null) {
            this.mosaic.helper.pleaseLogin();
        }
        else {
            var sum_hour = Number(day * this.mosaic.working_hour_per_day) + Number(hour);
            var sum_min = Number(sum_hour * 60) + Number(min);
            var Amount = Math.floor(sum_min * 10 / 6);
            this.toAmount = Amount;
            return Amount;
        }
    };
    //UQ時間換算
    ReturnUq.prototype.getAmount_hd = function (o_day, o_hour, o_min) {
        return __awaiter(this, void 0, void 0, function () {
            var working_hour_per_day, min, hour, day;
            return __generator(this, function (_a) {
                //8⇨day_uqに置き換える
                if (this.mosaic.working_hour_per_day == null) {
                    this.mosaic.helper.pleaseLogin();
                }
                else {
                    working_hour_per_day = this.mosaic.working_hour_per_day;
                    this.amount_hd = "";
                    min = o_min % 60;
                    o_hour = Number(Math.floor(o_min / 60) + Number(o_hour));
                    hour = o_hour % working_hour_per_day;
                    day = Number(Math.floor(o_hour / working_hour_per_day)) + Number(o_day);
                    if (day !== 0) {
                        this.amount_hd = this.amount_hd + String(day) + "日 ";
                        if (hour !== 0) {
                            this.amount_hd = this.amount_hd + "と " + String(hour) + "時間 ";
                        }
                        else if (min !== 0) {
                            this.amount_hd = this.amount_hd + "と";
                        }
                    }
                    else {
                        if (hour !== 0) {
                            this.amount_hd = this.amount_hd + String(hour) + "時間 ";
                        }
                    }
                    if (min !== 0) {
                        this.amount_hd = this.amount_hd + String(min) + "分";
                    }
                    console.log(day + "   " + hour + "   " + min);
                }
                return [2 /*return*/];
            });
        });
    };
    ReturnUq.prototype.getAccount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoading = true;
                        return [4 /*yield*/, this.$data.wallet.getAccount()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.$data.wallet.getUnconfirmed()];
                    case 2:
                        _a.sent();
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ReturnUq.prototype.tapSend = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('tapSend');
                        if (!(this.isValidation() === true)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.$data.wallet.sendNem(this.toAddr, this.toAmount, this.message)];
                    case 1:
                        result = _a.sent();
                        console.log('tapSend', result);
                        message = '送金しました';
                        if (result.message !== 'SUCCESS') {
                            message = "Error " + result.message;
                        }
                        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$toast(message);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ReturnUq.prototype.isValidation = function () {
        this.validation = [];
        this.validation.push(this.$data.rules.senderAddrLimit(this.toAddr));
        this.validation.push(this.$data.rules.senderAddrInput(this.toAddr));
        this.validation.push(this.$data.rules.amountLimit(this.toAmount));
        this.validation.push(this.$data.rules.amountInput(this.toAmount));
        this.validation.push(this.$data.rules.messageRules(this.message));
        console.log(this.validation);
        var isError = false;
        this.validation.forEach(function (obj) {
            if (obj !== true) {
                isError = true;
            }
        });
        return !isError;
    };
    ReturnUq.prototype.setData = function (address, privateKey) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.$data.wallet.setData(address, privateKey);
                return [2 /*return*/];
            });
        });
    };
    ReturnUq = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_class_component___default()({
            name: 'return',
            data: function () { return ({
                nem: new __WEBPACK_IMPORTED_MODULE_2__ts_nemWrapper__["a" /* default */](),
                mosaic: new __WEBPACK_IMPORTED_MODULE_4__ts_mosaicTransfer__["a" /* default */](),
                wallet: new __WEBPACK_IMPORTED_MODULE_3__ts_walletModel__["a" /* default */](),
                modal: false,
                qrJson: '',
                fmessage: 'father message',
                rules: {
                    senderAddrLimit: function (value) { return (value && (value.length === 46 || value.length === 40)) || '送金先アドレス(-除く)は40文字です。'; },
                    senderAddrInput: function (value) {
                        var pattern = /^[a-zA-Z0-9-]+$/;
                        return pattern.test(value) || '送金先の入力が不正です';
                    },
                    amountLimit: function (value) { return (value >= 0) || '数量を入力してください'; },
                    amountInput: function (value) {
                        var pattern = /^[0-9.]+$/;
                        return (pattern.test(value) && !isNaN(Number(value))) || '数量の入力が不正です';
                    },
                    messageRules: function (value) { return (value.length <= 1024) || 'メッセージの最大文字数が超えています。'; }
                },
            }); },
            watch: {
                'wallet.address': function (newVal, oldVal) {
                    this.$data.qrJson = this.$data.nem.getQRcodeJson('2', 2, '', newVal, 0, '');
                }
            },
            components: { ConfirmationModal: __WEBPACK_IMPORTED_MODULE_5__ConfirmationModal_vue__["a" /* default */] },
            methods: {
                myactionFunc: function () {
                },
                func: function (msg) {
                    console.log(msg);
                },
            },
            props: ['version']
        })
    ], ReturnUq);
    return ReturnUq;
}(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]));
/* harmony default export */ __webpack_exports__["a"] = (ReturnUq);


/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_util_colors__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_util_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify_es5_util_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_toast_lib_toast_css__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_toast_lib_toast_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_toast_lib_toast_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_toast__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_qriously__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_qriously___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_qriously__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_qrcode_reader__ = __webpack_require__(693);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a, {
    theme: {
        original: __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_util_colors___default.a.purple.base,
        theme: '#FFDEEA',
        background: '#FFF6EA',
        view: '#ffa07a',
        select: '#FF7F78',
        button: '#5FACEF'
    },
    options: {
        themeVariations: ['original', 'secondary']
    }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue2_toast___default.a, {
    defaultType: 'bottom',
    duration: 3000,
    wordWrap: true,
    width: '280px'
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_qriously___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_qrcode_reader__["default"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */] }
});


/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(152);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41e2f165_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(281);
function injectStyle (ssrContext) {
  __webpack_require__(278)
  __webpack_require__(280)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-41e2f165"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41e2f165_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 278:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 28:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_localforage__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_localforage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_crypto_js__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_crypto_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_crypto_js__);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
//import nem from 'nem-sdk';

//import axios from 'axios';

var helper = /** @class */ (function () {
    function helper() {
        this.key = '';
        //path:string = 'http://localhost:3000/api/v1/'
        this.path = 'https://mgt.smart-uq.com/api/v1/';
    }
    helper.prototype.Encrypt = function (word) {
        return __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.AES.encrypt(word, this.key).toString();
    };
    helper.prototype.Decrypt = function (word) {
        return __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.AES.decrypt(word, this.key).toString(__WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.enc.Utf8);
    };
    helper.prototype.save = function (key, value) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_localforage___default.a.setItem(key, value)];
                    case 1:
                        result = _a.sent();
                        console.log(result);
                        console.log("save...");
                        return [2 /*return*/];
                }
            });
        });
    };
    helper.prototype.load = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_localforage___default.a.getItem(key)];
                    case 1:
                        result = _a.sent();
                        console.log("loading..." + key);
                        console.log("result");
                        console.log(result);
                        return [2 /*return*/, result];
                }
            });
        });
    };
    helper.prototype.loadHeaders = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_localforage___default.a.getItem("Headers")];
                    case 1:
                        result = _a.sent();
                        console.log("loading... headers");
                        console.log("result");
                        console.log(result);
                        if (result == null || result["access-token"] == null) {
                            console.log("=========please login=========");
                            this.pleaseLogin();
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    helper.prototype.saveData = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var key, d, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        key = 'SmartUQ-Wallet';
                        return [4 /*yield*/, this.toAESJSON(data.address, data.private_key, data.public_key)];
                    case 1:
                        d = _a.sent();
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_localforage___default.a.setItem(key, d)];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    helper.prototype.pleaseLogin = function () {
        console.log("=========please login!=========");
        this.deleteLocalStrage();
    };
    helper.prototype.deleteLocalStrage = function () {
        __WEBPACK_IMPORTED_MODULE_0_localforage___default.a.clear();
        this.reload();
    };
    helper.prototype.reload = function () {
        window.location.href = '/';
    };
    helper.prototype.toAESJSON = function (address, privateKey, publicKey) {
        var AESprivateKey = this.Encrypt(privateKey);
        console.log("暗号化＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝");
        console.log(AESprivateKey);
        return {
            address: address,
            privateKey: AESprivateKey,
            publicKey: publicKey
        };
    };
    helper.prototype.saveInitialData = function (result) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = JSON.parse(result);
                        console.log(result);
                        console.log(result["user_info"][0]);
                        console.log(result["company_info"][0]);
                        console.log(result["account_list"]);
                        return [4 /*yield*/, this.save("User-Info", result["user_info"][0])];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.save("Company-Info", result["company_info"][0])];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.save("Account-List", result["account_list"])];
                    case 3:
                        _a.sent();
                        location.reload();
                        return [2 /*return*/];
                }
            });
        });
    };
    return helper;
}());
/* harmony default export */ __webpack_exports__["a"] = (helper);


/***/ }),

/***/ 280:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',[_c('header',{style:({ backgroundImage: 'url(' + _vm.background_img1 + ')' })},[_c('img',{attrs:{"src":_vm.SmartUQ_logo}})])]),_vm._v(" "),_c('main',[_c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1),_vm._v(" "),_c('div',{attrs:{"id":"footer"}},[_c('router-link',{attrs:{"to":{ name: 'History' }}},[_c('img',{attrs:{"src":_vm.footer_rireki}})]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'Hello', params: { userId: 123 } }}},[_c('img',{attrs:{"src":_vm.footer_sinsei}})]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'TimeCard', params: { userId: 123 } }}},[_c('img',{attrs:{"src":_vm.footer_kintai}})]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'Settings', params: { userId: 123 } }}},[_c('img',{attrs:{"src":_vm.footer_settei}})])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello_vue__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_Output_vue__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_details_MyTransaction_vue__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_Settings_vue__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_details_MyAddress_vue__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_details_MyWalletInfo_vue__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_details_MyWalletPrivate_vue__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_History_vue__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pages_details_RestoreWallet_vue__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_pages_details_MyPage_vue__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pages_details_AccountList_vue__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_pages_TimeCard_vue__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_pages_details_TimeCardHistory_vue__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_pages_details_Register_vue__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_pages_details_ReturnUq_vue__ = __webpack_require__(685);

















//import TimeCardForgetting from '@/components/pages/details/TimeCardForgetting.vue'
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [
        { path: '/', name: 'Hello', component: __WEBPACK_IMPORTED_MODULE_2__components_Hello_vue__["a" /* default */] },
        { path: '/outputs', name: 'Output', component: __WEBPACK_IMPORTED_MODULE_3__components_pages_Output_vue__["a" /* default */] },
        { path: '/pages/details/my_transaction', name: 'MyTransaction', component: __WEBPACK_IMPORTED_MODULE_4__components_pages_details_MyTransaction_vue__["a" /* default */] },
        { path: '/settings', name: 'Settings', component: __WEBPACK_IMPORTED_MODULE_5__components_pages_Settings_vue__["a" /* default */] },
        { path: '/pages/details/my_address', name: 'MyAddress', component: __WEBPACK_IMPORTED_MODULE_6__components_pages_details_MyAddress_vue__["a" /* default */] },
        { path: '/pages/details/my_wallet_info', name: 'MyWalletInfo', component: __WEBPACK_IMPORTED_MODULE_7__components_pages_details_MyWalletInfo_vue__["a" /* default */] },
        { path: '/pages/details/my_wallet_private', name: 'MyWalletPrivate', component: __WEBPACK_IMPORTED_MODULE_8__components_pages_details_MyWalletPrivate_vue__["a" /* default */] },
        { path: '/history', name: 'History', component: __WEBPACK_IMPORTED_MODULE_9__components_pages_History_vue__["a" /* default */] },
        { path: '/pages/details/restore_wallet', name: 'RestoreWallet', component: __WEBPACK_IMPORTED_MODULE_10__components_pages_details_RestoreWallet_vue__["a" /* default */] },
        { path: '/pages/details/my_page', name: 'MyPage', component: __WEBPACK_IMPORTED_MODULE_11__components_pages_details_MyPage_vue__["a" /* default */] },
        { path: '/pages/details/account_list', name: 'AccountList', component: __WEBPACK_IMPORTED_MODULE_12__components_pages_details_AccountList_vue__["a" /* default */] },
        { path: '/pages/time_card', name: 'TimeCard', component: __WEBPACK_IMPORTED_MODULE_13__components_pages_TimeCard_vue__["a" /* default */] },
        { path: '/pages/time_card/history', name: 'TimeCardHistory', component: __WEBPACK_IMPORTED_MODULE_14__components_pages_details_TimeCardHistory_vue__["a" /* default */] },
        { path: '/pages/details/register', name: 'Register', component: __WEBPACK_IMPORTED_MODULE_15__components_pages_details_Register_vue__["a" /* default */] },
        { path: '/pages/details/return_uq', name: 'ReturnUq', component: __WEBPACK_IMPORTED_MODULE_16__components_pages_details_ReturnUq_vue__["a" /* default */] },
    ]
}));


/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__ = __webpack_require__(153);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2093ebc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__(638);
function injectStyle (ssrContext) {
  __webpack_require__(285)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2093ebc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 285:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wallet_vue__ = __webpack_require__(154);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64b9de04_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wallet_vue__ = __webpack_require__(637);
function injectStyle (ssrContext) {
  __webpack_require__(287)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64b9de04"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wallet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64b9de04_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wallet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 287:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Waitting_vue__ = __webpack_require__(155);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bf94c04_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Waitting_vue__ = __webpack_require__(290);
function injectStyle (ssrContext) {
  __webpack_require__(289)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5bf94c04"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Waitting_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bf94c04_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Waitting_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 289:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"waitting",attrs:{"id":"waitting"}},[_c('v-container',{staticClass:"v-main paTop0",style:({ backgroundImage: 'url(' + _vm.background_img + ')' })},[_c('v-card-actions',{staticClass:"padding0"},[_c('v-card-title'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('p',{staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(_vm.$props.version))])],1)],1),_vm._v(" "),_c('v-app',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card',[_c('p',[_vm._v("申請中です")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(156);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43d2b360_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(400);
function injectStyle (ssrContext) {
  __webpack_require__(292)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43d2b360"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43d2b360_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 292:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 293:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal","appear":""}},[_c('div',{staticClass:"modal modal-overlay",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.$emit('close')}}},[_c('div',{staticClass:"modal-window"},[_c('div',{staticClass:"modal-content"},[_vm._t("default")],2),_vm._v(" "),_c('footer',{staticClass:"modal-footer"},[_vm._t("footer",[_c('button',{on:{"click":function($event){_vm.$emit('close')}}},[_vm._v("Close")])])],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 298:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 30:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nem_sdk__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_nem_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_encoding_japanese__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_encoding_japanese___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_encoding_japanese__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper__ = __webpack_require__(28);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




var nemWrapper = /** @class */ (function () {
    function nemWrapper() {
        this.endpoint = '';
        this.host = '';
        this.port = '';
        this.net = '';
        this.helper = new __WEBPACK_IMPORTED_MODULE_3__helper__["a" /* default */]();
        //タイムスタンプ解析
        this.dispTimeStamp = function (timeStamp) {
            var NEM_EPOCH = Date.UTC(2015, 2, 29, 0, 6, 25, 0);
            var d = new Date(timeStamp * 1000 + NEM_EPOCH);
            var strDate = d.getFullYear()
                + "年" + (d.getMonth() + 1)
                + '月' + d.getDate()
                + '日' + d.getHours()
                + ':' + d.getMinutes();
            return strDate;
        };
        //UQを時間に変換
        this.amount_hd = function (uqcoin) {
            var uq_x = uqcoin / 800;
            var uq_fract_d = uq_x * 10 % 10 / 10;
            var day = String(uq_x).split(".")[0];
            var hours = String(uq_fract_d * 800 / 100).split(".")[0];
            var uq_fract_m = Number(uq_fract_d * 800 / 100) * 10 % 10 / 10;
            var uq_fract_m2 = String(uq_fract_m * 100).split(".")[0];
            var minutes = String(Number(uq_fract_m2) / 100 * 60).split(".")[0];
            var amount_hd = "";
            if (day !== "0") {
                amount_hd = amount_hd + day + "日 ";
            }
            if (hours !== "0") {
                amount_hd = amount_hd + hours + "時間 ";
            }
            if (minutes !== "0") {
                amount_hd = amount_hd + minutes + "分";
            }
            if (amount_hd === "") {
                amount_hd = "0分";
            }
            return amount_hd;
        };
        // NIS設定.
        this.host = 'https://nem02.neluta.win';
        this.port = '7891';
        //this.host = 'http://go.nem.ninja'
        //this.port = 'hugealice3'
        this.net = __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.model.network.data.mainnet.id;
        this.endpoint = __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.model.objects.create("endpoint")(this.host, this.port);
    }
    // NISの状態確認.
    nemWrapper.prototype.isNIS = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.com.requests.endpoint.heartbeat(this.endpoint)];
                    case 1:
                        result = _a.sent();
                        if (result.message === 'ok') {
                            return [2 /*return*/, true];
                        }
                        else {
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    // アカウント作成.
    nemWrapper.prototype.createAccount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var walletName, password, wallet, common, account, result;
            return __generator(this, function (_a) {
                walletName = "wallet";
                password = "wallet";
                wallet = __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.model.wallet.createPRNG(walletName, password, this.net);
                common = __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.model.objects.create("common")(password, "");
                account = wallet.accounts[0];
                __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.crypto.helpers.passwordToPrivatekey(common, account, account.algo);
                result = {
                    address: account.address,
                    privateKey: common.privateKey
                };
                console.log("アドレス生成:" + account.address);
                return [2 /*return*/, result];
            });
        });
    };
    // アカウント情報取得.
    nemWrapper.prototype.getAccount = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.com.requests.account.data(this.endpoint, address)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    nemWrapper.prototype.getAccountMo = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log("mosaics.owned");
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.com.requests.account.mosaics.owned(this.endpoint, address)];
                    case 1:
                        result = _a.sent();
                        console.log("mosaics.mosaicname");
                        console.log("mosaics.quantity");
                        result.data.forEach(function (data) {
                            console.log(data.mosaicId.name);
                            console.log(data.quantity);
                        });
                        return [2 /*return*/, result];
                }
            });
        });
    };
    nemWrapper.prototype.getUnconfirmed = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.com.requests.account.transactions.unconfirmed(this.endpoint, address)];
                    case 1:
                        result = _a.sent();
                        console.log(result);
                        return [2 /*return*/, result];
                }
            });
        });
    };
    // 送金（NEM）
    nemWrapper.prototype.sendNem = function (address, privateKey, amount, message) {
        return __awaiter(this, void 0, void 0, function () {
            var common, transferTransaction, transactionEntity, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        common = __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.model.objects.create('common')('', privateKey);
                        transferTransaction = __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.model.objects.create('transferTransaction')(address, amount, message);
                        transactionEntity = __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.model.transactions.prepare('transferTransaction')(common, transferTransaction, this.net);
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.model.transactions.send(common, transactionEntity, this.endpoint)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    // 送金（Mosaic）
    nemWrapper.prototype.sendMosaics = function (address, privateKey, mosaics, message, networkTimestamp) {
        return __awaiter(this, void 0, void 0, function () {
            var common, transferTransaction, mosaicDefinitionMetaDataPair, transactionEntity, timeStamp, deadline, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        common = __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.model.objects.create('common')('', privateKey);
                        transferTransaction = __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.model.objects.create('transferTransaction')(address, 1, message);
                        return [4 /*yield*/, this.getMosaicDefinitionMetaDataPair(this.endpoint, mosaics)];
                    case 1:
                        mosaicDefinitionMetaDataPair = _a.sent();
                        mosaics.forEach(function (mosaic) {
                            var fullMosaicName = mosaic.namespace + ':' + mosaic.name;
                            if ((mosaicDefinitionMetaDataPair[fullMosaicName].mosaicDefinition.id.namespaceId === mosaic.namespace) &&
                                (mosaicDefinitionMetaDataPair[fullMosaicName].mosaicDefinition.id.name === mosaic.name)) {
                                var divisibility_1 = 0;
                                mosaicDefinitionMetaDataPair[fullMosaicName].mosaicDefinition.properties.forEach(function (prop) {
                                    if (prop.name === 'divisibility') {
                                        divisibility_1 = prop.value;
                                    }
                                });
                                var quantity = mosaic.amount * Math.pow(10, divisibility_1);
                                var mosaicAttachment = __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.model.objects.create('mosaicAttachment')(mosaic.namespace, mosaic.name, quantity);
                                transferTransaction.mosaics.push(mosaicAttachment);
                            }
                        });
                        transactionEntity = __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.model.transactions.prepare('mosaicTransferTransaction')(common, transferTransaction, mosaicDefinitionMetaDataPair, this.net);
                        timeStamp = Math.floor(networkTimestamp / 1000);
                        deadline = timeStamp + 3600;
                        // 3. prepare後に、作成されたエンティティの間違ったタイムスタンプを、正しい値で「上書き」する
                        transactionEntity.timeStamp = timeStamp;
                        transactionEntity.deadline = deadline;
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.model.transactions.send(common, transactionEntity, this.endpoint)];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    // モザイク定義取得.
    nemWrapper.prototype.getMosaicDefinitionMetaDataPair = function (endpoint, mosaics) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var mosaicDefinitionMetaDataPair = __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.model.objects.get('mosaicDefinitionMetaDataPair');
                        var mosaicCount = 0;
                        mosaics.forEach(function (mosaic) {
                            var mosaicAttachment = __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.model.objects.create('mosaicAttachment')(mosaic.namespace, mosaic.name, mosaic.amount);
                            var result = __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.com.requests.namespace.mosaicDefinitions(endpoint, mosaicAttachment.mosaicId.namespaceId)
                                .then(function (result) {
                                mosaicCount = mosaicCount + 1;
                                var neededDefinition = __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.utils.helpers.searchMosaicDefinitionArray(result.data, [mosaic.name]);
                                var fullMosaicName = __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.utils.format.mosaicIdToName(mosaicAttachment.mosaicId);
                                if (undefined === neededDefinition[fullMosaicName]) {
                                    console.error('Mosaic not found !');
                                    return;
                                }
                                mosaicDefinitionMetaDataPair[fullMosaicName] = {};
                                mosaicDefinitionMetaDataPair[fullMosaicName].mosaicDefinition = neededDefinition[fullMosaicName];
                                var supply = 0;
                                result.data.some(function (obj) {
                                    if ((obj.mosaic.id.namespaceId === mosaic.namespace) &&
                                        (obj.mosaic.id.name === mosaic.name)) {
                                        obj.mosaic.properties.some(function (prop) {
                                            if (prop.name === 'initialSupply') {
                                                supply = prop.value;
                                                return true;
                                            }
                                        });
                                    }
                                });
                                mosaicDefinitionMetaDataPair[fullMosaicName].supply = supply;
                                if (mosaicCount >= mosaics.length) {
                                    resolve(mosaicDefinitionMetaDataPair);
                                }
                            }).catch(function (e) {
                                console.error(e);
                                reject(e);
                            });
                        });
                    })];
            });
        });
    };
    // QRコードjson取得.
    nemWrapper.prototype.getQRcodeJson = function (v, type, name, addr, amount, msg) {
        // v:2, type:1 アカウント, type:2 請求書
        var amountVal = amount * Math.pow(10, 6);
        var json = {
            type: type,
            data: {
                name: name,
                addr: addr,
                amount: amountVal,
                msg: msg
            },
            v: v
        };
        var jsonString = JSON.stringify(json);
        var result = __WEBPACK_IMPORTED_MODULE_1_encoding_japanese___default.a.codeToString(__WEBPACK_IMPORTED_MODULE_1_encoding_japanese___default.a.convert(this.getStr2Array(jsonString), 'UTF8'));
        return result;
    };
    // NEMの可分性取得
    nemWrapper.prototype.getNemDivisibility = function () {
        return Math.pow(10, 6);
    };
    nemWrapper.prototype.getStr2Array = function (str) {
        var array = [];
        for (var i = 0; i < str.length; i++) {
            array.push(str.charCodeAt(i));
        }
        return array;
    };
    //トランザクション履歴取得
    nemWrapper.prototype.getTransactions = function (address, toAddress) {
        var _this = this;
        console.log(address);
        console.log(this.endpoint);
        console.log(toAddress);
        var servant = [];
        var transferTx = __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.com.requests.account.transactions.all(this.endpoint, address).then(function (res) {
            res.data.forEach(function (prop) {
                console.log(prop);
                if (prop.transaction.mosaics !== undefined) {
                    if (prop.transaction.message.payload !== undefined && prop.transaction.recipient == toAddress) {
                        var tran = prop.transaction;
                        var signature = tran.signer;
                        var recipient = tran.recipient;
                        var timestamp = _this.dispTimeStamp(tran.timeStamp);
                        var amount = tran.amount / 1000000;
                        var amount_hd = _this.amount_hd(amount);
                        var message = _this.utf8_hex_string_to_string(tran.message.payload);
                        var flag = true;
                        if (message != null && message.indexOf("[[[年次有給申請]]]") !== -1) {
                            //console.log(prop.transaction.mosaics[1].mosaicId.name);
                            message = message.replace("[[[年次有給申請]]]", "");
                        }
                        else if (message != null) {
                            message = message.replace("[[[返却]]]", "UQ返却分");
                            flag = false;
                        }
                        console.log([timestamp, amount, amount_hd, message, flag]);
                        servant.push([timestamp, amount, amount_hd, message, flag]);
                    }
                }
            });
        });
        console.log(servant);
        return servant;
    };
    nemWrapper.prototype.getApplicationLogsFromAPI = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var result, url, headers, access_token, uid, client, response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = [];
                        if (!(address != null && address != "")) return [3 /*break*/, 3];
                        url = this.helper.path + "auth_users/uq_application_log/" + address;
                        console.log("in getaccountlist");
                        return [4 /*yield*/, this.helper.loadHeaders()];
                    case 1:
                        headers = _a.sent();
                        access_token = headers["access-token"];
                        uid = headers["uid"];
                        client = headers["client"];
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url, {
                                headers: { "Content-Type": "application/json",
                                    "access-token": access_token,
                                    "uid": uid,
                                    "client": client },
                                data: {}
                            }).then(function (response) {
                                console.log('status:', response.status); // 200
                                console.log(response.data.data[0]);
                                result = response.data.data[0];
                                // catchでエラー時の挙動を定義する
                            }).catch(function (error) {
                                if (error.response && error.response.status == "401") {
                                    console.log("please login");
                                    _this.helper.pleaseLogin();
                                }
                            })];
                    case 2:
                        response = _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, result];
                }
            });
        });
    };
    //トランザクション履歴取得
    nemWrapper.prototype.getApplicationLogs = function (address) {
        var _this = this;
        var servant = [];
        var transferTx = this.getApplicationLogsFromAPI(address).then(function (res) {
            console.log(res);
            res.forEach(function (prop) {
                console.log(prop);
                var timestamp = _this.toDate(prop[0]);
                var amount = prop[2];
                var amount_hd = _this.amount_hd(amount);
                var message = prop[3];
                if (message != null)
                    message = message.replace("[[[年次有給申請]]]", "");
                console.log([timestamp, amount, amount_hd, message]);
                servant.push([timestamp, amount, amount_hd, message]);
            });
        });
        console.log(servant);
        return servant;
    };
    //timestamp（文字列）を時間に変換
    nemWrapper.prototype.toDate = function (date) {
        var Y = date.substr(0, 4);
        var M = date.substr(5, 2);
        var D = date.substr(8, 2);
        var time = date.substr(11, 5);
        return Y + "年" + M + "月" + D + "日" + time;
    };
    //メッセージ解析
    nemWrapper.prototype.utf8_hex_string_to_string = function (hex_str1) {
        var bytes2 = this.hex_string_to_bytes(hex_str1);
        var str2 = this.utf8_bytes_to_string(bytes2);
        return str2;
    };
    nemWrapper.prototype.hex_to_byte = function (hex_str) {
        return parseInt(hex_str, 16);
    };
    nemWrapper.prototype.hex_string_to_bytes = function (hex_str) {
        var result = [];
        if (hex_str && hex_str.length) {
            for (var i = 0; i < hex_str.length; i += 2) {
                result.push(this.hex_to_byte(hex_str.substr(i, 2)));
            }
        }
        return result;
    };
    nemWrapper.prototype.utf8_bytes_to_string = function (arr) {
        if (arr == null)
            return null;
        var result = "";
        var i;
        while (i = arr.shift()) {
            if (i <= 0x7f) {
                result += String.fromCharCode(i);
            }
            else if (i <= 0xdf) {
                var c = ((i & 0x1f) << 6);
                c += arr.shift() & 0x3f;
                result += String.fromCharCode(c);
            }
            else if (i <= 0xe0) {
                var c = ((arr.shift() & 0x1f) << 6) | 0x0800;
                c += arr.shift() & 0x3f;
                result += String.fromCharCode(c);
            }
            else {
                var c = ((i & 0x0f) << 12);
                c += (arr.shift() & 0x3f) << 6;
                c += arr.shift() & 0x3f;
                result += String.fromCharCode(c);
            }
        }
        return result;
    };
    //メッセージ解析end
    nemWrapper.prototype.getCompanyInfoFromAPI = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var result, url, headers, access_token, uid, client, response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = [];
                        if (!(address != null && address != "")) return [3 /*break*/, 3];
                        url = this.helper.path + "auth_users/company_info/" + address;
                        console.log("in getcompanyinfofromapi");
                        return [4 /*yield*/, this.helper.load("Headers")
                            //let headers = await this.helper.loadHeaders()
                        ];
                    case 1:
                        headers = _a.sent();
                        if (!(headers != null)) return [3 /*break*/, 3];
                        access_token = headers["access-token"];
                        uid = headers["uid"];
                        client = headers["client"];
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url, {
                                headers: { "Content-Type": "application/json",
                                    "access-token": access_token,
                                    "uid": uid,
                                    "client": client },
                                data: {}
                            }).then(function (response) {
                                console.log('status:', response.status); // 200
                                console.log(response.data);
                                result = response.data.data[0];
                                // catchでエラー時の挙動を定義する
                            }).catch(function (error) {
                                if (error.response && error.response.status == "401") {
                                    console.log("please login");
                                    _this.helper.pleaseLogin();
                                }
                            })];
                    case 2:
                        response = _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, result];
                }
            });
        });
    };
    //UQを受け取っているかどうか
    nemWrapper.prototype.checkRecieveUq = function (transaction, yourMosaicName, address) {
        return __awaiter(this, void 0, void 0, function () {
            var mosaics_flag;
            return __generator(this, function (_a) {
                mosaics_flag = false;
                if (transaction.mosaics) {
                    mosaics_flag = transaction.mosaics.filter(function (value) {
                        return value.mosaicId.name === yourMosaicName;
                    });
                }
                if (transaction.recipient != null && transaction.recipient == address) {
                    if (mosaics_flag) {
                        return [2 /*return*/, true];
                    }
                }
                return [2 /*return*/, false];
            });
        });
    };
    return nemWrapper;
}());
/* harmony default export */ __webpack_exports__["a"] = (nemWrapper);


/***/ }),

/***/ 300:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 332:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 333:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 334:
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ 338:
/***/ (function(module, exports) {

module.exports = {"_from":"elliptic@6.5.4","_id":"elliptic@6.5.4","_inBundle":false,"_integrity":"sha512-iLhC6ULemrljPZb+QutR5TQGB+pdW6KGD5RSegS+8sorOZT+rdQFbsQFJgvN3eRqNALqJer4oQ16YvJHlU8hzQ==","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"elliptic@6.5.4","name":"elliptic","escapedName":"elliptic","rawSpec":"6.5.4","saveSpec":null,"fetchSpec":"6.5.4"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.5.4.tgz","_shasum":"da37cebd31e79a1367e941b592ed1fbebd58abbb","_spec":"elliptic@6.5.4","_where":"/Users/soda/Documents/development/Vue/smartuq-wallet/node_modules/browserify-sign","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"bundleDependencies":false,"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"},"deprecated":false,"description":"EC cryptography","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.5.4"}

/***/ }),

/***/ 339:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 369:
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ 400:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login",attrs:{"id":"login"}},[_c('v-container',{staticClass:"v-main paTop0",style:({ height: '100vh',backgroundImage: 'url(' + _vm.background_img + ')' })},[_c('v-card-actions',{staticClass:"padding0"},[_c('v-card-title'),_vm._v(" "),_c('p',{staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(_vm.$props.version))])],1),_vm._v(" "),_c('div',{staticClass:"login-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"v-form login-form",attrs:{"label":"","placeholder":"メールアドレス"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"v-form login-form",attrs:{"label":"","type":"password","placeholder":"パスワード"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('div',[_c('v-btn',{staticClass:"white--text f-bold login-btn pa5_10per",on:{"click":function($event){_vm.login()}}},[_c('span',{staticClass:"color_092033"},[_vm._v("ログイン")])])],1),_vm._v(" "),_c('v-btn',{staticClass:"white--text f-bold login-btn pa5_10per",attrs:{"to":{ name: 'Register',params: {address:_vm.$props.address, public_key:_vm.$props.public_key, private_key:_vm.$props.private_key , version:_vm.$props.version}}}},[_c('span',{staticClass:"color_092033"},[_vm._v("新規登録")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 401:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Top_vue__ = __webpack_require__(194);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e2f0ad1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Top_vue__ = __webpack_require__(636);
function injectStyle (ssrContext) {
  __webpack_require__(402)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e2f0ad1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Top_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e2f0ad1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Top_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 402:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 450:
/***/ (function(module, exports) {

module.exports = {"_args":[["tough-cookie@2.3.4","/Users/soda/Documents/development/Vue/smartuq-wallet"]],"_from":"tough-cookie@2.3.4","_id":"tough-cookie@2.3.4","_inBundle":false,"_integrity":"sha512-TZ6TTfI5NtZnuyy/Kecv+CnoROnyXn2DN97LontgQpCwsX2XyLYCC0ENhYkehSOwAp8rTQKc/NUIF7BkQ5rKLA==","_location":"/tough-cookie","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"tough-cookie@2.3.4","name":"tough-cookie","escapedName":"tough-cookie","rawSpec":"2.3.4","saveSpec":null,"fetchSpec":"2.3.4"},"_requiredBy":["/request"],"_resolved":"https://registry.npmjs.org/tough-cookie/-/tough-cookie-2.3.4.tgz","_spec":"2.3.4","_where":"/Users/soda/Documents/development/Vue/smartuq-wallet","author":{"name":"Jeremy Stashewsky","email":"jstashewsky@salesforce.com"},"bugs":{"url":"https://github.com/salesforce/tough-cookie/issues"},"contributors":[{"name":"Alexander Savin"},{"name":"Ian Livingstone"},{"name":"Ivan Nikulin"},{"name":"Lalit Kapoor"},{"name":"Sam Thompson"},{"name":"Sebastian Mayr"}],"dependencies":{"punycode":"^1.4.1"},"description":"RFC6265 Cookies and Cookie Jar for node.js","devDependencies":{"async":"^1.4.2","string.prototype.repeat":"^0.2.0","vows":"^0.8.1"},"engines":{"node":">=0.8"},"files":["lib"],"homepage":"https://github.com/salesforce/tough-cookie","keywords":["HTTP","cookie","cookies","set-cookie","cookiejar","jar","RFC6265","RFC2965"],"license":"BSD-3-Clause","main":"./lib/cookie","name":"tough-cookie","repository":{"type":"git","url":"git://github.com/salesforce/tough-cookie.git"},"scripts":{"suffixup":"curl -o public_suffix_list.dat https://publicsuffix.org/list/public_suffix_list.dat && ./generate-pubsuffix.js","test":"vows test/*_test.js"},"version":"2.3.4"}

/***/ }),

/***/ 473:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d53d07a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmationModal_vue__ = __webpack_require__(294);
function injectStyle (ssrContext) {
  __webpack_require__(293)
}
var normalizeComponent = __webpack_require__(10)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d53d07a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmationModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 490:
/***/ (function(module, exports) {

module.exports = {"application/1d-interleaved-parityfec":{"source":"iana"},"application/3gpdash-qoe-report+xml":{"source":"iana","compressible":true},"application/3gpp-ims+xml":{"source":"iana","compressible":true},"application/a2l":{"source":"iana"},"application/activemessage":{"source":"iana"},"application/activity+json":{"source":"iana","compressible":true},"application/alto-costmap+json":{"source":"iana","compressible":true},"application/alto-costmapfilter+json":{"source":"iana","compressible":true},"application/alto-directory+json":{"source":"iana","compressible":true},"application/alto-endpointcost+json":{"source":"iana","compressible":true},"application/alto-endpointcostparams+json":{"source":"iana","compressible":true},"application/alto-endpointprop+json":{"source":"iana","compressible":true},"application/alto-endpointpropparams+json":{"source":"iana","compressible":true},"application/alto-error+json":{"source":"iana","compressible":true},"application/alto-networkmap+json":{"source":"iana","compressible":true},"application/alto-networkmapfilter+json":{"source":"iana","compressible":true},"application/aml":{"source":"iana"},"application/andrew-inset":{"source":"iana","extensions":["ez"]},"application/applefile":{"source":"iana"},"application/applixware":{"source":"apache","extensions":["aw"]},"application/atf":{"source":"iana"},"application/atfx":{"source":"iana"},"application/atom+xml":{"source":"iana","compressible":true,"extensions":["atom"]},"application/atomcat+xml":{"source":"iana","compressible":true,"extensions":["atomcat"]},"application/atomdeleted+xml":{"source":"iana","compressible":true},"application/atomicmail":{"source":"iana"},"application/atomsvc+xml":{"source":"iana","compressible":true,"extensions":["atomsvc"]},"application/atxml":{"source":"iana"},"application/auth-policy+xml":{"source":"iana","compressible":true},"application/bacnet-xdd+zip":{"source":"iana","compressible":false},"application/batch-smtp":{"source":"iana"},"application/bdoc":{"compressible":false,"extensions":["bdoc"]},"application/beep+xml":{"source":"iana","compressible":true},"application/calendar+json":{"source":"iana","compressible":true},"application/calendar+xml":{"source":"iana","compressible":true},"application/call-completion":{"source":"iana"},"application/cals-1840":{"source":"iana"},"application/cbor":{"source":"iana"},"application/cccex":{"source":"iana"},"application/ccmp+xml":{"source":"iana","compressible":true},"application/ccxml+xml":{"source":"iana","compressible":true,"extensions":["ccxml"]},"application/cdfx+xml":{"source":"iana","compressible":true},"application/cdmi-capability":{"source":"iana","extensions":["cdmia"]},"application/cdmi-container":{"source":"iana","extensions":["cdmic"]},"application/cdmi-domain":{"source":"iana","extensions":["cdmid"]},"application/cdmi-object":{"source":"iana","extensions":["cdmio"]},"application/cdmi-queue":{"source":"iana","extensions":["cdmiq"]},"application/cdni":{"source":"iana"},"application/cea":{"source":"iana"},"application/cea-2018+xml":{"source":"iana","compressible":true},"application/cellml+xml":{"source":"iana","compressible":true},"application/cfw":{"source":"iana"},"application/clue_info+xml":{"source":"iana","compressible":true},"application/cms":{"source":"iana"},"application/cnrp+xml":{"source":"iana","compressible":true},"application/coap-group+json":{"source":"iana","compressible":true},"application/coap-payload":{"source":"iana"},"application/commonground":{"source":"iana"},"application/conference-info+xml":{"source":"iana","compressible":true},"application/cose":{"source":"iana"},"application/cose-key":{"source":"iana"},"application/cose-key-set":{"source":"iana"},"application/cpl+xml":{"source":"iana","compressible":true},"application/csrattrs":{"source":"iana"},"application/csta+xml":{"source":"iana","compressible":true},"application/cstadata+xml":{"source":"iana","compressible":true},"application/csvm+json":{"source":"iana","compressible":true},"application/cu-seeme":{"source":"apache","extensions":["cu"]},"application/cwt":{"source":"iana"},"application/cybercash":{"source":"iana"},"application/dart":{"compressible":true},"application/dash+xml":{"source":"iana","compressible":true,"extensions":["mpd"]},"application/dashdelta":{"source":"iana"},"application/davmount+xml":{"source":"iana","compressible":true,"extensions":["davmount"]},"application/dca-rft":{"source":"iana"},"application/dcd":{"source":"iana"},"application/dec-dx":{"source":"iana"},"application/dialog-info+xml":{"source":"iana","compressible":true},"application/dicom":{"source":"iana"},"application/dicom+json":{"source":"iana","compressible":true},"application/dicom+xml":{"source":"iana","compressible":true},"application/dii":{"source":"iana"},"application/dit":{"source":"iana"},"application/dns":{"source":"iana"},"application/dns+json":{"source":"iana","compressible":true},"application/docbook+xml":{"source":"apache","compressible":true,"extensions":["dbk"]},"application/dskpp+xml":{"source":"iana","compressible":true},"application/dssc+der":{"source":"iana","extensions":["dssc"]},"application/dssc+xml":{"source":"iana","compressible":true,"extensions":["xdssc"]},"application/dvcs":{"source":"iana"},"application/ecmascript":{"source":"iana","compressible":true,"extensions":["ecma","es"]},"application/edi-consent":{"source":"iana"},"application/edi-x12":{"source":"iana","compressible":false},"application/edifact":{"source":"iana","compressible":false},"application/efi":{"source":"iana"},"application/emergencycalldata.comment+xml":{"source":"iana","compressible":true},"application/emergencycalldata.control+xml":{"source":"iana","compressible":true},"application/emergencycalldata.deviceinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.ecall.msd":{"source":"iana"},"application/emergencycalldata.providerinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.serviceinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.subscriberinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.veds+xml":{"source":"iana","compressible":true},"application/emma+xml":{"source":"iana","compressible":true,"extensions":["emma"]},"application/emotionml+xml":{"source":"iana","compressible":true},"application/encaprtp":{"source":"iana"},"application/epp+xml":{"source":"iana","compressible":true},"application/epub+zip":{"source":"iana","compressible":false,"extensions":["epub"]},"application/eshop":{"source":"iana"},"application/exi":{"source":"iana","extensions":["exi"]},"application/fastinfoset":{"source":"iana"},"application/fastsoap":{"source":"iana"},"application/fdt+xml":{"source":"iana","compressible":true},"application/fhir+json":{"source":"iana","compressible":true},"application/fhir+xml":{"source":"iana","compressible":true},"application/fido.trusted-apps+json":{"compressible":true},"application/fits":{"source":"iana"},"application/font-sfnt":{"source":"iana"},"application/font-tdpfr":{"source":"iana","extensions":["pfr"]},"application/font-woff":{"source":"iana","compressible":false},"application/framework-attributes+xml":{"source":"iana","compressible":true},"application/geo+json":{"source":"iana","compressible":true,"extensions":["geojson"]},"application/geo+json-seq":{"source":"iana"},"application/geopackage+sqlite3":{"source":"iana"},"application/geoxacml+xml":{"source":"iana","compressible":true},"application/gltf-buffer":{"source":"iana"},"application/gml+xml":{"source":"iana","compressible":true,"extensions":["gml"]},"application/gpx+xml":{"source":"apache","compressible":true,"extensions":["gpx"]},"application/gxf":{"source":"apache","extensions":["gxf"]},"application/gzip":{"source":"iana","compressible":false,"extensions":["gz"]},"application/h224":{"source":"iana"},"application/held+xml":{"source":"iana","compressible":true},"application/hjson":{"extensions":["hjson"]},"application/http":{"source":"iana"},"application/hyperstudio":{"source":"iana","extensions":["stk"]},"application/ibe-key-request+xml":{"source":"iana","compressible":true},"application/ibe-pkg-reply+xml":{"source":"iana","compressible":true},"application/ibe-pp-data":{"source":"iana"},"application/iges":{"source":"iana"},"application/im-iscomposing+xml":{"source":"iana","compressible":true},"application/index":{"source":"iana"},"application/index.cmd":{"source":"iana"},"application/index.obj":{"source":"iana"},"application/index.response":{"source":"iana"},"application/index.vnd":{"source":"iana"},"application/inkml+xml":{"source":"iana","compressible":true,"extensions":["ink","inkml"]},"application/iotp":{"source":"iana"},"application/ipfix":{"source":"iana","extensions":["ipfix"]},"application/ipp":{"source":"iana"},"application/isup":{"source":"iana"},"application/its+xml":{"source":"iana","compressible":true},"application/java-archive":{"source":"apache","compressible":false,"extensions":["jar","war","ear"]},"application/java-serialized-object":{"source":"apache","compressible":false,"extensions":["ser"]},"application/java-vm":{"source":"apache","compressible":false,"extensions":["class"]},"application/javascript":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["js","mjs"]},"application/jf2feed+json":{"source":"iana","compressible":true},"application/jose":{"source":"iana"},"application/jose+json":{"source":"iana","compressible":true},"application/jrd+json":{"source":"iana","compressible":true},"application/json":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["json","map"]},"application/json-patch+json":{"source":"iana","compressible":true},"application/json-seq":{"source":"iana"},"application/json5":{"extensions":["json5"]},"application/jsonml+json":{"source":"apache","compressible":true,"extensions":["jsonml"]},"application/jwk+json":{"source":"iana","compressible":true},"application/jwk-set+json":{"source":"iana","compressible":true},"application/jwt":{"source":"iana"},"application/kpml-request+xml":{"source":"iana","compressible":true},"application/kpml-response+xml":{"source":"iana","compressible":true},"application/ld+json":{"source":"iana","compressible":true,"extensions":["jsonld"]},"application/lgr+xml":{"source":"iana","compressible":true},"application/link-format":{"source":"iana"},"application/load-control+xml":{"source":"iana","compressible":true},"application/lost+xml":{"source":"iana","compressible":true,"extensions":["lostxml"]},"application/lostsync+xml":{"source":"iana","compressible":true},"application/lxf":{"source":"iana"},"application/mac-binhex40":{"source":"iana","extensions":["hqx"]},"application/mac-compactpro":{"source":"apache","extensions":["cpt"]},"application/macwriteii":{"source":"iana"},"application/mads+xml":{"source":"iana","compressible":true,"extensions":["mads"]},"application/manifest+json":{"charset":"UTF-8","compressible":true,"extensions":["webmanifest"]},"application/marc":{"source":"iana","extensions":["mrc"]},"application/marcxml+xml":{"source":"iana","compressible":true,"extensions":["mrcx"]},"application/mathematica":{"source":"iana","extensions":["ma","nb","mb"]},"application/mathml+xml":{"source":"iana","compressible":true,"extensions":["mathml"]},"application/mathml-content+xml":{"source":"iana","compressible":true},"application/mathml-presentation+xml":{"source":"iana","compressible":true},"application/mbms-associated-procedure-description+xml":{"source":"iana","compressible":true},"application/mbms-deregister+xml":{"source":"iana","compressible":true},"application/mbms-envelope+xml":{"source":"iana","compressible":true},"application/mbms-msk+xml":{"source":"iana","compressible":true},"application/mbms-msk-response+xml":{"source":"iana","compressible":true},"application/mbms-protection-description+xml":{"source":"iana","compressible":true},"application/mbms-reception-report+xml":{"source":"iana","compressible":true},"application/mbms-register+xml":{"source":"iana","compressible":true},"application/mbms-register-response+xml":{"source":"iana","compressible":true},"application/mbms-schedule+xml":{"source":"iana","compressible":true},"application/mbms-user-service-description+xml":{"source":"iana","compressible":true},"application/mbox":{"source":"iana","extensions":["mbox"]},"application/media-policy-dataset+xml":{"source":"iana","compressible":true},"application/media_control+xml":{"source":"iana","compressible":true},"application/mediaservercontrol+xml":{"source":"iana","compressible":true,"extensions":["mscml"]},"application/merge-patch+json":{"source":"iana","compressible":true},"application/metalink+xml":{"source":"apache","compressible":true,"extensions":["metalink"]},"application/metalink4+xml":{"source":"iana","compressible":true,"extensions":["meta4"]},"application/mets+xml":{"source":"iana","compressible":true,"extensions":["mets"]},"application/mf4":{"source":"iana"},"application/mikey":{"source":"iana"},"application/mmt-usd+xml":{"source":"iana","compressible":true},"application/mods+xml":{"source":"iana","compressible":true,"extensions":["mods"]},"application/moss-keys":{"source":"iana"},"application/moss-signature":{"source":"iana"},"application/mosskey-data":{"source":"iana"},"application/mosskey-request":{"source":"iana"},"application/mp21":{"source":"iana","extensions":["m21","mp21"]},"application/mp4":{"source":"iana","extensions":["mp4s","m4p"]},"application/mpeg4-generic":{"source":"iana"},"application/mpeg4-iod":{"source":"iana"},"application/mpeg4-iod-xmt":{"source":"iana"},"application/mrb-consumer+xml":{"source":"iana","compressible":true},"application/mrb-publish+xml":{"source":"iana","compressible":true},"application/msc-ivr+xml":{"source":"iana","compressible":true},"application/msc-mixer+xml":{"source":"iana","compressible":true},"application/msword":{"source":"iana","compressible":false,"extensions":["doc","dot"]},"application/mud+json":{"source":"iana","compressible":true},"application/mxf":{"source":"iana","extensions":["mxf"]},"application/n-quads":{"source":"iana"},"application/n-triples":{"source":"iana"},"application/nasdata":{"source":"iana"},"application/news-checkgroups":{"source":"iana"},"application/news-groupinfo":{"source":"iana"},"application/news-transmission":{"source":"iana"},"application/nlsml+xml":{"source":"iana","compressible":true},"application/node":{"source":"iana"},"application/nss":{"source":"iana"},"application/ocsp-request":{"source":"iana"},"application/ocsp-response":{"source":"iana"},"application/octet-stream":{"source":"iana","compressible":false,"extensions":["bin","dms","lrf","mar","so","dist","distz","pkg","bpk","dump","elc","deploy","exe","dll","deb","dmg","iso","img","msi","msp","msm","buffer"]},"application/oda":{"source":"iana","extensions":["oda"]},"application/odx":{"source":"iana"},"application/oebps-package+xml":{"source":"iana","compressible":true,"extensions":["opf"]},"application/ogg":{"source":"iana","compressible":false,"extensions":["ogx"]},"application/omdoc+xml":{"source":"apache","compressible":true,"extensions":["omdoc"]},"application/onenote":{"source":"apache","extensions":["onetoc","onetoc2","onetmp","onepkg"]},"application/oxps":{"source":"iana","extensions":["oxps"]},"application/p2p-overlay+xml":{"source":"iana","compressible":true},"application/parityfec":{"source":"iana"},"application/passport":{"source":"iana"},"application/patch-ops-error+xml":{"source":"iana","compressible":true,"extensions":["xer"]},"application/pdf":{"source":"iana","compressible":false,"extensions":["pdf"]},"application/pdx":{"source":"iana"},"application/pgp-encrypted":{"source":"iana","compressible":false,"extensions":["pgp"]},"application/pgp-keys":{"source":"iana"},"application/pgp-signature":{"source":"iana","extensions":["asc","sig"]},"application/pics-rules":{"source":"apache","extensions":["prf"]},"application/pidf+xml":{"source":"iana","compressible":true},"application/pidf-diff+xml":{"source":"iana","compressible":true},"application/pkcs10":{"source":"iana","extensions":["p10"]},"application/pkcs12":{"source":"iana"},"application/pkcs7-mime":{"source":"iana","extensions":["p7m","p7c"]},"application/pkcs7-signature":{"source":"iana","extensions":["p7s"]},"application/pkcs8":{"source":"iana","extensions":["p8"]},"application/pkcs8-encrypted":{"source":"iana"},"application/pkix-attr-cert":{"source":"iana","extensions":["ac"]},"application/pkix-cert":{"source":"iana","extensions":["cer"]},"application/pkix-crl":{"source":"iana","extensions":["crl"]},"application/pkix-pkipath":{"source":"iana","extensions":["pkipath"]},"application/pkixcmp":{"source":"iana","extensions":["pki"]},"application/pls+xml":{"source":"iana","compressible":true,"extensions":["pls"]},"application/poc-settings+xml":{"source":"iana","compressible":true},"application/postscript":{"source":"iana","compressible":true,"extensions":["ai","eps","ps"]},"application/ppsp-tracker+json":{"source":"iana","compressible":true},"application/problem+json":{"source":"iana","compressible":true},"application/problem+xml":{"source":"iana","compressible":true},"application/provenance+xml":{"source":"iana","compressible":true},"application/prs.alvestrand.titrax-sheet":{"source":"iana"},"application/prs.cww":{"source":"iana","extensions":["cww"]},"application/prs.hpub+zip":{"source":"iana","compressible":false},"application/prs.nprend":{"source":"iana"},"application/prs.plucker":{"source":"iana"},"application/prs.rdf-xml-crypt":{"source":"iana"},"application/prs.xsf+xml":{"source":"iana","compressible":true},"application/pskc+xml":{"source":"iana","compressible":true,"extensions":["pskcxml"]},"application/qsig":{"source":"iana"},"application/raml+yaml":{"compressible":true,"extensions":["raml"]},"application/raptorfec":{"source":"iana"},"application/rdap+json":{"source":"iana","compressible":true},"application/rdf+xml":{"source":"iana","compressible":true,"extensions":["rdf","owl"]},"application/reginfo+xml":{"source":"iana","compressible":true,"extensions":["rif"]},"application/relax-ng-compact-syntax":{"source":"iana","extensions":["rnc"]},"application/remote-printing":{"source":"iana"},"application/reputon+json":{"source":"iana","compressible":true},"application/resource-lists+xml":{"source":"iana","compressible":true,"extensions":["rl"]},"application/resource-lists-diff+xml":{"source":"iana","compressible":true,"extensions":["rld"]},"application/rfc+xml":{"source":"iana","compressible":true},"application/riscos":{"source":"iana"},"application/rlmi+xml":{"source":"iana","compressible":true},"application/rls-services+xml":{"source":"iana","compressible":true,"extensions":["rs"]},"application/route-apd+xml":{"source":"iana","compressible":true},"application/route-s-tsid+xml":{"source":"iana","compressible":true},"application/route-usd+xml":{"source":"iana","compressible":true},"application/rpki-ghostbusters":{"source":"iana","extensions":["gbr"]},"application/rpki-manifest":{"source":"iana","extensions":["mft"]},"application/rpki-publication":{"source":"iana"},"application/rpki-roa":{"source":"iana","extensions":["roa"]},"application/rpki-updown":{"source":"iana"},"application/rsd+xml":{"source":"apache","compressible":true,"extensions":["rsd"]},"application/rss+xml":{"source":"apache","compressible":true,"extensions":["rss"]},"application/rtf":{"source":"iana","compressible":true,"extensions":["rtf"]},"application/rtploopback":{"source":"iana"},"application/rtx":{"source":"iana"},"application/samlassertion+xml":{"source":"iana","compressible":true},"application/samlmetadata+xml":{"source":"iana","compressible":true},"application/sbml+xml":{"source":"iana","compressible":true,"extensions":["sbml"]},"application/scaip+xml":{"source":"iana","compressible":true},"application/scim+json":{"source":"iana","compressible":true},"application/scvp-cv-request":{"source":"iana","extensions":["scq"]},"application/scvp-cv-response":{"source":"iana","extensions":["scs"]},"application/scvp-vp-request":{"source":"iana","extensions":["spq"]},"application/scvp-vp-response":{"source":"iana","extensions":["spp"]},"application/sdp":{"source":"iana","extensions":["sdp"]},"application/secevent+jwt":{"source":"iana"},"application/senml+cbor":{"source":"iana"},"application/senml+json":{"source":"iana","compressible":true},"application/senml+xml":{"source":"iana","compressible":true},"application/senml-exi":{"source":"iana"},"application/sensml+cbor":{"source":"iana"},"application/sensml+json":{"source":"iana","compressible":true},"application/sensml+xml":{"source":"iana","compressible":true},"application/sensml-exi":{"source":"iana"},"application/sep+xml":{"source":"iana","compressible":true},"application/sep-exi":{"source":"iana"},"application/session-info":{"source":"iana"},"application/set-payment":{"source":"iana"},"application/set-payment-initiation":{"source":"iana","extensions":["setpay"]},"application/set-registration":{"source":"iana"},"application/set-registration-initiation":{"source":"iana","extensions":["setreg"]},"application/sgml":{"source":"iana"},"application/sgml-open-catalog":{"source":"iana"},"application/shf+xml":{"source":"iana","compressible":true,"extensions":["shf"]},"application/sieve":{"source":"iana"},"application/simple-filter+xml":{"source":"iana","compressible":true},"application/simple-message-summary":{"source":"iana"},"application/simplesymbolcontainer":{"source":"iana"},"application/slate":{"source":"iana"},"application/smil":{"source":"iana"},"application/smil+xml":{"source":"iana","compressible":true,"extensions":["smi","smil"]},"application/smpte336m":{"source":"iana"},"application/soap+fastinfoset":{"source":"iana"},"application/soap+xml":{"source":"iana","compressible":true},"application/sparql-query":{"source":"iana","extensions":["rq"]},"application/sparql-results+xml":{"source":"iana","compressible":true,"extensions":["srx"]},"application/spirits-event+xml":{"source":"iana","compressible":true},"application/sql":{"source":"iana"},"application/srgs":{"source":"iana","extensions":["gram"]},"application/srgs+xml":{"source":"iana","compressible":true,"extensions":["grxml"]},"application/sru+xml":{"source":"iana","compressible":true,"extensions":["sru"]},"application/ssdl+xml":{"source":"apache","compressible":true,"extensions":["ssdl"]},"application/ssml+xml":{"source":"iana","compressible":true,"extensions":["ssml"]},"application/stix+json":{"source":"iana","compressible":true},"application/tamp-apex-update":{"source":"iana"},"application/tamp-apex-update-confirm":{"source":"iana"},"application/tamp-community-update":{"source":"iana"},"application/tamp-community-update-confirm":{"source":"iana"},"application/tamp-error":{"source":"iana"},"application/tamp-sequence-adjust":{"source":"iana"},"application/tamp-sequence-adjust-confirm":{"source":"iana"},"application/tamp-status-query":{"source":"iana"},"application/tamp-status-response":{"source":"iana"},"application/tamp-update":{"source":"iana"},"application/tamp-update-confirm":{"source":"iana"},"application/tar":{"compressible":true},"application/taxii+json":{"source":"iana","compressible":true},"application/tei+xml":{"source":"iana","compressible":true,"extensions":["tei","teicorpus"]},"application/thraud+xml":{"source":"iana","compressible":true,"extensions":["tfi"]},"application/timestamp-query":{"source":"iana"},"application/timestamp-reply":{"source":"iana"},"application/timestamped-data":{"source":"iana","extensions":["tsd"]},"application/tlsrpt+gzip":{"source":"iana"},"application/tlsrpt+json":{"source":"iana","compressible":true},"application/tnauthlist":{"source":"iana"},"application/trickle-ice-sdpfrag":{"source":"iana"},"application/trig":{"source":"iana"},"application/ttml+xml":{"source":"iana","compressible":true},"application/tve-trigger":{"source":"iana"},"application/ulpfec":{"source":"iana"},"application/urc-grpsheet+xml":{"source":"iana","compressible":true},"application/urc-ressheet+xml":{"source":"iana","compressible":true},"application/urc-targetdesc+xml":{"source":"iana","compressible":true},"application/urc-uisocketdesc+xml":{"source":"iana","compressible":true},"application/vcard+json":{"source":"iana","compressible":true},"application/vcard+xml":{"source":"iana","compressible":true},"application/vemmi":{"source":"iana"},"application/vividence.scriptfile":{"source":"apache"},"application/vnd.1000minds.decision-model+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-prose+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-prose-pc3ch+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-v2x-local-service-information":{"source":"iana"},"application/vnd.3gpp.access-transfer-events+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.bsf+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.gmop+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mc-signalling-ear":{"source":"iana"},"application/vnd.3gpp.mcdata-payload":{"source":"iana"},"application/vnd.3gpp.mcdata-signalling":{"source":"iana"},"application/vnd.3gpp.mcptt-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-floor-request+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-location-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-mbms-usage-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-signed+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mid-call+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.pic-bw-large":{"source":"iana","extensions":["plb"]},"application/vnd.3gpp.pic-bw-small":{"source":"iana","extensions":["psb"]},"application/vnd.3gpp.pic-bw-var":{"source":"iana","extensions":["pvb"]},"application/vnd.3gpp.sms":{"source":"iana"},"application/vnd.3gpp.sms+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.srvcc-ext+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.srvcc-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.state-and-event-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.ussd+xml":{"source":"iana","compressible":true},"application/vnd.3gpp2.bcmcsinfo+xml":{"source":"iana","compressible":true},"application/vnd.3gpp2.sms":{"source":"iana"},"application/vnd.3gpp2.tcap":{"source":"iana","extensions":["tcap"]},"application/vnd.3lightssoftware.imagescal":{"source":"iana"},"application/vnd.3m.post-it-notes":{"source":"iana","extensions":["pwn"]},"application/vnd.accpac.simply.aso":{"source":"iana","extensions":["aso"]},"application/vnd.accpac.simply.imp":{"source":"iana","extensions":["imp"]},"application/vnd.acucobol":{"source":"iana","extensions":["acu"]},"application/vnd.acucorp":{"source":"iana","extensions":["atc","acutc"]},"application/vnd.adobe.air-application-installer-package+zip":{"source":"apache","compressible":false,"extensions":["air"]},"application/vnd.adobe.flash.movie":{"source":"iana"},"application/vnd.adobe.formscentral.fcdt":{"source":"iana","extensions":["fcdt"]},"application/vnd.adobe.fxp":{"source":"iana","extensions":["fxp","fxpl"]},"application/vnd.adobe.partial-upload":{"source":"iana"},"application/vnd.adobe.xdp+xml":{"source":"iana","compressible":true,"extensions":["xdp"]},"application/vnd.adobe.xfdf":{"source":"iana","extensions":["xfdf"]},"application/vnd.aether.imp":{"source":"iana"},"application/vnd.afpc.afplinedata":{"source":"iana"},"application/vnd.afpc.modca":{"source":"iana"},"application/vnd.ah-barcode":{"source":"iana"},"application/vnd.ahead.space":{"source":"iana","extensions":["ahead"]},"application/vnd.airzip.filesecure.azf":{"source":"iana","extensions":["azf"]},"application/vnd.airzip.filesecure.azs":{"source":"iana","extensions":["azs"]},"application/vnd.amadeus+json":{"source":"iana","compressible":true},"application/vnd.amazon.ebook":{"source":"apache","extensions":["azw"]},"application/vnd.amazon.mobi8-ebook":{"source":"iana"},"application/vnd.americandynamics.acc":{"source":"iana","extensions":["acc"]},"application/vnd.amiga.ami":{"source":"iana","extensions":["ami"]},"application/vnd.amundsen.maze+xml":{"source":"iana","compressible":true},"application/vnd.android.package-archive":{"source":"apache","compressible":false,"extensions":["apk"]},"application/vnd.anki":{"source":"iana"},"application/vnd.anser-web-certificate-issue-initiation":{"source":"iana","extensions":["cii"]},"application/vnd.anser-web-funds-transfer-initiation":{"source":"apache","extensions":["fti"]},"application/vnd.antix.game-component":{"source":"iana","extensions":["atx"]},"application/vnd.apache.thrift.binary":{"source":"iana"},"application/vnd.apache.thrift.compact":{"source":"iana"},"application/vnd.apache.thrift.json":{"source":"iana"},"application/vnd.api+json":{"source":"iana","compressible":true},"application/vnd.apothekende.reservation+json":{"source":"iana","compressible":true},"application/vnd.apple.installer+xml":{"source":"iana","compressible":true,"extensions":["mpkg"]},"application/vnd.apple.keynote":{"source":"iana","extensions":["keynote"]},"application/vnd.apple.mpegurl":{"source":"iana","extensions":["m3u8"]},"application/vnd.apple.numbers":{"source":"iana","extensions":["numbers"]},"application/vnd.apple.pages":{"source":"iana","extensions":["pages"]},"application/vnd.apple.pkpass":{"compressible":false,"extensions":["pkpass"]},"application/vnd.arastra.swi":{"source":"iana"},"application/vnd.aristanetworks.swi":{"source":"iana","extensions":["swi"]},"application/vnd.artisan+json":{"source":"iana","compressible":true},"application/vnd.artsquare":{"source":"iana"},"application/vnd.astraea-software.iota":{"source":"iana","extensions":["iota"]},"application/vnd.audiograph":{"source":"iana","extensions":["aep"]},"application/vnd.autopackage":{"source":"iana"},"application/vnd.avalon+json":{"source":"iana","compressible":true},"application/vnd.avistar+xml":{"source":"iana","compressible":true},"application/vnd.balsamiq.bmml+xml":{"source":"iana","compressible":true},"application/vnd.balsamiq.bmpr":{"source":"iana"},"application/vnd.banana-accounting":{"source":"iana"},"application/vnd.bbf.usp.msg":{"source":"iana"},"application/vnd.bbf.usp.msg+json":{"source":"iana","compressible":true},"application/vnd.bekitzur-stech+json":{"source":"iana","compressible":true},"application/vnd.bint.med-content":{"source":"iana"},"application/vnd.biopax.rdf+xml":{"source":"iana","compressible":true},"application/vnd.blink-idb-value-wrapper":{"source":"iana"},"application/vnd.blueice.multipass":{"source":"iana","extensions":["mpm"]},"application/vnd.bluetooth.ep.oob":{"source":"iana"},"application/vnd.bluetooth.le.oob":{"source":"iana"},"application/vnd.bmi":{"source":"iana","extensions":["bmi"]},"application/vnd.businessobjects":{"source":"iana","extensions":["rep"]},"application/vnd.byu.uapi+json":{"source":"iana","compressible":true},"application/vnd.cab-jscript":{"source":"iana"},"application/vnd.canon-cpdl":{"source":"iana"},"application/vnd.canon-lips":{"source":"iana"},"application/vnd.capasystems-pg+json":{"source":"iana","compressible":true},"application/vnd.cendio.thinlinc.clientconf":{"source":"iana"},"application/vnd.century-systems.tcp_stream":{"source":"iana"},"application/vnd.chemdraw+xml":{"source":"iana","compressible":true,"extensions":["cdxml"]},"application/vnd.chess-pgn":{"source":"iana"},"application/vnd.chipnuts.karaoke-mmd":{"source":"iana","extensions":["mmd"]},"application/vnd.cinderella":{"source":"iana","extensions":["cdy"]},"application/vnd.cirpack.isdn-ext":{"source":"iana"},"application/vnd.citationstyles.style+xml":{"source":"iana","compressible":true,"extensions":["csl"]},"application/vnd.claymore":{"source":"iana","extensions":["cla"]},"application/vnd.cloanto.rp9":{"source":"iana","extensions":["rp9"]},"application/vnd.clonk.c4group":{"source":"iana","extensions":["c4g","c4d","c4f","c4p","c4u"]},"application/vnd.cluetrust.cartomobile-config":{"source":"iana","extensions":["c11amc"]},"application/vnd.cluetrust.cartomobile-config-pkg":{"source":"iana","extensions":["c11amz"]},"application/vnd.coffeescript":{"source":"iana"},"application/vnd.collabio.xodocuments.document":{"source":"iana"},"application/vnd.collabio.xodocuments.document-template":{"source":"iana"},"application/vnd.collabio.xodocuments.presentation":{"source":"iana"},"application/vnd.collabio.xodocuments.presentation-template":{"source":"iana"},"application/vnd.collabio.xodocuments.spreadsheet":{"source":"iana"},"application/vnd.collabio.xodocuments.spreadsheet-template":{"source":"iana"},"application/vnd.collection+json":{"source":"iana","compressible":true},"application/vnd.collection.doc+json":{"source":"iana","compressible":true},"application/vnd.collection.next+json":{"source":"iana","compressible":true},"application/vnd.comicbook+zip":{"source":"iana","compressible":false},"application/vnd.comicbook-rar":{"source":"iana"},"application/vnd.commerce-battelle":{"source":"iana"},"application/vnd.commonspace":{"source":"iana","extensions":["csp"]},"application/vnd.contact.cmsg":{"source":"iana","extensions":["cdbcmsg"]},"application/vnd.coreos.ignition+json":{"source":"iana","compressible":true},"application/vnd.cosmocaller":{"source":"iana","extensions":["cmc"]},"application/vnd.crick.clicker":{"source":"iana","extensions":["clkx"]},"application/vnd.crick.clicker.keyboard":{"source":"iana","extensions":["clkk"]},"application/vnd.crick.clicker.palette":{"source":"iana","extensions":["clkp"]},"application/vnd.crick.clicker.template":{"source":"iana","extensions":["clkt"]},"application/vnd.crick.clicker.wordbank":{"source":"iana","extensions":["clkw"]},"application/vnd.criticaltools.wbs+xml":{"source":"iana","compressible":true,"extensions":["wbs"]},"application/vnd.ctc-posml":{"source":"iana","extensions":["pml"]},"application/vnd.ctct.ws+xml":{"source":"iana","compressible":true},"application/vnd.cups-pdf":{"source":"iana"},"application/vnd.cups-postscript":{"source":"iana"},"application/vnd.cups-ppd":{"source":"iana","extensions":["ppd"]},"application/vnd.cups-raster":{"source":"iana"},"application/vnd.cups-raw":{"source":"iana"},"application/vnd.curl":{"source":"iana"},"application/vnd.curl.car":{"source":"apache","extensions":["car"]},"application/vnd.curl.pcurl":{"source":"apache","extensions":["pcurl"]},"application/vnd.cyan.dean.root+xml":{"source":"iana","compressible":true},"application/vnd.cybank":{"source":"iana"},"application/vnd.d2l.coursepackage1p0+zip":{"source":"iana","compressible":false},"application/vnd.dart":{"source":"iana","compressible":true,"extensions":["dart"]},"application/vnd.data-vision.rdz":{"source":"iana","extensions":["rdz"]},"application/vnd.datapackage+json":{"source":"iana","compressible":true},"application/vnd.dataresource+json":{"source":"iana","compressible":true},"application/vnd.debian.binary-package":{"source":"iana"},"application/vnd.dece.data":{"source":"iana","extensions":["uvf","uvvf","uvd","uvvd"]},"application/vnd.dece.ttml+xml":{"source":"iana","compressible":true,"extensions":["uvt","uvvt"]},"application/vnd.dece.unspecified":{"source":"iana","extensions":["uvx","uvvx"]},"application/vnd.dece.zip":{"source":"iana","extensions":["uvz","uvvz"]},"application/vnd.denovo.fcselayout-link":{"source":"iana","extensions":["fe_launch"]},"application/vnd.desmume.movie":{"source":"iana"},"application/vnd.dir-bi.plate-dl-nosuffix":{"source":"iana"},"application/vnd.dm.delegation+xml":{"source":"iana","compressible":true},"application/vnd.dna":{"source":"iana","extensions":["dna"]},"application/vnd.document+json":{"source":"iana","compressible":true},"application/vnd.dolby.mlp":{"source":"apache","extensions":["mlp"]},"application/vnd.dolby.mobile.1":{"source":"iana"},"application/vnd.dolby.mobile.2":{"source":"iana"},"application/vnd.doremir.scorecloud-binary-document":{"source":"iana"},"application/vnd.dpgraph":{"source":"iana","extensions":["dpg"]},"application/vnd.dreamfactory":{"source":"iana","extensions":["dfac"]},"application/vnd.drive+json":{"source":"iana","compressible":true},"application/vnd.ds-keypoint":{"source":"apache","extensions":["kpxx"]},"application/vnd.dtg.local":{"source":"iana"},"application/vnd.dtg.local.flash":{"source":"iana"},"application/vnd.dtg.local.html":{"source":"iana"},"application/vnd.dvb.ait":{"source":"iana","extensions":["ait"]},"application/vnd.dvb.dvbj":{"source":"iana"},"application/vnd.dvb.esgcontainer":{"source":"iana"},"application/vnd.dvb.ipdcdftnotifaccess":{"source":"iana"},"application/vnd.dvb.ipdcesgaccess":{"source":"iana"},"application/vnd.dvb.ipdcesgaccess2":{"source":"iana"},"application/vnd.dvb.ipdcesgpdd":{"source":"iana"},"application/vnd.dvb.ipdcroaming":{"source":"iana"},"application/vnd.dvb.iptv.alfec-base":{"source":"iana"},"application/vnd.dvb.iptv.alfec-enhancement":{"source":"iana"},"application/vnd.dvb.notif-aggregate-root+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-container+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-generic+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-msglist+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-registration-request+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-registration-response+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-init+xml":{"source":"iana","compressible":true},"application/vnd.dvb.pfr":{"source":"iana"},"application/vnd.dvb.service":{"source":"iana","extensions":["svc"]},"application/vnd.dxr":{"source":"iana"},"application/vnd.dynageo":{"source":"iana","extensions":["geo"]},"application/vnd.dzr":{"source":"iana"},"application/vnd.easykaraoke.cdgdownload":{"source":"iana"},"application/vnd.ecdis-update":{"source":"iana"},"application/vnd.ecip.rlp":{"source":"iana"},"application/vnd.ecowin.chart":{"source":"iana","extensions":["mag"]},"application/vnd.ecowin.filerequest":{"source":"iana"},"application/vnd.ecowin.fileupdate":{"source":"iana"},"application/vnd.ecowin.series":{"source":"iana"},"application/vnd.ecowin.seriesrequest":{"source":"iana"},"application/vnd.ecowin.seriesupdate":{"source":"iana"},"application/vnd.efi.img":{"source":"iana"},"application/vnd.efi.iso":{"source":"iana"},"application/vnd.emclient.accessrequest+xml":{"source":"iana","compressible":true},"application/vnd.enliven":{"source":"iana","extensions":["nml"]},"application/vnd.enphase.envoy":{"source":"iana"},"application/vnd.eprints.data+xml":{"source":"iana","compressible":true},"application/vnd.epson.esf":{"source":"iana","extensions":["esf"]},"application/vnd.epson.msf":{"source":"iana","extensions":["msf"]},"application/vnd.epson.quickanime":{"source":"iana","extensions":["qam"]},"application/vnd.epson.salt":{"source":"iana","extensions":["slt"]},"application/vnd.epson.ssf":{"source":"iana","extensions":["ssf"]},"application/vnd.ericsson.quickcall":{"source":"iana"},"application/vnd.espass-espass+zip":{"source":"iana","compressible":false},"application/vnd.eszigno3+xml":{"source":"iana","compressible":true,"extensions":["es3","et3"]},"application/vnd.etsi.aoc+xml":{"source":"iana","compressible":true},"application/vnd.etsi.asic-e+zip":{"source":"iana","compressible":false},"application/vnd.etsi.asic-s+zip":{"source":"iana","compressible":false},"application/vnd.etsi.cug+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvcommand+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvdiscovery+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvprofile+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-bc+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-cod+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-npvr+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvservice+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsync+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvueprofile+xml":{"source":"iana","compressible":true},"application/vnd.etsi.mcid+xml":{"source":"iana","compressible":true},"application/vnd.etsi.mheg5":{"source":"iana"},"application/vnd.etsi.overload-control-policy-dataset+xml":{"source":"iana","compressible":true},"application/vnd.etsi.pstn+xml":{"source":"iana","compressible":true},"application/vnd.etsi.sci+xml":{"source":"iana","compressible":true},"application/vnd.etsi.simservs+xml":{"source":"iana","compressible":true},"application/vnd.etsi.timestamp-token":{"source":"iana"},"application/vnd.etsi.tsl+xml":{"source":"iana","compressible":true},"application/vnd.etsi.tsl.der":{"source":"iana"},"application/vnd.eudora.data":{"source":"iana"},"application/vnd.evolv.ecig.profile":{"source":"iana"},"application/vnd.evolv.ecig.settings":{"source":"iana"},"application/vnd.evolv.ecig.theme":{"source":"iana"},"application/vnd.ezpix-album":{"source":"iana","extensions":["ez2"]},"application/vnd.ezpix-package":{"source":"iana","extensions":["ez3"]},"application/vnd.f-secure.mobile":{"source":"iana"},"application/vnd.fastcopy-disk-image":{"source":"iana"},"application/vnd.fdf":{"source":"iana","extensions":["fdf"]},"application/vnd.fdsn.mseed":{"source":"iana","extensions":["mseed"]},"application/vnd.fdsn.seed":{"source":"iana","extensions":["seed","dataless"]},"application/vnd.ffsns":{"source":"iana"},"application/vnd.filmit.zfc":{"source":"iana"},"application/vnd.fints":{"source":"iana"},"application/vnd.firemonkeys.cloudcell":{"source":"iana"},"application/vnd.flographit":{"source":"iana","extensions":["gph"]},"application/vnd.fluxtime.clip":{"source":"iana","extensions":["ftc"]},"application/vnd.font-fontforge-sfd":{"source":"iana"},"application/vnd.framemaker":{"source":"iana","extensions":["fm","frame","maker","book"]},"application/vnd.frogans.fnc":{"source":"iana","extensions":["fnc"]},"application/vnd.frogans.ltf":{"source":"iana","extensions":["ltf"]},"application/vnd.fsc.weblaunch":{"source":"iana","extensions":["fsc"]},"application/vnd.fujitsu.oasys":{"source":"iana","extensions":["oas"]},"application/vnd.fujitsu.oasys2":{"source":"iana","extensions":["oa2"]},"application/vnd.fujitsu.oasys3":{"source":"iana","extensions":["oa3"]},"application/vnd.fujitsu.oasysgp":{"source":"iana","extensions":["fg5"]},"application/vnd.fujitsu.oasysprs":{"source":"iana","extensions":["bh2"]},"application/vnd.fujixerox.art-ex":{"source":"iana"},"application/vnd.fujixerox.art4":{"source":"iana"},"application/vnd.fujixerox.ddd":{"source":"iana","extensions":["ddd"]},"application/vnd.fujixerox.docuworks":{"source":"iana","extensions":["xdw"]},"application/vnd.fujixerox.docuworks.binder":{"source":"iana","extensions":["xbd"]},"application/vnd.fujixerox.docuworks.container":{"source":"iana"},"application/vnd.fujixerox.hbpl":{"source":"iana"},"application/vnd.fut-misnet":{"source":"iana"},"application/vnd.futoin+json":{"source":"iana","compressible":true},"application/vnd.fuzzysheet":{"source":"iana","extensions":["fzs"]},"application/vnd.genomatix.tuxedo":{"source":"iana","extensions":["txd"]},"application/vnd.geo+json":{"source":"iana","compressible":true},"application/vnd.geocube+xml":{"source":"iana","compressible":true},"application/vnd.geogebra.file":{"source":"iana","extensions":["ggb"]},"application/vnd.geogebra.tool":{"source":"iana","extensions":["ggt"]},"application/vnd.geometry-explorer":{"source":"iana","extensions":["gex","gre"]},"application/vnd.geonext":{"source":"iana","extensions":["gxt"]},"application/vnd.geoplan":{"source":"iana","extensions":["g2w"]},"application/vnd.geospace":{"source":"iana","extensions":["g3w"]},"application/vnd.gerber":{"source":"iana"},"application/vnd.globalplatform.card-content-mgt":{"source":"iana"},"application/vnd.globalplatform.card-content-mgt-response":{"source":"iana"},"application/vnd.gmx":{"source":"iana","extensions":["gmx"]},"application/vnd.google-apps.document":{"compressible":false,"extensions":["gdoc"]},"application/vnd.google-apps.presentation":{"compressible":false,"extensions":["gslides"]},"application/vnd.google-apps.spreadsheet":{"compressible":false,"extensions":["gsheet"]},"application/vnd.google-earth.kml+xml":{"source":"iana","compressible":true,"extensions":["kml"]},"application/vnd.google-earth.kmz":{"source":"iana","compressible":false,"extensions":["kmz"]},"application/vnd.gov.sk.e-form+xml":{"source":"iana","compressible":true},"application/vnd.gov.sk.e-form+zip":{"source":"iana","compressible":false},"application/vnd.gov.sk.xmldatacontainer+xml":{"source":"iana","compressible":true},"application/vnd.grafeq":{"source":"iana","extensions":["gqf","gqs"]},"application/vnd.gridmp":{"source":"iana"},"application/vnd.groove-account":{"source":"iana","extensions":["gac"]},"application/vnd.groove-help":{"source":"iana","extensions":["ghf"]},"application/vnd.groove-identity-message":{"source":"iana","extensions":["gim"]},"application/vnd.groove-injector":{"source":"iana","extensions":["grv"]},"application/vnd.groove-tool-message":{"source":"iana","extensions":["gtm"]},"application/vnd.groove-tool-template":{"source":"iana","extensions":["tpl"]},"application/vnd.groove-vcard":{"source":"iana","extensions":["vcg"]},"application/vnd.hal+json":{"source":"iana","compressible":true},"application/vnd.hal+xml":{"source":"iana","compressible":true,"extensions":["hal"]},"application/vnd.handheld-entertainment+xml":{"source":"iana","compressible":true,"extensions":["zmm"]},"application/vnd.hbci":{"source":"iana","extensions":["hbci"]},"application/vnd.hc+json":{"source":"iana","compressible":true},"application/vnd.hcl-bireports":{"source":"iana"},"application/vnd.hdt":{"source":"iana"},"application/vnd.heroku+json":{"source":"iana","compressible":true},"application/vnd.hhe.lesson-player":{"source":"iana","extensions":["les"]},"application/vnd.hp-hpgl":{"source":"iana","extensions":["hpgl"]},"application/vnd.hp-hpid":{"source":"iana","extensions":["hpid"]},"application/vnd.hp-hps":{"source":"iana","extensions":["hps"]},"application/vnd.hp-jlyt":{"source":"iana","extensions":["jlt"]},"application/vnd.hp-pcl":{"source":"iana","extensions":["pcl"]},"application/vnd.hp-pclxl":{"source":"iana","extensions":["pclxl"]},"application/vnd.httphone":{"source":"iana"},"application/vnd.hydrostatix.sof-data":{"source":"iana","extensions":["sfd-hdstx"]},"application/vnd.hyper+json":{"source":"iana","compressible":true},"application/vnd.hyper-item+json":{"source":"iana","compressible":true},"application/vnd.hyperdrive+json":{"source":"iana","compressible":true},"application/vnd.hzn-3d-crossword":{"source":"iana"},"application/vnd.ibm.afplinedata":{"source":"iana"},"application/vnd.ibm.electronic-media":{"source":"iana"},"application/vnd.ibm.minipay":{"source":"iana","extensions":["mpy"]},"application/vnd.ibm.modcap":{"source":"iana","extensions":["afp","listafp","list3820"]},"application/vnd.ibm.rights-management":{"source":"iana","extensions":["irm"]},"application/vnd.ibm.secure-container":{"source":"iana","extensions":["sc"]},"application/vnd.iccprofile":{"source":"iana","extensions":["icc","icm"]},"application/vnd.ieee.1905":{"source":"iana"},"application/vnd.igloader":{"source":"iana","extensions":["igl"]},"application/vnd.imagemeter.folder+zip":{"source":"iana","compressible":false},"application/vnd.imagemeter.image+zip":{"source":"iana","compressible":false},"application/vnd.immervision-ivp":{"source":"iana","extensions":["ivp"]},"application/vnd.immervision-ivu":{"source":"iana","extensions":["ivu"]},"application/vnd.ims.imsccv1p1":{"source":"iana"},"application/vnd.ims.imsccv1p2":{"source":"iana"},"application/vnd.ims.imsccv1p3":{"source":"iana"},"application/vnd.ims.lis.v2.result+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolconsumerprofile+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolproxy+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolproxy.id+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolsettings+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolsettings.simple+json":{"source":"iana","compressible":true},"application/vnd.informedcontrol.rms+xml":{"source":"iana","compressible":true},"application/vnd.informix-visionary":{"source":"iana"},"application/vnd.infotech.project":{"source":"iana"},"application/vnd.infotech.project+xml":{"source":"iana","compressible":true},"application/vnd.innopath.wamp.notification":{"source":"iana"},"application/vnd.insors.igm":{"source":"iana","extensions":["igm"]},"application/vnd.intercon.formnet":{"source":"iana","extensions":["xpw","xpx"]},"application/vnd.intergeo":{"source":"iana","extensions":["i2g"]},"application/vnd.intertrust.digibox":{"source":"iana"},"application/vnd.intertrust.nncp":{"source":"iana"},"application/vnd.intu.qbo":{"source":"iana","extensions":["qbo"]},"application/vnd.intu.qfx":{"source":"iana","extensions":["qfx"]},"application/vnd.iptc.g2.catalogitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.conceptitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.knowledgeitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.newsitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.newsmessage+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.packageitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.planningitem+xml":{"source":"iana","compressible":true},"application/vnd.ipunplugged.rcprofile":{"source":"iana","extensions":["rcprofile"]},"application/vnd.irepository.package+xml":{"source":"iana","compressible":true,"extensions":["irp"]},"application/vnd.is-xpr":{"source":"iana","extensions":["xpr"]},"application/vnd.isac.fcs":{"source":"iana","extensions":["fcs"]},"application/vnd.jam":{"source":"iana","extensions":["jam"]},"application/vnd.japannet-directory-service":{"source":"iana"},"application/vnd.japannet-jpnstore-wakeup":{"source":"iana"},"application/vnd.japannet-payment-wakeup":{"source":"iana"},"application/vnd.japannet-registration":{"source":"iana"},"application/vnd.japannet-registration-wakeup":{"source":"iana"},"application/vnd.japannet-setstore-wakeup":{"source":"iana"},"application/vnd.japannet-verification":{"source":"iana"},"application/vnd.japannet-verification-wakeup":{"source":"iana"},"application/vnd.jcp.javame.midlet-rms":{"source":"iana","extensions":["rms"]},"application/vnd.jisp":{"source":"iana","extensions":["jisp"]},"application/vnd.joost.joda-archive":{"source":"iana","extensions":["joda"]},"application/vnd.jsk.isdn-ngn":{"source":"iana"},"application/vnd.kahootz":{"source":"iana","extensions":["ktz","ktr"]},"application/vnd.kde.karbon":{"source":"iana","extensions":["karbon"]},"application/vnd.kde.kchart":{"source":"iana","extensions":["chrt"]},"application/vnd.kde.kformula":{"source":"iana","extensions":["kfo"]},"application/vnd.kde.kivio":{"source":"iana","extensions":["flw"]},"application/vnd.kde.kontour":{"source":"iana","extensions":["kon"]},"application/vnd.kde.kpresenter":{"source":"iana","extensions":["kpr","kpt"]},"application/vnd.kde.kspread":{"source":"iana","extensions":["ksp"]},"application/vnd.kde.kword":{"source":"iana","extensions":["kwd","kwt"]},"application/vnd.kenameaapp":{"source":"iana","extensions":["htke"]},"application/vnd.kidspiration":{"source":"iana","extensions":["kia"]},"application/vnd.kinar":{"source":"iana","extensions":["kne","knp"]},"application/vnd.koan":{"source":"iana","extensions":["skp","skd","skt","skm"]},"application/vnd.kodak-descriptor":{"source":"iana","extensions":["sse"]},"application/vnd.las.las+json":{"source":"iana","compressible":true},"application/vnd.las.las+xml":{"source":"iana","compressible":true,"extensions":["lasxml"]},"application/vnd.leap+json":{"source":"iana","compressible":true},"application/vnd.liberty-request+xml":{"source":"iana","compressible":true},"application/vnd.llamagraphics.life-balance.desktop":{"source":"iana","extensions":["lbd"]},"application/vnd.llamagraphics.life-balance.exchange+xml":{"source":"iana","compressible":true,"extensions":["lbe"]},"application/vnd.lotus-1-2-3":{"source":"iana","extensions":["123"]},"application/vnd.lotus-approach":{"source":"iana","extensions":["apr"]},"application/vnd.lotus-freelance":{"source":"iana","extensions":["pre"]},"application/vnd.lotus-notes":{"source":"iana","extensions":["nsf"]},"application/vnd.lotus-organizer":{"source":"iana","extensions":["org"]},"application/vnd.lotus-screencam":{"source":"iana","extensions":["scm"]},"application/vnd.lotus-wordpro":{"source":"iana","extensions":["lwp"]},"application/vnd.macports.portpkg":{"source":"iana","extensions":["portpkg"]},"application/vnd.mapbox-vector-tile":{"source":"iana"},"application/vnd.marlin.drm.actiontoken+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.conftoken+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.license+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.mdcf":{"source":"iana"},"application/vnd.mason+json":{"source":"iana","compressible":true},"application/vnd.maxmind.maxmind-db":{"source":"iana"},"application/vnd.mcd":{"source":"iana","extensions":["mcd"]},"application/vnd.medcalcdata":{"source":"iana","extensions":["mc1"]},"application/vnd.mediastation.cdkey":{"source":"iana","extensions":["cdkey"]},"application/vnd.meridian-slingshot":{"source":"iana"},"application/vnd.mfer":{"source":"iana","extensions":["mwf"]},"application/vnd.mfmp":{"source":"iana","extensions":["mfm"]},"application/vnd.micro+json":{"source":"iana","compressible":true},"application/vnd.micrografx.flo":{"source":"iana","extensions":["flo"]},"application/vnd.micrografx.igx":{"source":"iana","extensions":["igx"]},"application/vnd.microsoft.portable-executable":{"source":"iana"},"application/vnd.microsoft.windows.thumbnail-cache":{"source":"iana"},"application/vnd.miele+json":{"source":"iana","compressible":true},"application/vnd.mif":{"source":"iana","extensions":["mif"]},"application/vnd.minisoft-hp3000-save":{"source":"iana"},"application/vnd.mitsubishi.misty-guard.trustweb":{"source":"iana"},"application/vnd.mobius.daf":{"source":"iana","extensions":["daf"]},"application/vnd.mobius.dis":{"source":"iana","extensions":["dis"]},"application/vnd.mobius.mbk":{"source":"iana","extensions":["mbk"]},"application/vnd.mobius.mqy":{"source":"iana","extensions":["mqy"]},"application/vnd.mobius.msl":{"source":"iana","extensions":["msl"]},"application/vnd.mobius.plc":{"source":"iana","extensions":["plc"]},"application/vnd.mobius.txf":{"source":"iana","extensions":["txf"]},"application/vnd.mophun.application":{"source":"iana","extensions":["mpn"]},"application/vnd.mophun.certificate":{"source":"iana","extensions":["mpc"]},"application/vnd.motorola.flexsuite":{"source":"iana"},"application/vnd.motorola.flexsuite.adsi":{"source":"iana"},"application/vnd.motorola.flexsuite.fis":{"source":"iana"},"application/vnd.motorola.flexsuite.gotap":{"source":"iana"},"application/vnd.motorola.flexsuite.kmr":{"source":"iana"},"application/vnd.motorola.flexsuite.ttc":{"source":"iana"},"application/vnd.motorola.flexsuite.wem":{"source":"iana"},"application/vnd.motorola.iprm":{"source":"iana"},"application/vnd.mozilla.xul+xml":{"source":"iana","compressible":true,"extensions":["xul"]},"application/vnd.ms-3mfdocument":{"source":"iana"},"application/vnd.ms-artgalry":{"source":"iana","extensions":["cil"]},"application/vnd.ms-asf":{"source":"iana"},"application/vnd.ms-cab-compressed":{"source":"iana","extensions":["cab"]},"application/vnd.ms-color.iccprofile":{"source":"apache"},"application/vnd.ms-excel":{"source":"iana","compressible":false,"extensions":["xls","xlm","xla","xlc","xlt","xlw"]},"application/vnd.ms-excel.addin.macroenabled.12":{"source":"iana","extensions":["xlam"]},"application/vnd.ms-excel.sheet.binary.macroenabled.12":{"source":"iana","extensions":["xlsb"]},"application/vnd.ms-excel.sheet.macroenabled.12":{"source":"iana","extensions":["xlsm"]},"application/vnd.ms-excel.template.macroenabled.12":{"source":"iana","extensions":["xltm"]},"application/vnd.ms-fontobject":{"source":"iana","compressible":true,"extensions":["eot"]},"application/vnd.ms-htmlhelp":{"source":"iana","extensions":["chm"]},"application/vnd.ms-ims":{"source":"iana","extensions":["ims"]},"application/vnd.ms-lrm":{"source":"iana","extensions":["lrm"]},"application/vnd.ms-office.activex+xml":{"source":"iana","compressible":true},"application/vnd.ms-officetheme":{"source":"iana","extensions":["thmx"]},"application/vnd.ms-opentype":{"source":"apache","compressible":true},"application/vnd.ms-outlook":{"compressible":false,"extensions":["msg"]},"application/vnd.ms-package.obfuscated-opentype":{"source":"apache"},"application/vnd.ms-pki.seccat":{"source":"apache","extensions":["cat"]},"application/vnd.ms-pki.stl":{"source":"apache","extensions":["stl"]},"application/vnd.ms-playready.initiator+xml":{"source":"iana","compressible":true},"application/vnd.ms-powerpoint":{"source":"iana","compressible":false,"extensions":["ppt","pps","pot"]},"application/vnd.ms-powerpoint.addin.macroenabled.12":{"source":"iana","extensions":["ppam"]},"application/vnd.ms-powerpoint.presentation.macroenabled.12":{"source":"iana","extensions":["pptm"]},"application/vnd.ms-powerpoint.slide.macroenabled.12":{"source":"iana","extensions":["sldm"]},"application/vnd.ms-powerpoint.slideshow.macroenabled.12":{"source":"iana","extensions":["ppsm"]},"application/vnd.ms-powerpoint.template.macroenabled.12":{"source":"iana","extensions":["potm"]},"application/vnd.ms-printdevicecapabilities+xml":{"source":"iana","compressible":true},"application/vnd.ms-printing.printticket+xml":{"source":"apache","compressible":true},"application/vnd.ms-printschematicket+xml":{"source":"iana","compressible":true},"application/vnd.ms-project":{"source":"iana","extensions":["mpp","mpt"]},"application/vnd.ms-tnef":{"source":"iana"},"application/vnd.ms-windows.devicepairing":{"source":"iana"},"application/vnd.ms-windows.nwprinting.oob":{"source":"iana"},"application/vnd.ms-windows.printerpairing":{"source":"iana"},"application/vnd.ms-windows.wsd.oob":{"source":"iana"},"application/vnd.ms-wmdrm.lic-chlg-req":{"source":"iana"},"application/vnd.ms-wmdrm.lic-resp":{"source":"iana"},"application/vnd.ms-wmdrm.meter-chlg-req":{"source":"iana"},"application/vnd.ms-wmdrm.meter-resp":{"source":"iana"},"application/vnd.ms-word.document.macroenabled.12":{"source":"iana","extensions":["docm"]},"application/vnd.ms-word.template.macroenabled.12":{"source":"iana","extensions":["dotm"]},"application/vnd.ms-works":{"source":"iana","extensions":["wps","wks","wcm","wdb"]},"application/vnd.ms-wpl":{"source":"iana","extensions":["wpl"]},"application/vnd.ms-xpsdocument":{"source":"iana","compressible":false,"extensions":["xps"]},"application/vnd.msa-disk-image":{"source":"iana"},"application/vnd.mseq":{"source":"iana","extensions":["mseq"]},"application/vnd.msign":{"source":"iana"},"application/vnd.multiad.creator":{"source":"iana"},"application/vnd.multiad.creator.cif":{"source":"iana"},"application/vnd.music-niff":{"source":"iana"},"application/vnd.musician":{"source":"iana","extensions":["mus"]},"application/vnd.muvee.style":{"source":"iana","extensions":["msty"]},"application/vnd.mynfc":{"source":"iana","extensions":["taglet"]},"application/vnd.ncd.control":{"source":"iana"},"application/vnd.ncd.reference":{"source":"iana"},"application/vnd.nearst.inv+json":{"source":"iana","compressible":true},"application/vnd.nervana":{"source":"iana"},"application/vnd.netfpx":{"source":"iana"},"application/vnd.neurolanguage.nlu":{"source":"iana","extensions":["nlu"]},"application/vnd.nimn":{"source":"iana"},"application/vnd.nintendo.nitro.rom":{"source":"iana"},"application/vnd.nintendo.snes.rom":{"source":"iana"},"application/vnd.nitf":{"source":"iana","extensions":["ntf","nitf"]},"application/vnd.noblenet-directory":{"source":"iana","extensions":["nnd"]},"application/vnd.noblenet-sealer":{"source":"iana","extensions":["nns"]},"application/vnd.noblenet-web":{"source":"iana","extensions":["nnw"]},"application/vnd.nokia.catalogs":{"source":"iana"},"application/vnd.nokia.conml+wbxml":{"source":"iana"},"application/vnd.nokia.conml+xml":{"source":"iana","compressible":true},"application/vnd.nokia.iptv.config+xml":{"source":"iana","compressible":true},"application/vnd.nokia.isds-radio-presets":{"source":"iana"},"application/vnd.nokia.landmark+wbxml":{"source":"iana"},"application/vnd.nokia.landmark+xml":{"source":"iana","compressible":true},"application/vnd.nokia.landmarkcollection+xml":{"source":"iana","compressible":true},"application/vnd.nokia.n-gage.ac+xml":{"source":"iana","compressible":true},"application/vnd.nokia.n-gage.data":{"source":"iana","extensions":["ngdat"]},"application/vnd.nokia.n-gage.symbian.install":{"source":"iana","extensions":["n-gage"]},"application/vnd.nokia.ncd":{"source":"iana"},"application/vnd.nokia.pcd+wbxml":{"source":"iana"},"application/vnd.nokia.pcd+xml":{"source":"iana","compressible":true},"application/vnd.nokia.radio-preset":{"source":"iana","extensions":["rpst"]},"application/vnd.nokia.radio-presets":{"source":"iana","extensions":["rpss"]},"application/vnd.novadigm.edm":{"source":"iana","extensions":["edm"]},"application/vnd.novadigm.edx":{"source":"iana","extensions":["edx"]},"application/vnd.novadigm.ext":{"source":"iana","extensions":["ext"]},"application/vnd.ntt-local.content-share":{"source":"iana"},"application/vnd.ntt-local.file-transfer":{"source":"iana"},"application/vnd.ntt-local.ogw_remote-access":{"source":"iana"},"application/vnd.ntt-local.sip-ta_remote":{"source":"iana"},"application/vnd.ntt-local.sip-ta_tcp_stream":{"source":"iana"},"application/vnd.oasis.opendocument.chart":{"source":"iana","extensions":["odc"]},"application/vnd.oasis.opendocument.chart-template":{"source":"iana","extensions":["otc"]},"application/vnd.oasis.opendocument.database":{"source":"iana","extensions":["odb"]},"application/vnd.oasis.opendocument.formula":{"source":"iana","extensions":["odf"]},"application/vnd.oasis.opendocument.formula-template":{"source":"iana","extensions":["odft"]},"application/vnd.oasis.opendocument.graphics":{"source":"iana","compressible":false,"extensions":["odg"]},"application/vnd.oasis.opendocument.graphics-template":{"source":"iana","extensions":["otg"]},"application/vnd.oasis.opendocument.image":{"source":"iana","extensions":["odi"]},"application/vnd.oasis.opendocument.image-template":{"source":"iana","extensions":["oti"]},"application/vnd.oasis.opendocument.presentation":{"source":"iana","compressible":false,"extensions":["odp"]},"application/vnd.oasis.opendocument.presentation-template":{"source":"iana","extensions":["otp"]},"application/vnd.oasis.opendocument.spreadsheet":{"source":"iana","compressible":false,"extensions":["ods"]},"application/vnd.oasis.opendocument.spreadsheet-template":{"source":"iana","extensions":["ots"]},"application/vnd.oasis.opendocument.text":{"source":"iana","compressible":false,"extensions":["odt"]},"application/vnd.oasis.opendocument.text-master":{"source":"iana","extensions":["odm"]},"application/vnd.oasis.opendocument.text-template":{"source":"iana","extensions":["ott"]},"application/vnd.oasis.opendocument.text-web":{"source":"iana","extensions":["oth"]},"application/vnd.obn":{"source":"iana"},"application/vnd.ocf+cbor":{"source":"iana"},"application/vnd.oftn.l10n+json":{"source":"iana","compressible":true},"application/vnd.oipf.contentaccessdownload+xml":{"source":"iana","compressible":true},"application/vnd.oipf.contentaccessstreaming+xml":{"source":"iana","compressible":true},"application/vnd.oipf.cspg-hexbinary":{"source":"iana"},"application/vnd.oipf.dae.svg+xml":{"source":"iana","compressible":true},"application/vnd.oipf.dae.xhtml+xml":{"source":"iana","compressible":true},"application/vnd.oipf.mippvcontrolmessage+xml":{"source":"iana","compressible":true},"application/vnd.oipf.pae.gem":{"source":"iana"},"application/vnd.oipf.spdiscovery+xml":{"source":"iana","compressible":true},"application/vnd.oipf.spdlist+xml":{"source":"iana","compressible":true},"application/vnd.oipf.ueprofile+xml":{"source":"iana","compressible":true},"application/vnd.oipf.userprofile+xml":{"source":"iana","compressible":true},"application/vnd.olpc-sugar":{"source":"iana","extensions":["xo"]},"application/vnd.oma-scws-config":{"source":"iana"},"application/vnd.oma-scws-http-request":{"source":"iana"},"application/vnd.oma-scws-http-response":{"source":"iana"},"application/vnd.oma.bcast.associated-procedure-parameter+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.drm-trigger+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.imd+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.ltkm":{"source":"iana"},"application/vnd.oma.bcast.notification+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.provisioningtrigger":{"source":"iana"},"application/vnd.oma.bcast.sgboot":{"source":"iana"},"application/vnd.oma.bcast.sgdd+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.sgdu":{"source":"iana"},"application/vnd.oma.bcast.simple-symbol-container":{"source":"iana"},"application/vnd.oma.bcast.smartcard-trigger+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.sprov+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.stkm":{"source":"iana"},"application/vnd.oma.cab-address-book+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-feature-handler+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-pcc+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-subs-invite+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-user-prefs+xml":{"source":"iana","compressible":true},"application/vnd.oma.dcd":{"source":"iana"},"application/vnd.oma.dcdc":{"source":"iana"},"application/vnd.oma.dd2+xml":{"source":"iana","compressible":true,"extensions":["dd2"]},"application/vnd.oma.drm.risd+xml":{"source":"iana","compressible":true},"application/vnd.oma.group-usage-list+xml":{"source":"iana","compressible":true},"application/vnd.oma.lwm2m+json":{"source":"iana","compressible":true},"application/vnd.oma.lwm2m+tlv":{"source":"iana"},"application/vnd.oma.pal+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.detailed-progress-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.final-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.groups+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.invocation-descriptor+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.optimized-progress-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.push":{"source":"iana"},"application/vnd.oma.scidm.messages+xml":{"source":"iana","compressible":true},"application/vnd.oma.xcap-directory+xml":{"source":"iana","compressible":true},"application/vnd.omads-email+xml":{"source":"iana","compressible":true},"application/vnd.omads-file+xml":{"source":"iana","compressible":true},"application/vnd.omads-folder+xml":{"source":"iana","compressible":true},"application/vnd.omaloc-supl-init":{"source":"iana"},"application/vnd.onepager":{"source":"iana"},"application/vnd.onepagertamp":{"source":"iana"},"application/vnd.onepagertamx":{"source":"iana"},"application/vnd.onepagertat":{"source":"iana"},"application/vnd.onepagertatp":{"source":"iana"},"application/vnd.onepagertatx":{"source":"iana"},"application/vnd.openblox.game+xml":{"source":"iana","compressible":true},"application/vnd.openblox.game-binary":{"source":"iana"},"application/vnd.openeye.oeb":{"source":"iana"},"application/vnd.openofficeorg.extension":{"source":"apache","extensions":["oxt"]},"application/vnd.openstreetmap.data+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.custom-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.customxmlproperties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawing+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.chart+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramcolors+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramdata+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramlayout+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramstyle+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.extended-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.commentauthors+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.handoutmaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.notesmaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.notesslide+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.presentation":{"source":"iana","compressible":false,"extensions":["pptx"]},"application/vnd.openxmlformats-officedocument.presentationml.presentation.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.presprops+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slide":{"source":"iana","extensions":["sldx"]},"application/vnd.openxmlformats-officedocument.presentationml.slide+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slidelayout+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slidemaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slideshow":{"source":"iana","extensions":["ppsx"]},"application/vnd.openxmlformats-officedocument.presentationml.slideshow.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slideupdateinfo+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.tablestyles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.tags+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.template":{"source":"iana","extensions":["potx"]},"application/vnd.openxmlformats-officedocument.presentationml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.viewprops+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.calcchain+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.externallink+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcachedefinition+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcacherecords+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivottable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.querytable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionheaders+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionlog+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedstrings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":{"source":"iana","compressible":false,"extensions":["xlsx"]},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetmetadata+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.tablesinglecells+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.template":{"source":"iana","extensions":["xltx"]},"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.usernames+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.volatiledependencies+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.theme+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.themeoverride+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.vmldrawing":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.document":{"source":"iana","compressible":false,"extensions":["docx"]},"application/vnd.openxmlformats-officedocument.wordprocessingml.document.glossary+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.endnotes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.fonttable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.settings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.template":{"source":"iana","extensions":["dotx"]},"application/vnd.openxmlformats-officedocument.wordprocessingml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.websettings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.core-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.digital-signature-xmlsignature+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.relationships+xml":{"source":"iana","compressible":true},"application/vnd.oracle.resource+json":{"source":"iana","compressible":true},"application/vnd.orange.indata":{"source":"iana"},"application/vnd.osa.netdeploy":{"source":"iana"},"application/vnd.osgeo.mapguide.package":{"source":"iana","extensions":["mgp"]},"application/vnd.osgi.bundle":{"source":"iana"},"application/vnd.osgi.dp":{"source":"iana","extensions":["dp"]},"application/vnd.osgi.subsystem":{"source":"iana","extensions":["esa"]},"application/vnd.otps.ct-kip+xml":{"source":"iana","compressible":true},"application/vnd.oxli.countgraph":{"source":"iana"},"application/vnd.pagerduty+json":{"source":"iana","compressible":true},"application/vnd.palm":{"source":"iana","extensions":["pdb","pqa","oprc"]},"application/vnd.panoply":{"source":"iana"},"application/vnd.paos.xml":{"source":"iana"},"application/vnd.patentdive":{"source":"iana"},"application/vnd.pawaafile":{"source":"iana","extensions":["paw"]},"application/vnd.pcos":{"source":"iana"},"application/vnd.pg.format":{"source":"iana","extensions":["str"]},"application/vnd.pg.osasli":{"source":"iana","extensions":["ei6"]},"application/vnd.piaccess.application-licence":{"source":"iana"},"application/vnd.picsel":{"source":"iana","extensions":["efif"]},"application/vnd.pmi.widget":{"source":"iana","extensions":["wg"]},"application/vnd.poc.group-advertisement+xml":{"source":"iana","compressible":true},"application/vnd.pocketlearn":{"source":"iana","extensions":["plf"]},"application/vnd.powerbuilder6":{"source":"iana","extensions":["pbd"]},"application/vnd.powerbuilder6-s":{"source":"iana"},"application/vnd.powerbuilder7":{"source":"iana"},"application/vnd.powerbuilder7-s":{"source":"iana"},"application/vnd.powerbuilder75":{"source":"iana"},"application/vnd.powerbuilder75-s":{"source":"iana"},"application/vnd.preminet":{"source":"iana"},"application/vnd.previewsystems.box":{"source":"iana","extensions":["box"]},"application/vnd.proteus.magazine":{"source":"iana","extensions":["mgz"]},"application/vnd.psfs":{"source":"iana"},"application/vnd.publishare-delta-tree":{"source":"iana","extensions":["qps"]},"application/vnd.pvi.ptid1":{"source":"iana","extensions":["ptid"]},"application/vnd.pwg-multiplexed":{"source":"iana"},"application/vnd.pwg-xhtml-print+xml":{"source":"iana","compressible":true},"application/vnd.qualcomm.brew-app-res":{"source":"iana"},"application/vnd.quarantainenet":{"source":"iana"},"application/vnd.quark.quarkxpress":{"source":"iana","extensions":["qxd","qxt","qwd","qwt","qxl","qxb"]},"application/vnd.quobject-quoxdocument":{"source":"iana"},"application/vnd.radisys.moml+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-conf+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-conn+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-dialog+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-stream+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-conf+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-base+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-fax-detect+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-fax-sendrecv+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-group+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-speech+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-transform+xml":{"source":"iana","compressible":true},"application/vnd.rainstor.data":{"source":"iana"},"application/vnd.rapid":{"source":"iana"},"application/vnd.rar":{"source":"iana"},"application/vnd.realvnc.bed":{"source":"iana","extensions":["bed"]},"application/vnd.recordare.musicxml":{"source":"iana","extensions":["mxl"]},"application/vnd.recordare.musicxml+xml":{"source":"iana","compressible":true,"extensions":["musicxml"]},"application/vnd.renlearn.rlprint":{"source":"iana"},"application/vnd.restful+json":{"source":"iana","compressible":true},"application/vnd.rig.cryptonote":{"source":"iana","extensions":["cryptonote"]},"application/vnd.rim.cod":{"source":"apache","extensions":["cod"]},"application/vnd.rn-realmedia":{"source":"apache","extensions":["rm"]},"application/vnd.rn-realmedia-vbr":{"source":"apache","extensions":["rmvb"]},"application/vnd.route66.link66+xml":{"source":"iana","compressible":true,"extensions":["link66"]},"application/vnd.rs-274x":{"source":"iana"},"application/vnd.ruckus.download":{"source":"iana"},"application/vnd.s3sms":{"source":"iana"},"application/vnd.sailingtracker.track":{"source":"iana","extensions":["st"]},"application/vnd.sbm.cid":{"source":"iana"},"application/vnd.sbm.mid2":{"source":"iana"},"application/vnd.scribus":{"source":"iana"},"application/vnd.sealed.3df":{"source":"iana"},"application/vnd.sealed.csf":{"source":"iana"},"application/vnd.sealed.doc":{"source":"iana"},"application/vnd.sealed.eml":{"source":"iana"},"application/vnd.sealed.mht":{"source":"iana"},"application/vnd.sealed.net":{"source":"iana"},"application/vnd.sealed.ppt":{"source":"iana"},"application/vnd.sealed.tiff":{"source":"iana"},"application/vnd.sealed.xls":{"source":"iana"},"application/vnd.sealedmedia.softseal.html":{"source":"iana"},"application/vnd.sealedmedia.softseal.pdf":{"source":"iana"},"application/vnd.seemail":{"source":"iana","extensions":["see"]},"application/vnd.sema":{"source":"iana","extensions":["sema"]},"application/vnd.semd":{"source":"iana","extensions":["semd"]},"application/vnd.semf":{"source":"iana","extensions":["semf"]},"application/vnd.shana.informed.formdata":{"source":"iana","extensions":["ifm"]},"application/vnd.shana.informed.formtemplate":{"source":"iana","extensions":["itp"]},"application/vnd.shana.informed.interchange":{"source":"iana","extensions":["iif"]},"application/vnd.shana.informed.package":{"source":"iana","extensions":["ipk"]},"application/vnd.shootproof+json":{"source":"iana","compressible":true},"application/vnd.sigrok.session":{"source":"iana"},"application/vnd.simtech-mindmapper":{"source":"iana","extensions":["twd","twds"]},"application/vnd.siren+json":{"source":"iana","compressible":true},"application/vnd.smaf":{"source":"iana","extensions":["mmf"]},"application/vnd.smart.notebook":{"source":"iana"},"application/vnd.smart.teacher":{"source":"iana","extensions":["teacher"]},"application/vnd.software602.filler.form+xml":{"source":"iana","compressible":true},"application/vnd.software602.filler.form-xml-zip":{"source":"iana"},"application/vnd.solent.sdkm+xml":{"source":"iana","compressible":true,"extensions":["sdkm","sdkd"]},"application/vnd.spotfire.dxp":{"source":"iana","extensions":["dxp"]},"application/vnd.spotfire.sfs":{"source":"iana","extensions":["sfs"]},"application/vnd.sqlite3":{"source":"iana"},"application/vnd.sss-cod":{"source":"iana"},"application/vnd.sss-dtf":{"source":"iana"},"application/vnd.sss-ntf":{"source":"iana"},"application/vnd.stardivision.calc":{"source":"apache","extensions":["sdc"]},"application/vnd.stardivision.draw":{"source":"apache","extensions":["sda"]},"application/vnd.stardivision.impress":{"source":"apache","extensions":["sdd"]},"application/vnd.stardivision.math":{"source":"apache","extensions":["smf"]},"application/vnd.stardivision.writer":{"source":"apache","extensions":["sdw","vor"]},"application/vnd.stardivision.writer-global":{"source":"apache","extensions":["sgl"]},"application/vnd.stepmania.package":{"source":"iana","extensions":["smzip"]},"application/vnd.stepmania.stepchart":{"source":"iana","extensions":["sm"]},"application/vnd.street-stream":{"source":"iana"},"application/vnd.sun.wadl+xml":{"source":"iana","compressible":true,"extensions":["wadl"]},"application/vnd.sun.xml.calc":{"source":"apache","extensions":["sxc"]},"application/vnd.sun.xml.calc.template":{"source":"apache","extensions":["stc"]},"application/vnd.sun.xml.draw":{"source":"apache","extensions":["sxd"]},"application/vnd.sun.xml.draw.template":{"source":"apache","extensions":["std"]},"application/vnd.sun.xml.impress":{"source":"apache","extensions":["sxi"]},"application/vnd.sun.xml.impress.template":{"source":"apache","extensions":["sti"]},"application/vnd.sun.xml.math":{"source":"apache","extensions":["sxm"]},"application/vnd.sun.xml.writer":{"source":"apache","extensions":["sxw"]},"application/vnd.sun.xml.writer.global":{"source":"apache","extensions":["sxg"]},"application/vnd.sun.xml.writer.template":{"source":"apache","extensions":["stw"]},"application/vnd.sus-calendar":{"source":"iana","extensions":["sus","susp"]},"application/vnd.svd":{"source":"iana","extensions":["svd"]},"application/vnd.swiftview-ics":{"source":"iana"},"application/vnd.symbian.install":{"source":"apache","extensions":["sis","sisx"]},"application/vnd.syncml+xml":{"source":"iana","compressible":true,"extensions":["xsm"]},"application/vnd.syncml.dm+wbxml":{"source":"iana","extensions":["bdm"]},"application/vnd.syncml.dm+xml":{"source":"iana","compressible":true,"extensions":["xdm"]},"application/vnd.syncml.dm.notification":{"source":"iana"},"application/vnd.syncml.dmddf+wbxml":{"source":"iana"},"application/vnd.syncml.dmddf+xml":{"source":"iana","compressible":true},"application/vnd.syncml.dmtnds+wbxml":{"source":"iana"},"application/vnd.syncml.dmtnds+xml":{"source":"iana","compressible":true},"application/vnd.syncml.ds.notification":{"source":"iana"},"application/vnd.tableschema+json":{"source":"iana","compressible":true},"application/vnd.tao.intent-module-archive":{"source":"iana","extensions":["tao"]},"application/vnd.tcpdump.pcap":{"source":"iana","extensions":["pcap","cap","dmp"]},"application/vnd.think-cell.ppttc+json":{"source":"iana","compressible":true},"application/vnd.tmd.mediaflex.api+xml":{"source":"iana","compressible":true},"application/vnd.tml":{"source":"iana"},"application/vnd.tmobile-livetv":{"source":"iana","extensions":["tmo"]},"application/vnd.tri.onesource":{"source":"iana"},"application/vnd.trid.tpt":{"source":"iana","extensions":["tpt"]},"application/vnd.triscape.mxs":{"source":"iana","extensions":["mxs"]},"application/vnd.trueapp":{"source":"iana","extensions":["tra"]},"application/vnd.truedoc":{"source":"iana"},"application/vnd.ubisoft.webplayer":{"source":"iana"},"application/vnd.ufdl":{"source":"iana","extensions":["ufd","ufdl"]},"application/vnd.uiq.theme":{"source":"iana","extensions":["utz"]},"application/vnd.umajin":{"source":"iana","extensions":["umj"]},"application/vnd.unity":{"source":"iana","extensions":["unityweb"]},"application/vnd.uoml+xml":{"source":"iana","compressible":true,"extensions":["uoml"]},"application/vnd.uplanet.alert":{"source":"iana"},"application/vnd.uplanet.alert-wbxml":{"source":"iana"},"application/vnd.uplanet.bearer-choice":{"source":"iana"},"application/vnd.uplanet.bearer-choice-wbxml":{"source":"iana"},"application/vnd.uplanet.cacheop":{"source":"iana"},"application/vnd.uplanet.cacheop-wbxml":{"source":"iana"},"application/vnd.uplanet.channel":{"source":"iana"},"application/vnd.uplanet.channel-wbxml":{"source":"iana"},"application/vnd.uplanet.list":{"source":"iana"},"application/vnd.uplanet.list-wbxml":{"source":"iana"},"application/vnd.uplanet.listcmd":{"source":"iana"},"application/vnd.uplanet.listcmd-wbxml":{"source":"iana"},"application/vnd.uplanet.signal":{"source":"iana"},"application/vnd.uri-map":{"source":"iana"},"application/vnd.valve.source.material":{"source":"iana"},"application/vnd.vcx":{"source":"iana","extensions":["vcx"]},"application/vnd.vd-study":{"source":"iana"},"application/vnd.vectorworks":{"source":"iana"},"application/vnd.vel+json":{"source":"iana","compressible":true},"application/vnd.verimatrix.vcas":{"source":"iana"},"application/vnd.vidsoft.vidconference":{"source":"iana"},"application/vnd.visio":{"source":"iana","extensions":["vsd","vst","vss","vsw"]},"application/vnd.visionary":{"source":"iana","extensions":["vis"]},"application/vnd.vividence.scriptfile":{"source":"iana"},"application/vnd.vsf":{"source":"iana","extensions":["vsf"]},"application/vnd.wap.sic":{"source":"iana"},"application/vnd.wap.slc":{"source":"iana"},"application/vnd.wap.wbxml":{"source":"iana","extensions":["wbxml"]},"application/vnd.wap.wmlc":{"source":"iana","extensions":["wmlc"]},"application/vnd.wap.wmlscriptc":{"source":"iana","extensions":["wmlsc"]},"application/vnd.webturbo":{"source":"iana","extensions":["wtb"]},"application/vnd.wfa.p2p":{"source":"iana"},"application/vnd.wfa.wsc":{"source":"iana"},"application/vnd.windows.devicepairing":{"source":"iana"},"application/vnd.wmc":{"source":"iana"},"application/vnd.wmf.bootstrap":{"source":"iana"},"application/vnd.wolfram.mathematica":{"source":"iana"},"application/vnd.wolfram.mathematica.package":{"source":"iana"},"application/vnd.wolfram.player":{"source":"iana","extensions":["nbp"]},"application/vnd.wordperfect":{"source":"iana","extensions":["wpd"]},"application/vnd.wqd":{"source":"iana","extensions":["wqd"]},"application/vnd.wrq-hp3000-labelled":{"source":"iana"},"application/vnd.wt.stf":{"source":"iana","extensions":["stf"]},"application/vnd.wv.csp+wbxml":{"source":"iana"},"application/vnd.wv.csp+xml":{"source":"iana","compressible":true},"application/vnd.wv.ssp+xml":{"source":"iana","compressible":true},"application/vnd.xacml+json":{"source":"iana","compressible":true},"application/vnd.xara":{"source":"iana","extensions":["xar"]},"application/vnd.xfdl":{"source":"iana","extensions":["xfdl"]},"application/vnd.xfdl.webform":{"source":"iana"},"application/vnd.xmi+xml":{"source":"iana","compressible":true},"application/vnd.xmpie.cpkg":{"source":"iana"},"application/vnd.xmpie.dpkg":{"source":"iana"},"application/vnd.xmpie.plan":{"source":"iana"},"application/vnd.xmpie.ppkg":{"source":"iana"},"application/vnd.xmpie.xlim":{"source":"iana"},"application/vnd.yamaha.hv-dic":{"source":"iana","extensions":["hvd"]},"application/vnd.yamaha.hv-script":{"source":"iana","extensions":["hvs"]},"application/vnd.yamaha.hv-voice":{"source":"iana","extensions":["hvp"]},"application/vnd.yamaha.openscoreformat":{"source":"iana","extensions":["osf"]},"application/vnd.yamaha.openscoreformat.osfpvg+xml":{"source":"iana","compressible":true,"extensions":["osfpvg"]},"application/vnd.yamaha.remote-setup":{"source":"iana"},"application/vnd.yamaha.smaf-audio":{"source":"iana","extensions":["saf"]},"application/vnd.yamaha.smaf-phrase":{"source":"iana","extensions":["spf"]},"application/vnd.yamaha.through-ngn":{"source":"iana"},"application/vnd.yamaha.tunnel-udpencap":{"source":"iana"},"application/vnd.yaoweme":{"source":"iana"},"application/vnd.yellowriver-custom-menu":{"source":"iana","extensions":["cmp"]},"application/vnd.youtube.yt":{"source":"iana"},"application/vnd.zul":{"source":"iana","extensions":["zir","zirz"]},"application/vnd.zzazz.deck+xml":{"source":"iana","compressible":true,"extensions":["zaz"]},"application/voicexml+xml":{"source":"iana","compressible":true,"extensions":["vxml"]},"application/voucher-cms+json":{"source":"iana","compressible":true},"application/vq-rtcpxr":{"source":"iana"},"application/wasm":{"compressible":true,"extensions":["wasm"]},"application/watcherinfo+xml":{"source":"iana","compressible":true},"application/webpush-options+json":{"source":"iana","compressible":true},"application/whoispp-query":{"source":"iana"},"application/whoispp-response":{"source":"iana"},"application/widget":{"source":"iana","extensions":["wgt"]},"application/winhlp":{"source":"apache","extensions":["hlp"]},"application/wita":{"source":"iana"},"application/wordperfect5.1":{"source":"iana"},"application/wsdl+xml":{"source":"iana","compressible":true,"extensions":["wsdl"]},"application/wspolicy+xml":{"source":"iana","compressible":true,"extensions":["wspolicy"]},"application/x-7z-compressed":{"source":"apache","compressible":false,"extensions":["7z"]},"application/x-abiword":{"source":"apache","extensions":["abw"]},"application/x-ace-compressed":{"source":"apache","extensions":["ace"]},"application/x-amf":{"source":"apache"},"application/x-apple-diskimage":{"source":"apache","extensions":["dmg"]},"application/x-arj":{"compressible":false,"extensions":["arj"]},"application/x-authorware-bin":{"source":"apache","extensions":["aab","x32","u32","vox"]},"application/x-authorware-map":{"source":"apache","extensions":["aam"]},"application/x-authorware-seg":{"source":"apache","extensions":["aas"]},"application/x-bcpio":{"source":"apache","extensions":["bcpio"]},"application/x-bdoc":{"compressible":false,"extensions":["bdoc"]},"application/x-bittorrent":{"source":"apache","extensions":["torrent"]},"application/x-blorb":{"source":"apache","extensions":["blb","blorb"]},"application/x-bzip":{"source":"apache","compressible":false,"extensions":["bz"]},"application/x-bzip2":{"source":"apache","compressible":false,"extensions":["bz2","boz"]},"application/x-cbr":{"source":"apache","extensions":["cbr","cba","cbt","cbz","cb7"]},"application/x-cdlink":{"source":"apache","extensions":["vcd"]},"application/x-cfs-compressed":{"source":"apache","extensions":["cfs"]},"application/x-chat":{"source":"apache","extensions":["chat"]},"application/x-chess-pgn":{"source":"apache","extensions":["pgn"]},"application/x-chrome-extension":{"extensions":["crx"]},"application/x-cocoa":{"source":"nginx","extensions":["cco"]},"application/x-compress":{"source":"apache"},"application/x-conference":{"source":"apache","extensions":["nsc"]},"application/x-cpio":{"source":"apache","extensions":["cpio"]},"application/x-csh":{"source":"apache","extensions":["csh"]},"application/x-deb":{"compressible":false},"application/x-debian-package":{"source":"apache","extensions":["deb","udeb"]},"application/x-dgc-compressed":{"source":"apache","extensions":["dgc"]},"application/x-director":{"source":"apache","extensions":["dir","dcr","dxr","cst","cct","cxt","w3d","fgd","swa"]},"application/x-doom":{"source":"apache","extensions":["wad"]},"application/x-dtbncx+xml":{"source":"apache","compressible":true,"extensions":["ncx"]},"application/x-dtbook+xml":{"source":"apache","compressible":true,"extensions":["dtb"]},"application/x-dtbresource+xml":{"source":"apache","compressible":true,"extensions":["res"]},"application/x-dvi":{"source":"apache","compressible":false,"extensions":["dvi"]},"application/x-envoy":{"source":"apache","extensions":["evy"]},"application/x-eva":{"source":"apache","extensions":["eva"]},"application/x-font-bdf":{"source":"apache","extensions":["bdf"]},"application/x-font-dos":{"source":"apache"},"application/x-font-framemaker":{"source":"apache"},"application/x-font-ghostscript":{"source":"apache","extensions":["gsf"]},"application/x-font-libgrx":{"source":"apache"},"application/x-font-linux-psf":{"source":"apache","extensions":["psf"]},"application/x-font-pcf":{"source":"apache","extensions":["pcf"]},"application/x-font-snf":{"source":"apache","extensions":["snf"]},"application/x-font-speedo":{"source":"apache"},"application/x-font-sunos-news":{"source":"apache"},"application/x-font-type1":{"source":"apache","extensions":["pfa","pfb","pfm","afm"]},"application/x-font-vfont":{"source":"apache"},"application/x-freearc":{"source":"apache","extensions":["arc"]},"application/x-futuresplash":{"source":"apache","extensions":["spl"]},"application/x-gca-compressed":{"source":"apache","extensions":["gca"]},"application/x-glulx":{"source":"apache","extensions":["ulx"]},"application/x-gnumeric":{"source":"apache","extensions":["gnumeric"]},"application/x-gramps-xml":{"source":"apache","extensions":["gramps"]},"application/x-gtar":{"source":"apache","extensions":["gtar"]},"application/x-gzip":{"source":"apache"},"application/x-hdf":{"source":"apache","extensions":["hdf"]},"application/x-httpd-php":{"compressible":true,"extensions":["php"]},"application/x-install-instructions":{"source":"apache","extensions":["install"]},"application/x-iso9660-image":{"source":"apache","extensions":["iso"]},"application/x-java-archive-diff":{"source":"nginx","extensions":["jardiff"]},"application/x-java-jnlp-file":{"source":"apache","compressible":false,"extensions":["jnlp"]},"application/x-javascript":{"compressible":true},"application/x-latex":{"source":"apache","compressible":false,"extensions":["latex"]},"application/x-lua-bytecode":{"extensions":["luac"]},"application/x-lzh-compressed":{"source":"apache","extensions":["lzh","lha"]},"application/x-makeself":{"source":"nginx","extensions":["run"]},"application/x-mie":{"source":"apache","extensions":["mie"]},"application/x-mobipocket-ebook":{"source":"apache","extensions":["prc","mobi"]},"application/x-mpegurl":{"compressible":false},"application/x-ms-application":{"source":"apache","extensions":["application"]},"application/x-ms-shortcut":{"source":"apache","extensions":["lnk"]},"application/x-ms-wmd":{"source":"apache","extensions":["wmd"]},"application/x-ms-wmz":{"source":"apache","extensions":["wmz"]},"application/x-ms-xbap":{"source":"apache","extensions":["xbap"]},"application/x-msaccess":{"source":"apache","extensions":["mdb"]},"application/x-msbinder":{"source":"apache","extensions":["obd"]},"application/x-mscardfile":{"source":"apache","extensions":["crd"]},"application/x-msclip":{"source":"apache","extensions":["clp"]},"application/x-msdos-program":{"extensions":["exe"]},"application/x-msdownload":{"source":"apache","extensions":["exe","dll","com","bat","msi"]},"application/x-msmediaview":{"source":"apache","extensions":["mvb","m13","m14"]},"application/x-msmetafile":{"source":"apache","extensions":["wmf","wmz","emf","emz"]},"application/x-msmoney":{"source":"apache","extensions":["mny"]},"application/x-mspublisher":{"source":"apache","extensions":["pub"]},"application/x-msschedule":{"source":"apache","extensions":["scd"]},"application/x-msterminal":{"source":"apache","extensions":["trm"]},"application/x-mswrite":{"source":"apache","extensions":["wri"]},"application/x-netcdf":{"source":"apache","extensions":["nc","cdf"]},"application/x-ns-proxy-autoconfig":{"compressible":true,"extensions":["pac"]},"application/x-nzb":{"source":"apache","extensions":["nzb"]},"application/x-perl":{"source":"nginx","extensions":["pl","pm"]},"application/x-pilot":{"source":"nginx","extensions":["prc","pdb"]},"application/x-pkcs12":{"source":"apache","compressible":false,"extensions":["p12","pfx"]},"application/x-pkcs7-certificates":{"source":"apache","extensions":["p7b","spc"]},"application/x-pkcs7-certreqresp":{"source":"apache","extensions":["p7r"]},"application/x-rar-compressed":{"source":"apache","compressible":false,"extensions":["rar"]},"application/x-redhat-package-manager":{"source":"nginx","extensions":["rpm"]},"application/x-research-info-systems":{"source":"apache","extensions":["ris"]},"application/x-sea":{"source":"nginx","extensions":["sea"]},"application/x-sh":{"source":"apache","compressible":true,"extensions":["sh"]},"application/x-shar":{"source":"apache","extensions":["shar"]},"application/x-shockwave-flash":{"source":"apache","compressible":false,"extensions":["swf"]},"application/x-silverlight-app":{"source":"apache","extensions":["xap"]},"application/x-sql":{"source":"apache","extensions":["sql"]},"application/x-stuffit":{"source":"apache","compressible":false,"extensions":["sit"]},"application/x-stuffitx":{"source":"apache","extensions":["sitx"]},"application/x-subrip":{"source":"apache","extensions":["srt"]},"application/x-sv4cpio":{"source":"apache","extensions":["sv4cpio"]},"application/x-sv4crc":{"source":"apache","extensions":["sv4crc"]},"application/x-t3vm-image":{"source":"apache","extensions":["t3"]},"application/x-tads":{"source":"apache","extensions":["gam"]},"application/x-tar":{"source":"apache","compressible":true,"extensions":["tar"]},"application/x-tcl":{"source":"apache","extensions":["tcl","tk"]},"application/x-tex":{"source":"apache","extensions":["tex"]},"application/x-tex-tfm":{"source":"apache","extensions":["tfm"]},"application/x-texinfo":{"source":"apache","extensions":["texinfo","texi"]},"application/x-tgif":{"source":"apache","extensions":["obj"]},"application/x-ustar":{"source":"apache","extensions":["ustar"]},"application/x-virtualbox-hdd":{"compressible":true,"extensions":["hdd"]},"application/x-virtualbox-ova":{"compressible":true,"extensions":["ova"]},"application/x-virtualbox-ovf":{"compressible":true,"extensions":["ovf"]},"application/x-virtualbox-vbox":{"compressible":true,"extensions":["vbox"]},"application/x-virtualbox-vbox-extpack":{"compressible":false,"extensions":["vbox-extpack"]},"application/x-virtualbox-vdi":{"compressible":true,"extensions":["vdi"]},"application/x-virtualbox-vhd":{"compressible":true,"extensions":["vhd"]},"application/x-virtualbox-vmdk":{"compressible":true,"extensions":["vmdk"]},"application/x-wais-source":{"source":"apache","extensions":["src"]},"application/x-web-app-manifest+json":{"compressible":true,"extensions":["webapp"]},"application/x-www-form-urlencoded":{"source":"iana","compressible":true},"application/x-x509-ca-cert":{"source":"apache","extensions":["der","crt","pem"]},"application/x-xfig":{"source":"apache","extensions":["fig"]},"application/x-xliff+xml":{"source":"apache","compressible":true,"extensions":["xlf"]},"application/x-xpinstall":{"source":"apache","compressible":false,"extensions":["xpi"]},"application/x-xz":{"source":"apache","extensions":["xz"]},"application/x-zmachine":{"source":"apache","extensions":["z1","z2","z3","z4","z5","z6","z7","z8"]},"application/x400-bp":{"source":"iana"},"application/xacml+xml":{"source":"iana","compressible":true},"application/xaml+xml":{"source":"apache","compressible":true,"extensions":["xaml"]},"application/xcap-att+xml":{"source":"iana","compressible":true},"application/xcap-caps+xml":{"source":"iana","compressible":true},"application/xcap-diff+xml":{"source":"iana","compressible":true,"extensions":["xdf"]},"application/xcap-el+xml":{"source":"iana","compressible":true},"application/xcap-error+xml":{"source":"iana","compressible":true},"application/xcap-ns+xml":{"source":"iana","compressible":true},"application/xcon-conference-info+xml":{"source":"iana","compressible":true},"application/xcon-conference-info-diff+xml":{"source":"iana","compressible":true},"application/xenc+xml":{"source":"iana","compressible":true,"extensions":["xenc"]},"application/xhtml+xml":{"source":"iana","compressible":true,"extensions":["xhtml","xht"]},"application/xhtml-voice+xml":{"source":"apache","compressible":true},"application/xliff+xml":{"source":"iana","compressible":true},"application/xml":{"source":"iana","compressible":true,"extensions":["xml","xsl","xsd","rng"]},"application/xml-dtd":{"source":"iana","compressible":true,"extensions":["dtd"]},"application/xml-external-parsed-entity":{"source":"iana"},"application/xml-patch+xml":{"source":"iana","compressible":true},"application/xmpp+xml":{"source":"iana","compressible":true},"application/xop+xml":{"source":"iana","compressible":true,"extensions":["xop"]},"application/xproc+xml":{"source":"apache","compressible":true,"extensions":["xpl"]},"application/xslt+xml":{"source":"iana","compressible":true,"extensions":["xslt"]},"application/xspf+xml":{"source":"apache","compressible":true,"extensions":["xspf"]},"application/xv+xml":{"source":"iana","compressible":true,"extensions":["mxml","xhvml","xvml","xvm"]},"application/yang":{"source":"iana","extensions":["yang"]},"application/yang-data+json":{"source":"iana","compressible":true},"application/yang-data+xml":{"source":"iana","compressible":true},"application/yang-patch+json":{"source":"iana","compressible":true},"application/yang-patch+xml":{"source":"iana","compressible":true},"application/yin+xml":{"source":"iana","compressible":true,"extensions":["yin"]},"application/zip":{"source":"iana","compressible":false,"extensions":["zip"]},"application/zlib":{"source":"iana"},"application/zstd":{"source":"iana"},"audio/1d-interleaved-parityfec":{"source":"iana"},"audio/32kadpcm":{"source":"iana"},"audio/3gpp":{"source":"iana","compressible":false,"extensions":["3gpp"]},"audio/3gpp2":{"source":"iana"},"audio/aac":{"source":"iana"},"audio/ac3":{"source":"iana"},"audio/adpcm":{"source":"apache","extensions":["adp"]},"audio/amr":{"source":"iana"},"audio/amr-wb":{"source":"iana"},"audio/amr-wb+":{"source":"iana"},"audio/aptx":{"source":"iana"},"audio/asc":{"source":"iana"},"audio/atrac-advanced-lossless":{"source":"iana"},"audio/atrac-x":{"source":"iana"},"audio/atrac3":{"source":"iana"},"audio/basic":{"source":"iana","compressible":false,"extensions":["au","snd"]},"audio/bv16":{"source":"iana"},"audio/bv32":{"source":"iana"},"audio/clearmode":{"source":"iana"},"audio/cn":{"source":"iana"},"audio/dat12":{"source":"iana"},"audio/dls":{"source":"iana"},"audio/dsr-es201108":{"source":"iana"},"audio/dsr-es202050":{"source":"iana"},"audio/dsr-es202211":{"source":"iana"},"audio/dsr-es202212":{"source":"iana"},"audio/dv":{"source":"iana"},"audio/dvi4":{"source":"iana"},"audio/eac3":{"source":"iana"},"audio/encaprtp":{"source":"iana"},"audio/evrc":{"source":"iana"},"audio/evrc-qcp":{"source":"iana"},"audio/evrc0":{"source":"iana"},"audio/evrc1":{"source":"iana"},"audio/evrcb":{"source":"iana"},"audio/evrcb0":{"source":"iana"},"audio/evrcb1":{"source":"iana"},"audio/evrcnw":{"source":"iana"},"audio/evrcnw0":{"source":"iana"},"audio/evrcnw1":{"source":"iana"},"audio/evrcwb":{"source":"iana"},"audio/evrcwb0":{"source":"iana"},"audio/evrcwb1":{"source":"iana"},"audio/evs":{"source":"iana"},"audio/fwdred":{"source":"iana"},"audio/g711-0":{"source":"iana"},"audio/g719":{"source":"iana"},"audio/g722":{"source":"iana"},"audio/g7221":{"source":"iana"},"audio/g723":{"source":"iana"},"audio/g726-16":{"source":"iana"},"audio/g726-24":{"source":"iana"},"audio/g726-32":{"source":"iana"},"audio/g726-40":{"source":"iana"},"audio/g728":{"source":"iana"},"audio/g729":{"source":"iana"},"audio/g7291":{"source":"iana"},"audio/g729d":{"source":"iana"},"audio/g729e":{"source":"iana"},"audio/gsm":{"source":"iana"},"audio/gsm-efr":{"source":"iana"},"audio/gsm-hr-08":{"source":"iana"},"audio/ilbc":{"source":"iana"},"audio/ip-mr_v2.5":{"source":"iana"},"audio/isac":{"source":"apache"},"audio/l16":{"source":"iana"},"audio/l20":{"source":"iana"},"audio/l24":{"source":"iana","compressible":false},"audio/l8":{"source":"iana"},"audio/lpc":{"source":"iana"},"audio/melp":{"source":"iana"},"audio/melp1200":{"source":"iana"},"audio/melp2400":{"source":"iana"},"audio/melp600":{"source":"iana"},"audio/midi":{"source":"apache","extensions":["mid","midi","kar","rmi"]},"audio/mobile-xmf":{"source":"iana"},"audio/mp3":{"compressible":false,"extensions":["mp3"]},"audio/mp4":{"source":"iana","compressible":false,"extensions":["m4a","mp4a"]},"audio/mp4a-latm":{"source":"iana"},"audio/mpa":{"source":"iana"},"audio/mpa-robust":{"source":"iana"},"audio/mpeg":{"source":"iana","compressible":false,"extensions":["mpga","mp2","mp2a","mp3","m2a","m3a"]},"audio/mpeg4-generic":{"source":"iana"},"audio/musepack":{"source":"apache"},"audio/ogg":{"source":"iana","compressible":false,"extensions":["oga","ogg","spx"]},"audio/opus":{"source":"iana"},"audio/parityfec":{"source":"iana"},"audio/pcma":{"source":"iana"},"audio/pcma-wb":{"source":"iana"},"audio/pcmu":{"source":"iana"},"audio/pcmu-wb":{"source":"iana"},"audio/prs.sid":{"source":"iana"},"audio/qcelp":{"source":"iana"},"audio/raptorfec":{"source":"iana"},"audio/red":{"source":"iana"},"audio/rtp-enc-aescm128":{"source":"iana"},"audio/rtp-midi":{"source":"iana"},"audio/rtploopback":{"source":"iana"},"audio/rtx":{"source":"iana"},"audio/s3m":{"source":"apache","extensions":["s3m"]},"audio/silk":{"source":"apache","extensions":["sil"]},"audio/smv":{"source":"iana"},"audio/smv-qcp":{"source":"iana"},"audio/smv0":{"source":"iana"},"audio/sp-midi":{"source":"iana"},"audio/speex":{"source":"iana"},"audio/t140c":{"source":"iana"},"audio/t38":{"source":"iana"},"audio/telephone-event":{"source":"iana"},"audio/tone":{"source":"iana"},"audio/uemclip":{"source":"iana"},"audio/ulpfec":{"source":"iana"},"audio/usac":{"source":"iana"},"audio/vdvi":{"source":"iana"},"audio/vmr-wb":{"source":"iana"},"audio/vnd.3gpp.iufp":{"source":"iana"},"audio/vnd.4sb":{"source":"iana"},"audio/vnd.audiokoz":{"source":"iana"},"audio/vnd.celp":{"source":"iana"},"audio/vnd.cisco.nse":{"source":"iana"},"audio/vnd.cmles.radio-events":{"source":"iana"},"audio/vnd.cns.anp1":{"source":"iana"},"audio/vnd.cns.inf1":{"source":"iana"},"audio/vnd.dece.audio":{"source":"iana","extensions":["uva","uvva"]},"audio/vnd.digital-winds":{"source":"iana","extensions":["eol"]},"audio/vnd.dlna.adts":{"source":"iana"},"audio/vnd.dolby.heaac.1":{"source":"iana"},"audio/vnd.dolby.heaac.2":{"source":"iana"},"audio/vnd.dolby.mlp":{"source":"iana"},"audio/vnd.dolby.mps":{"source":"iana"},"audio/vnd.dolby.pl2":{"source":"iana"},"audio/vnd.dolby.pl2x":{"source":"iana"},"audio/vnd.dolby.pl2z":{"source":"iana"},"audio/vnd.dolby.pulse.1":{"source":"iana"},"audio/vnd.dra":{"source":"iana","extensions":["dra"]},"audio/vnd.dts":{"source":"iana","extensions":["dts"]},"audio/vnd.dts.hd":{"source":"iana","extensions":["dtshd"]},"audio/vnd.dvb.file":{"source":"iana"},"audio/vnd.everad.plj":{"source":"iana"},"audio/vnd.hns.audio":{"source":"iana"},"audio/vnd.lucent.voice":{"source":"iana","extensions":["lvp"]},"audio/vnd.ms-playready.media.pya":{"source":"iana","extensions":["pya"]},"audio/vnd.nokia.mobile-xmf":{"source":"iana"},"audio/vnd.nortel.vbk":{"source":"iana"},"audio/vnd.nuera.ecelp4800":{"source":"iana","extensions":["ecelp4800"]},"audio/vnd.nuera.ecelp7470":{"source":"iana","extensions":["ecelp7470"]},"audio/vnd.nuera.ecelp9600":{"source":"iana","extensions":["ecelp9600"]},"audio/vnd.octel.sbc":{"source":"iana"},"audio/vnd.presonus.multitrack":{"source":"iana"},"audio/vnd.qcelp":{"source":"iana"},"audio/vnd.rhetorex.32kadpcm":{"source":"iana"},"audio/vnd.rip":{"source":"iana","extensions":["rip"]},"audio/vnd.rn-realaudio":{"compressible":false},"audio/vnd.sealedmedia.softseal.mpeg":{"source":"iana"},"audio/vnd.vmx.cvsd":{"source":"iana"},"audio/vnd.wave":{"compressible":false},"audio/vorbis":{"source":"iana","compressible":false},"audio/vorbis-config":{"source":"iana"},"audio/wav":{"compressible":false,"extensions":["wav"]},"audio/wave":{"compressible":false,"extensions":["wav"]},"audio/webm":{"source":"apache","compressible":false,"extensions":["weba"]},"audio/x-aac":{"source":"apache","compressible":false,"extensions":["aac"]},"audio/x-aiff":{"source":"apache","extensions":["aif","aiff","aifc"]},"audio/x-caf":{"source":"apache","compressible":false,"extensions":["caf"]},"audio/x-flac":{"source":"apache","extensions":["flac"]},"audio/x-m4a":{"source":"nginx","extensions":["m4a"]},"audio/x-matroska":{"source":"apache","extensions":["mka"]},"audio/x-mpegurl":{"source":"apache","extensions":["m3u"]},"audio/x-ms-wax":{"source":"apache","extensions":["wax"]},"audio/x-ms-wma":{"source":"apache","extensions":["wma"]},"audio/x-pn-realaudio":{"source":"apache","extensions":["ram","ra"]},"audio/x-pn-realaudio-plugin":{"source":"apache","extensions":["rmp"]},"audio/x-realaudio":{"source":"nginx","extensions":["ra"]},"audio/x-tta":{"source":"apache"},"audio/x-wav":{"source":"apache","extensions":["wav"]},"audio/xm":{"source":"apache","extensions":["xm"]},"chemical/x-cdx":{"source":"apache","extensions":["cdx"]},"chemical/x-cif":{"source":"apache","extensions":["cif"]},"chemical/x-cmdf":{"source":"apache","extensions":["cmdf"]},"chemical/x-cml":{"source":"apache","extensions":["cml"]},"chemical/x-csml":{"source":"apache","extensions":["csml"]},"chemical/x-pdb":{"source":"apache"},"chemical/x-xyz":{"source":"apache","extensions":["xyz"]},"font/collection":{"source":"iana","extensions":["ttc"]},"font/otf":{"source":"iana","compressible":true,"extensions":["otf"]},"font/sfnt":{"source":"iana"},"font/ttf":{"source":"iana","extensions":["ttf"]},"font/woff":{"source":"iana","extensions":["woff"]},"font/woff2":{"source":"iana","extensions":["woff2"]},"image/aces":{"source":"iana","extensions":["exr"]},"image/apng":{"compressible":false,"extensions":["apng"]},"image/avci":{"source":"iana"},"image/avcs":{"source":"iana"},"image/bmp":{"source":"iana","compressible":true,"extensions":["bmp"]},"image/cgm":{"source":"iana","extensions":["cgm"]},"image/dicom-rle":{"source":"iana","extensions":["drle"]},"image/emf":{"source":"iana","extensions":["emf"]},"image/fits":{"source":"iana","extensions":["fits"]},"image/g3fax":{"source":"iana","extensions":["g3"]},"image/gif":{"source":"iana","compressible":false,"extensions":["gif"]},"image/heic":{"source":"iana"},"image/heic-sequence":{"source":"iana"},"image/heif":{"source":"iana"},"image/heif-sequence":{"source":"iana"},"image/ief":{"source":"iana","extensions":["ief"]},"image/jls":{"source":"iana","extensions":["jls"]},"image/jp2":{"source":"iana","compressible":false,"extensions":["jp2","jpg2"]},"image/jpeg":{"source":"iana","compressible":false,"extensions":["jpeg","jpg","jpe"]},"image/jpm":{"source":"iana","compressible":false,"extensions":["jpm"]},"image/jpx":{"source":"iana","compressible":false,"extensions":["jpx","jpf"]},"image/ktx":{"source":"iana","extensions":["ktx"]},"image/naplps":{"source":"iana"},"image/pjpeg":{"compressible":false},"image/png":{"source":"iana","compressible":false,"extensions":["png"]},"image/prs.btif":{"source":"iana","extensions":["btif"]},"image/prs.pti":{"source":"iana","extensions":["pti"]},"image/pwg-raster":{"source":"iana"},"image/sgi":{"source":"apache","extensions":["sgi"]},"image/svg+xml":{"source":"iana","compressible":true,"extensions":["svg","svgz"]},"image/t38":{"source":"iana","extensions":["t38"]},"image/tiff":{"source":"iana","compressible":false,"extensions":["tif","tiff"]},"image/tiff-fx":{"source":"iana","extensions":["tfx"]},"image/vnd.adobe.photoshop":{"source":"iana","compressible":true,"extensions":["psd"]},"image/vnd.airzip.accelerator.azv":{"source":"iana","extensions":["azv"]},"image/vnd.cns.inf2":{"source":"iana"},"image/vnd.dece.graphic":{"source":"iana","extensions":["uvi","uvvi","uvg","uvvg"]},"image/vnd.djvu":{"source":"iana","extensions":["djvu","djv"]},"image/vnd.dvb.subtitle":{"source":"iana","extensions":["sub"]},"image/vnd.dwg":{"source":"iana","extensions":["dwg"]},"image/vnd.dxf":{"source":"iana","extensions":["dxf"]},"image/vnd.fastbidsheet":{"source":"iana","extensions":["fbs"]},"image/vnd.fpx":{"source":"iana","extensions":["fpx"]},"image/vnd.fst":{"source":"iana","extensions":["fst"]},"image/vnd.fujixerox.edmics-mmr":{"source":"iana","extensions":["mmr"]},"image/vnd.fujixerox.edmics-rlc":{"source":"iana","extensions":["rlc"]},"image/vnd.globalgraphics.pgb":{"source":"iana"},"image/vnd.microsoft.icon":{"source":"iana","extensions":["ico"]},"image/vnd.mix":{"source":"iana"},"image/vnd.mozilla.apng":{"source":"iana"},"image/vnd.ms-modi":{"source":"iana","extensions":["mdi"]},"image/vnd.ms-photo":{"source":"apache","extensions":["wdp"]},"image/vnd.net-fpx":{"source":"iana","extensions":["npx"]},"image/vnd.radiance":{"source":"iana"},"image/vnd.sealed.png":{"source":"iana"},"image/vnd.sealedmedia.softseal.gif":{"source":"iana"},"image/vnd.sealedmedia.softseal.jpg":{"source":"iana"},"image/vnd.svf":{"source":"iana"},"image/vnd.tencent.tap":{"source":"iana","extensions":["tap"]},"image/vnd.valve.source.texture":{"source":"iana","extensions":["vtf"]},"image/vnd.wap.wbmp":{"source":"iana","extensions":["wbmp"]},"image/vnd.xiff":{"source":"iana","extensions":["xif"]},"image/vnd.zbrush.pcx":{"source":"iana","extensions":["pcx"]},"image/webp":{"source":"apache","extensions":["webp"]},"image/wmf":{"source":"iana","extensions":["wmf"]},"image/x-3ds":{"source":"apache","extensions":["3ds"]},"image/x-cmu-raster":{"source":"apache","extensions":["ras"]},"image/x-cmx":{"source":"apache","extensions":["cmx"]},"image/x-freehand":{"source":"apache","extensions":["fh","fhc","fh4","fh5","fh7"]},"image/x-icon":{"source":"apache","compressible":true,"extensions":["ico"]},"image/x-jng":{"source":"nginx","extensions":["jng"]},"image/x-mrsid-image":{"source":"apache","extensions":["sid"]},"image/x-ms-bmp":{"source":"nginx","compressible":true,"extensions":["bmp"]},"image/x-pcx":{"source":"apache","extensions":["pcx"]},"image/x-pict":{"source":"apache","extensions":["pic","pct"]},"image/x-portable-anymap":{"source":"apache","extensions":["pnm"]},"image/x-portable-bitmap":{"source":"apache","extensions":["pbm"]},"image/x-portable-graymap":{"source":"apache","extensions":["pgm"]},"image/x-portable-pixmap":{"source":"apache","extensions":["ppm"]},"image/x-rgb":{"source":"apache","extensions":["rgb"]},"image/x-tga":{"source":"apache","extensions":["tga"]},"image/x-xbitmap":{"source":"apache","extensions":["xbm"]},"image/x-xcf":{"compressible":false},"image/x-xpixmap":{"source":"apache","extensions":["xpm"]},"image/x-xwindowdump":{"source":"apache","extensions":["xwd"]},"message/cpim":{"source":"iana"},"message/delivery-status":{"source":"iana"},"message/disposition-notification":{"source":"iana","extensions":["disposition-notification"]},"message/external-body":{"source":"iana"},"message/feedback-report":{"source":"iana"},"message/global":{"source":"iana","extensions":["u8msg"]},"message/global-delivery-status":{"source":"iana","extensions":["u8dsn"]},"message/global-disposition-notification":{"source":"iana","extensions":["u8mdn"]},"message/global-headers":{"source":"iana","extensions":["u8hdr"]},"message/http":{"source":"iana","compressible":false},"message/imdn+xml":{"source":"iana","compressible":true},"message/news":{"source":"iana"},"message/partial":{"source":"iana","compressible":false},"message/rfc822":{"source":"iana","compressible":true,"extensions":["eml","mime"]},"message/s-http":{"source":"iana"},"message/sip":{"source":"iana"},"message/sipfrag":{"source":"iana"},"message/tracking-status":{"source":"iana"},"message/vnd.si.simp":{"source":"iana"},"message/vnd.wfa.wsc":{"source":"iana","extensions":["wsc"]},"model/3mf":{"source":"iana"},"model/gltf+json":{"source":"iana","compressible":true,"extensions":["gltf"]},"model/gltf-binary":{"source":"iana","compressible":true,"extensions":["glb"]},"model/iges":{"source":"iana","compressible":false,"extensions":["igs","iges"]},"model/mesh":{"source":"iana","compressible":false,"extensions":["msh","mesh","silo"]},"model/stl":{"source":"iana"},"model/vnd.collada+xml":{"source":"iana","compressible":true,"extensions":["dae"]},"model/vnd.dwf":{"source":"iana","extensions":["dwf"]},"model/vnd.flatland.3dml":{"source":"iana"},"model/vnd.gdl":{"source":"iana","extensions":["gdl"]},"model/vnd.gs-gdl":{"source":"apache"},"model/vnd.gs.gdl":{"source":"iana"},"model/vnd.gtw":{"source":"iana","extensions":["gtw"]},"model/vnd.moml+xml":{"source":"iana","compressible":true},"model/vnd.mts":{"source":"iana","extensions":["mts"]},"model/vnd.opengex":{"source":"iana"},"model/vnd.parasolid.transmit.binary":{"source":"iana"},"model/vnd.parasolid.transmit.text":{"source":"iana"},"model/vnd.rosette.annotated-data-model":{"source":"iana"},"model/vnd.usdz+zip":{"source":"iana","compressible":false},"model/vnd.valve.source.compiled-map":{"source":"iana"},"model/vnd.vtu":{"source":"iana","extensions":["vtu"]},"model/vrml":{"source":"iana","compressible":false,"extensions":["wrl","vrml"]},"model/x3d+binary":{"source":"apache","compressible":false,"extensions":["x3db","x3dbz"]},"model/x3d+fastinfoset":{"source":"iana"},"model/x3d+vrml":{"source":"apache","compressible":false,"extensions":["x3dv","x3dvz"]},"model/x3d+xml":{"source":"iana","compressible":true,"extensions":["x3d","x3dz"]},"model/x3d-vrml":{"source":"iana"},"multipart/alternative":{"source":"iana","compressible":false},"multipart/appledouble":{"source":"iana"},"multipart/byteranges":{"source":"iana"},"multipart/digest":{"source":"iana"},"multipart/encrypted":{"source":"iana","compressible":false},"multipart/form-data":{"source":"iana","compressible":false},"multipart/header-set":{"source":"iana"},"multipart/mixed":{"source":"iana","compressible":false},"multipart/multilingual":{"source":"iana"},"multipart/parallel":{"source":"iana"},"multipart/related":{"source":"iana","compressible":false},"multipart/report":{"source":"iana"},"multipart/signed":{"source":"iana","compressible":false},"multipart/vnd.bint.med-plus":{"source":"iana"},"multipart/voice-message":{"source":"iana"},"multipart/x-mixed-replace":{"source":"iana"},"text/1d-interleaved-parityfec":{"source":"iana"},"text/cache-manifest":{"source":"iana","compressible":true,"extensions":["appcache","manifest"]},"text/calendar":{"source":"iana","extensions":["ics","ifb"]},"text/calender":{"compressible":true},"text/cmd":{"compressible":true},"text/coffeescript":{"extensions":["coffee","litcoffee"]},"text/css":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["css"]},"text/csv":{"source":"iana","compressible":true,"extensions":["csv"]},"text/csv-schema":{"source":"iana"},"text/directory":{"source":"iana"},"text/dns":{"source":"iana"},"text/ecmascript":{"source":"iana"},"text/encaprtp":{"source":"iana"},"text/enriched":{"source":"iana"},"text/fwdred":{"source":"iana"},"text/grammar-ref-list":{"source":"iana"},"text/html":{"source":"iana","compressible":true,"extensions":["html","htm","shtml"]},"text/jade":{"extensions":["jade"]},"text/javascript":{"source":"iana","compressible":true},"text/jcr-cnd":{"source":"iana"},"text/jsx":{"compressible":true,"extensions":["jsx"]},"text/less":{"extensions":["less"]},"text/markdown":{"source":"iana","compressible":true,"extensions":["markdown","md"]},"text/mathml":{"source":"nginx","extensions":["mml"]},"text/mizar":{"source":"iana"},"text/n3":{"source":"iana","compressible":true,"extensions":["n3"]},"text/parameters":{"source":"iana"},"text/parityfec":{"source":"iana"},"text/plain":{"source":"iana","compressible":true,"extensions":["txt","text","conf","def","list","log","in","ini"]},"text/provenance-notation":{"source":"iana"},"text/prs.fallenstein.rst":{"source":"iana"},"text/prs.lines.tag":{"source":"iana","extensions":["dsc"]},"text/prs.prop.logic":{"source":"iana"},"text/raptorfec":{"source":"iana"},"text/red":{"source":"iana"},"text/rfc822-headers":{"source":"iana"},"text/richtext":{"source":"iana","compressible":true,"extensions":["rtx"]},"text/rtf":{"source":"iana","compressible":true,"extensions":["rtf"]},"text/rtp-enc-aescm128":{"source":"iana"},"text/rtploopback":{"source":"iana"},"text/rtx":{"source":"iana"},"text/sgml":{"source":"iana","extensions":["sgml","sgm"]},"text/shex":{"extensions":["shex"]},"text/slim":{"extensions":["slim","slm"]},"text/strings":{"source":"iana"},"text/stylus":{"extensions":["stylus","styl"]},"text/t140":{"source":"iana"},"text/tab-separated-values":{"source":"iana","compressible":true,"extensions":["tsv"]},"text/troff":{"source":"iana","extensions":["t","tr","roff","man","me","ms"]},"text/turtle":{"source":"iana","charset":"UTF-8","extensions":["ttl"]},"text/ulpfec":{"source":"iana"},"text/uri-list":{"source":"iana","compressible":true,"extensions":["uri","uris","urls"]},"text/vcard":{"source":"iana","compressible":true,"extensions":["vcard"]},"text/vnd.a":{"source":"iana"},"text/vnd.abc":{"source":"iana"},"text/vnd.ascii-art":{"source":"iana"},"text/vnd.curl":{"source":"iana","extensions":["curl"]},"text/vnd.curl.dcurl":{"source":"apache","extensions":["dcurl"]},"text/vnd.curl.mcurl":{"source":"apache","extensions":["mcurl"]},"text/vnd.curl.scurl":{"source":"apache","extensions":["scurl"]},"text/vnd.debian.copyright":{"source":"iana"},"text/vnd.dmclientscript":{"source":"iana"},"text/vnd.dvb.subtitle":{"source":"iana","extensions":["sub"]},"text/vnd.esmertec.theme-descriptor":{"source":"iana"},"text/vnd.fly":{"source":"iana","extensions":["fly"]},"text/vnd.fmi.flexstor":{"source":"iana","extensions":["flx"]},"text/vnd.gml":{"source":"iana"},"text/vnd.graphviz":{"source":"iana","extensions":["gv"]},"text/vnd.hgl":{"source":"iana"},"text/vnd.in3d.3dml":{"source":"iana","extensions":["3dml"]},"text/vnd.in3d.spot":{"source":"iana","extensions":["spot"]},"text/vnd.iptc.newsml":{"source":"iana"},"text/vnd.iptc.nitf":{"source":"iana"},"text/vnd.latex-z":{"source":"iana"},"text/vnd.motorola.reflex":{"source":"iana"},"text/vnd.ms-mediapackage":{"source":"iana"},"text/vnd.net2phone.commcenter.command":{"source":"iana"},"text/vnd.radisys.msml-basic-layout":{"source":"iana"},"text/vnd.si.uricatalogue":{"source":"iana"},"text/vnd.sun.j2me.app-descriptor":{"source":"iana","extensions":["jad"]},"text/vnd.trolltech.linguist":{"source":"iana"},"text/vnd.wap.si":{"source":"iana"},"text/vnd.wap.sl":{"source":"iana"},"text/vnd.wap.wml":{"source":"iana","extensions":["wml"]},"text/vnd.wap.wmlscript":{"source":"iana","extensions":["wmls"]},"text/vtt":{"charset":"UTF-8","compressible":true,"extensions":["vtt"]},"text/x-asm":{"source":"apache","extensions":["s","asm"]},"text/x-c":{"source":"apache","extensions":["c","cc","cxx","cpp","h","hh","dic"]},"text/x-component":{"source":"nginx","extensions":["htc"]},"text/x-fortran":{"source":"apache","extensions":["f","for","f77","f90"]},"text/x-gwt-rpc":{"compressible":true},"text/x-handlebars-template":{"extensions":["hbs"]},"text/x-java-source":{"source":"apache","extensions":["java"]},"text/x-jquery-tmpl":{"compressible":true},"text/x-lua":{"extensions":["lua"]},"text/x-markdown":{"compressible":true,"extensions":["mkd"]},"text/x-nfo":{"source":"apache","extensions":["nfo"]},"text/x-opml":{"source":"apache","extensions":["opml"]},"text/x-org":{"compressible":true,"extensions":["org"]},"text/x-pascal":{"source":"apache","extensions":["p","pas"]},"text/x-processing":{"compressible":true,"extensions":["pde"]},"text/x-sass":{"extensions":["sass"]},"text/x-scss":{"extensions":["scss"]},"text/x-setext":{"source":"apache","extensions":["etx"]},"text/x-sfv":{"source":"apache","extensions":["sfv"]},"text/x-suse-ymp":{"compressible":true,"extensions":["ymp"]},"text/x-uuencode":{"source":"apache","extensions":["uu"]},"text/x-vcalendar":{"source":"apache","extensions":["vcs"]},"text/x-vcard":{"source":"apache","extensions":["vcf"]},"text/xml":{"source":"iana","compressible":true,"extensions":["xml"]},"text/xml-external-parsed-entity":{"source":"iana"},"text/yaml":{"extensions":["yaml","yml"]},"video/1d-interleaved-parityfec":{"source":"iana"},"video/3gpp":{"source":"iana","extensions":["3gp","3gpp"]},"video/3gpp-tt":{"source":"iana"},"video/3gpp2":{"source":"iana","extensions":["3g2"]},"video/bmpeg":{"source":"iana"},"video/bt656":{"source":"iana"},"video/celb":{"source":"iana"},"video/dv":{"source":"iana"},"video/encaprtp":{"source":"iana"},"video/h261":{"source":"iana","extensions":["h261"]},"video/h263":{"source":"iana","extensions":["h263"]},"video/h263-1998":{"source":"iana"},"video/h263-2000":{"source":"iana"},"video/h264":{"source":"iana","extensions":["h264"]},"video/h264-rcdo":{"source":"iana"},"video/h264-svc":{"source":"iana"},"video/h265":{"source":"iana"},"video/iso.segment":{"source":"iana"},"video/jpeg":{"source":"iana","extensions":["jpgv"]},"video/jpeg2000":{"source":"iana"},"video/jpm":{"source":"apache","extensions":["jpm","jpgm"]},"video/mj2":{"source":"iana","extensions":["mj2","mjp2"]},"video/mp1s":{"source":"iana"},"video/mp2p":{"source":"iana"},"video/mp2t":{"source":"iana","extensions":["ts"]},"video/mp4":{"source":"iana","compressible":false,"extensions":["mp4","mp4v","mpg4"]},"video/mp4v-es":{"source":"iana"},"video/mpeg":{"source":"iana","compressible":false,"extensions":["mpeg","mpg","mpe","m1v","m2v"]},"video/mpeg4-generic":{"source":"iana"},"video/mpv":{"source":"iana"},"video/nv":{"source":"iana"},"video/ogg":{"source":"iana","compressible":false,"extensions":["ogv"]},"video/parityfec":{"source":"iana"},"video/pointer":{"source":"iana"},"video/quicktime":{"source":"iana","compressible":false,"extensions":["qt","mov"]},"video/raptorfec":{"source":"iana"},"video/raw":{"source":"iana"},"video/rtp-enc-aescm128":{"source":"iana"},"video/rtploopback":{"source":"iana"},"video/rtx":{"source":"iana"},"video/smpte291":{"source":"iana"},"video/smpte292m":{"source":"iana"},"video/ulpfec":{"source":"iana"},"video/vc1":{"source":"iana"},"video/vnd.cctv":{"source":"iana"},"video/vnd.dece.hd":{"source":"iana","extensions":["uvh","uvvh"]},"video/vnd.dece.mobile":{"source":"iana","extensions":["uvm","uvvm"]},"video/vnd.dece.mp4":{"source":"iana"},"video/vnd.dece.pd":{"source":"iana","extensions":["uvp","uvvp"]},"video/vnd.dece.sd":{"source":"iana","extensions":["uvs","uvvs"]},"video/vnd.dece.video":{"source":"iana","extensions":["uvv","uvvv"]},"video/vnd.directv.mpeg":{"source":"iana"},"video/vnd.directv.mpeg-tts":{"source":"iana"},"video/vnd.dlna.mpeg-tts":{"source":"iana"},"video/vnd.dvb.file":{"source":"iana","extensions":["dvb"]},"video/vnd.fvt":{"source":"iana","extensions":["fvt"]},"video/vnd.hns.video":{"source":"iana"},"video/vnd.iptvforum.1dparityfec-1010":{"source":"iana"},"video/vnd.iptvforum.1dparityfec-2005":{"source":"iana"},"video/vnd.iptvforum.2dparityfec-1010":{"source":"iana"},"video/vnd.iptvforum.2dparityfec-2005":{"source":"iana"},"video/vnd.iptvforum.ttsavc":{"source":"iana"},"video/vnd.iptvforum.ttsmpeg2":{"source":"iana"},"video/vnd.motorola.video":{"source":"iana"},"video/vnd.motorola.videop":{"source":"iana"},"video/vnd.mpegurl":{"source":"iana","extensions":["mxu","m4u"]},"video/vnd.ms-playready.media.pyv":{"source":"iana","extensions":["pyv"]},"video/vnd.nokia.interleaved-multimedia":{"source":"iana"},"video/vnd.nokia.mp4vr":{"source":"iana"},"video/vnd.nokia.videovoip":{"source":"iana"},"video/vnd.objectvideo":{"source":"iana"},"video/vnd.radgamettools.bink":{"source":"iana"},"video/vnd.radgamettools.smacker":{"source":"iana"},"video/vnd.sealed.mpeg1":{"source":"iana"},"video/vnd.sealed.mpeg4":{"source":"iana"},"video/vnd.sealed.swf":{"source":"iana"},"video/vnd.sealedmedia.softseal.mov":{"source":"iana"},"video/vnd.uvvu.mp4":{"source":"iana","extensions":["uvu","uvvu"]},"video/vnd.vivo":{"source":"iana","extensions":["viv"]},"video/vp8":{"source":"iana"},"video/webm":{"source":"apache","compressible":false,"extensions":["webm"]},"video/x-f4v":{"source":"apache","extensions":["f4v"]},"video/x-fli":{"source":"apache","extensions":["fli"]},"video/x-flv":{"source":"apache","compressible":false,"extensions":["flv"]},"video/x-m4v":{"source":"apache","extensions":["m4v"]},"video/x-matroska":{"source":"apache","compressible":false,"extensions":["mkv","mk3d","mks"]},"video/x-mng":{"source":"apache","extensions":["mng"]},"video/x-ms-asf":{"source":"apache","extensions":["asf","asx"]},"video/x-ms-vob":{"source":"apache","extensions":["vob"]},"video/x-ms-wm":{"source":"apache","extensions":["wm"]},"video/x-ms-wmv":{"source":"apache","compressible":false,"extensions":["wmv"]},"video/x-ms-wmx":{"source":"apache","extensions":["wmx"]},"video/x-ms-wvx":{"source":"apache","extensions":["wvx"]},"video/x-msvideo":{"source":"apache","extensions":["avi"]},"video/x-sgi-movie":{"source":"apache","extensions":["movie"]},"video/x-smv":{"source":"apache","extensions":["smv"]},"x-conference/x-cooltalk":{"source":"apache","extensions":["ice"]},"x-shader/x-fragment":{"compressible":true},"x-shader/x-vertex":{"compressible":true}}

/***/ }),

/***/ 503:
/***/ (function(module, exports) {

module.exports = {"id":"afterRequest.json#","type":"object","optional":true,"required":["lastAccess","eTag","hitCount"],"properties":{"expires":{"type":"string","pattern":"^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?"},"lastAccess":{"type":"string","pattern":"^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?"},"eTag":{"type":"string"},"hitCount":{"type":"integer"},"comment":{"type":"string"}}}

/***/ }),

/***/ 504:
/***/ (function(module, exports) {

module.exports = {"id":"beforeRequest.json#","type":"object","optional":true,"required":["lastAccess","eTag","hitCount"],"properties":{"expires":{"type":"string","pattern":"^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?"},"lastAccess":{"type":"string","pattern":"^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?"},"eTag":{"type":"string"},"hitCount":{"type":"integer"},"comment":{"type":"string"}}}

/***/ }),

/***/ 505:
/***/ (function(module, exports) {

module.exports = {"id":"browser.json#","type":"object","required":["name","version"],"properties":{"name":{"type":"string"},"version":{"type":"string"},"comment":{"type":"string"}}}

/***/ }),

/***/ 506:
/***/ (function(module, exports) {

module.exports = {"id":"cache.json#","properties":{"beforeRequest":{"oneOf":[{"type":"null"},{"$ref":"beforeRequest.json#"}]},"afterRequest":{"oneOf":[{"type":"null"},{"$ref":"afterRequest.json#"}]},"comment":{"type":"string"}}}

/***/ }),

/***/ 507:
/***/ (function(module, exports) {

module.exports = {"id":"content.json#","type":"object","required":["size","mimeType"],"properties":{"size":{"type":"integer"},"compression":{"type":"integer"},"mimeType":{"type":"string"},"text":{"type":"string"},"encoding":{"type":"string"},"comment":{"type":"string"}}}

/***/ }),

/***/ 508:
/***/ (function(module, exports) {

module.exports = {"id":"cookie.json#","type":"object","required":["name","value"],"properties":{"name":{"type":"string"},"value":{"type":"string"},"path":{"type":"string"},"domain":{"type":"string"},"expires":{"type":["string","null"],"format":"date-time"},"httpOnly":{"type":"boolean"},"secure":{"type":"boolean"},"comment":{"type":"string"}}}

/***/ }),

/***/ 509:
/***/ (function(module, exports) {

module.exports = {"id":"creator.json#","type":"object","required":["name","version"],"properties":{"name":{"type":"string"},"version":{"type":"string"},"comment":{"type":"string"}}}

/***/ }),

/***/ 510:
/***/ (function(module, exports) {

module.exports = {"id":"entry.json#","type":"object","optional":true,"required":["startedDateTime","time","request","response","cache","timings"],"properties":{"pageref":{"type":"string"},"startedDateTime":{"type":"string","format":"date-time","pattern":"^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))"},"time":{"type":"number","min":0},"request":{"$ref":"request.json#"},"response":{"$ref":"response.json#"},"cache":{"$ref":"cache.json#"},"timings":{"$ref":"timings.json#"},"serverIPAddress":{"type":"string","oneOf":[{"format":"ipv4"},{"format":"ipv6"}]},"connection":{"type":"string"},"comment":{"type":"string"}}}

/***/ }),

/***/ 511:
/***/ (function(module, exports) {

module.exports = {"id":"har.json#","type":"object","required":["log"],"properties":{"log":{"$ref":"log.json#"}}}

/***/ }),

/***/ 512:
/***/ (function(module, exports) {

module.exports = {"id":"header.json#","type":"object","required":["name","value"],"properties":{"name":{"type":"string"},"value":{"type":"string"},"comment":{"type":"string"}}}

/***/ }),

/***/ 513:
/***/ (function(module, exports) {

module.exports = {"id":"log.json#","type":"object","required":["version","creator","entries"],"properties":{"version":{"type":"string"},"creator":{"$ref":"creator.json#"},"browser":{"$ref":"browser.json#"},"pages":{"type":"array","items":{"$ref":"page.json#"}},"entries":{"type":"array","items":{"$ref":"entry.json#"}},"comment":{"type":"string"}}}

/***/ }),

/***/ 514:
/***/ (function(module, exports) {

module.exports = {"id":"page.json#","type":"object","optional":true,"required":["startedDateTime","id","title","pageTimings"],"properties":{"startedDateTime":{"type":"string","format":"date-time","pattern":"^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))"},"id":{"type":"string","unique":true},"title":{"type":"string"},"pageTimings":{"$ref":"pageTimings.json#"},"comment":{"type":"string"}}}

/***/ }),

/***/ 515:
/***/ (function(module, exports) {

module.exports = {"id":"pageTimings.json#","type":"object","properties":{"onContentLoad":{"type":"number","min":-1},"onLoad":{"type":"number","min":-1},"comment":{"type":"string"}}}

/***/ }),

/***/ 516:
/***/ (function(module, exports) {

module.exports = {"id":"postData.json#","type":"object","optional":true,"required":["mimeType"],"properties":{"mimeType":{"type":"string"},"text":{"type":"string"},"params":{"type":"array","required":["name"],"properties":{"name":{"type":"string"},"value":{"type":"string"},"fileName":{"type":"string"},"contentType":{"type":"string"},"comment":{"type":"string"}}},"comment":{"type":"string"}}}

/***/ }),

/***/ 517:
/***/ (function(module, exports) {

module.exports = {"id":"query.json#","type":"object","required":["name","value"],"properties":{"name":{"type":"string"},"value":{"type":"string"},"comment":{"type":"string"}}}

/***/ }),

/***/ 518:
/***/ (function(module, exports) {

module.exports = {"id":"request.json#","type":"object","required":["method","url","httpVersion","cookies","headers","queryString","headersSize","bodySize"],"properties":{"method":{"type":"string"},"url":{"type":"string","format":"uri"},"httpVersion":{"type":"string"},"cookies":{"type":"array","items":{"$ref":"cookie.json#"}},"headers":{"type":"array","items":{"$ref":"header.json#"}},"queryString":{"type":"array","items":{"$ref":"query.json#"}},"postData":{"$ref":"postData.json#"},"headersSize":{"type":"integer"},"bodySize":{"type":"integer"},"comment":{"type":"string"}}}

/***/ }),

/***/ 519:
/***/ (function(module, exports) {

module.exports = {"id":"response.json#","type":"object","required":["status","statusText","httpVersion","cookies","headers","content","redirectURL","headersSize","bodySize"],"properties":{"status":{"type":"integer"},"statusText":{"type":"string"},"httpVersion":{"type":"string"},"cookies":{"type":"array","items":{"$ref":"cookie.json#"}},"headers":{"type":"array","items":{"$ref":"header.json#"}},"content":{"$ref":"content.json#"},"redirectURL":{"type":"string"},"headersSize":{"type":"integer"},"bodySize":{"type":"integer"},"comment":{"type":"string"}}}

/***/ }),

/***/ 520:
/***/ (function(module, exports) {

module.exports = {"id":"timings.json#","required":["send","wait","receive"],"properties":{"dns":{"type":"number","min":-1},"connect":{"type":"number","min":-1},"blocked":{"type":"number","min":-1},"send":{"type":"number","min":-1},"wait":{"type":"number","min":-1},"receive":{"type":"number","min":-1},"ssl":{"type":"number","min":-1},"comment":{"type":"string"}}}

/***/ }),

/***/ 527:
/***/ (function(module, exports) {

function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 527;

/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_localforage__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_localforage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nemWrapper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper__ = __webpack_require__(28);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




var walletModel = /** @class */ (function () {
    function walletModel() {
        var _this = this;
        this.balance = 0;
        this.address = '';
        this.mosaic = '';
        this.mosaic_name = '';
        this.mosaic_balance = 0;
        this.publicKey = '';
        this.privateKey = '';
        this.uq_day = '';
        this.uq_hours = '';
        this.uq_minutes = '';
        this.undefined = false;
        this.transactions = [];
        this.application_logs = [];
        this.yourMosaicName = '';
        this.toAddress = '';
        this.minimum_unit = 25;
        this.working_hour_per_day = 8;
        this.approval_flag = 1;
        this.carry_over_flag = 1;
        this.show_kurikoshi = false;
        this.approval = false;
        this.nonapproval = false;
        /*ページ切り替え */
        this.signup_modal = false;
        this.login_page = true;
        this.waitting_page = false;
        this.top_page = false;
        this.nem = new __WEBPACK_IMPORTED_MODULE_1__nemWrapper__["a" /* default */]();
        this.helper = new __WEBPACK_IMPORTED_MODULE_3__helper__["a" /* default */]();
        // クラス生成時にローカルストレージからアカウント情報を取得
        this.load()
            .then(function (result) {
            console.log(result);
            // 無ければアカウントを作成します
            if (result === null) {
                _this.signup_modal = true;
                _this.nem.createAccount()
                    .then(function (wallet) {
                    _this.address = wallet.address;
                    _this.privateKey = wallet.privateKey;
                    _this.helper.save('SmartUQ-Wallet', _this.toAESJSON());
                }).catch(function (error) {
                    console.error(error);
                });
            }
            else {
                // あればNEMの残高を取得します
                _this.getAccount();
                _this.getAccountMo();
                _this.getUnconfirmed();
                _this.transactions = _this.nem.getTransactions(_this.address, _this.toAddress);
                _this.application_logs = _this.nem.getApplicationLogs(_this.address);
                //this.nem.getApplicationLogs(this.address)
            }
        }).catch(function (error) {
            console.error(error);
        })
            .then(function () {
            _this.checkAccount(_this.address);
        });
    }
    //アカウントが登録されているかのflagを切り替える
    walletModel.prototype.checkAccount = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var flag;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkAccountFromAPI(address)];
                    case 1:
                        flag = _a.sent();
                        this.login_page = false;
                        if (flag == 0) { //アドレスが存在しない
                            this.login_page = true;
                        }
                        else if (flag == 10) { //承認待ち
                            this.waitting_page = true;
                        }
                        else if (flag == 11) {
                            this.top_page = true;
                        }
                        else {
                            this.login_page = true;
                        }
                        console.log("flag:" + flag);
                        return [2 /*return*/];
                }
            });
        });
    };
    //APIでアカウントが登録されているか確認
    walletModel.prototype.checkAccountFromAPI = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.address != "")) return [3 /*break*/, 2];
                        url = this.helper.path + "users/user_exist/" + this.address;
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.data];
                    case 2: return [2 /*return*/, 0];
                }
            });
        });
    };
    // ローカルストレージから取得.
    walletModel.prototype.load = function () {
        return __awaiter(this, void 0, void 0, function () {
            var key, result, key2, result2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        key = 'SmartUQ-Wallet';
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_localforage___default.a.getItem(key)];
                    case 1:
                        result = _a.sent();
                        if (result !== null) {
                            this.address = result.address;
                            this.privateKey = this.helper.Decrypt(result.privateKey);
                            this.publicKey = result.publicKey;
                        }
                        key2 = 'Company-Info';
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_localforage___default.a.getItem(key2)];
                    case 2:
                        result2 = _a.sent();
                        if (!(result2 == null)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.nem.getCompanyInfoFromAPI(this.address)];
                    case 3:
                        result2 = _a.sent();
                        _a.label = 4;
                    case 4:
                        this.working_hour_per_day = result2.working_hour_per_day;
                        this.yourMosaicName = result2.mosaic_name;
                        this.toAddress = result2.address;
                        console.log(this.toAddress);
                        console.log("===================");
                        this.minimum_unit = result2.minimum_unit;
                        this.approval_flag = result2.approval_flag;
                        this.carry_over_flag = result2.carry_over_flag;
                        if (this.carry_over_flag == 1) {
                            this.show_kurikoshi = true;
                        }
                        else {
                            this.show_kurikoshi = false;
                        }
                        if (this.approval_flag == 1) {
                            this.approval = true;
                        }
                        else {
                            this.nonapproval = true;
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    // ローカルストレージから削除.
    walletModel.prototype.remove = function () {
        return __awaiter(this, void 0, void 0, function () {
            var key, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        key = 'SmartUQ-Wallet';
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_localforage___default.a.removeItem(key)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    // アカウント情報を取得.
    walletModel.prototype.getAccount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.nem.getAccount(this.address)];
                    case 1:
                        result = _a.sent();
                        this.balance = result.account.balance / this.nem.getNemDivisibility();
                        if (result.account.publicKey !== null) {
                            this.publicKey = result.account.publicKey;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    walletModel.prototype.getUnconfirmed = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.nem.getUnconfirmed(this.address)];
                    case 1:
                        result = _a.sent();
                        console.log("length");
                        console.log(result.data.length);
                        if (result.data.length > 0) {
                            console.log("承認中・・・"), this.undefined = true;
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    // 送金(NEM)
    walletModel.prototype.sendNem = function (address, amount, message) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.nem.sendNem(address, this.privateKey, amount, message)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    // モザイクの残高取得
    walletModel.prototype.getAccountMo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, mosaic_name, smart_uq_data, day_uq, uq_x, uq_fract_d, uq_fract_m, uq_fract_m2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.nem.getAccountMo(this.address)];
                    case 1:
                        result = _a.sent();
                        mosaic_name = this.yourMosaicName;
                        if (mosaic_name == "")
                            this.helper.pleaseLogin();
                        smart_uq_data = result.data.filter(function (value) {
                            return value.mosaicId.name === mosaic_name;
                        });
                        if (smart_uq_data[0] && smart_uq_data[0].quantity) {
                            console.log(smart_uq_data[0]);
                            this.mosaic_balance = smart_uq_data[0].quantity;
                            console.log("smart_uq mosaic_balance");
                            console.log(this.mosaic_balance);
                            day_uq = this.working_hour_per_day * 100;
                            uq_x = this.mosaic_balance / day_uq;
                            uq_fract_d = uq_x * 10 % 10 / 10;
                            this.uq_day = String(uq_x).split(".")[0];
                            this.uq_hours = String(uq_fract_d * day_uq / 100).split(".")[0];
                            uq_fract_m = Number(uq_fract_d * day_uq / 100) * 10 % 10 / 10;
                            uq_fract_m2 = String(uq_fract_m * 100).split(".")[0];
                            this.uq_minutes = String(Number(uq_fract_m2) / 100 * 60).split(".")[0];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    walletModel.prototype.toAESJSON = function () {
        return __awaiter(this, void 0, void 0, function () {
            var AESprivateKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.helper.Encrypt(this.privateKey)];
                    case 1:
                        AESprivateKey = _a.sent();
                        console.log("暗号化＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝");
                        console.log(AESprivateKey);
                        return [2 /*return*/, {
                                address: this.address,
                                privateKey: AESprivateKey,
                                publicKey: this.publicKey
                            }];
                }
            });
        });
    };
    walletModel.prototype.setData = function (address, secretkey) {
        return __awaiter(this, void 0, void 0, function () {
            var key, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        key = 'SmartUQ-Wallet';
                        this.address = address;
                        this.privateKey = secretkey;
                        return [4 /*yield*/, this.toAESJSON()];
                    case 1:
                        data = _a.sent();
                        this.helper.save(key, data);
                        return [2 /*return*/];
                }
            });
        });
    };
    return walletModel;
}());
/* harmony default export */ __webpack_exports__["a"] = (walletModel);


/***/ }),

/***/ 551:
/***/ (function(module, exports) {

module.exports = {"id":"https://raw.githubusercontent.com/epoberezkin/ajv/master/lib/refs/json-schema-v5.json#","$schema":"http://json-schema.org/draft-04/schema#","description":"Core schema meta-schema (v5 proposals)","definitions":{"schemaArray":{"type":"array","minItems":1,"items":{"$ref":"#"}},"positiveInteger":{"type":"integer","minimum":0},"positiveIntegerDefault0":{"allOf":[{"$ref":"#/definitions/positiveInteger"},{"default":0}]},"simpleTypes":{"enum":["array","boolean","integer","null","number","object","string"]},"stringArray":{"type":"array","items":{"type":"string"},"minItems":1,"uniqueItems":true},"$data":{"type":"object","required":["$data"],"properties":{"$data":{"type":"string","anyOf":[{"format":"relative-json-pointer"},{"format":"json-pointer"}]}},"additionalProperties":false}},"type":"object","properties":{"id":{"type":"string","format":"uri"},"$schema":{"type":"string","format":"uri"},"title":{"type":"string"},"description":{"type":"string"},"default":{},"multipleOf":{"anyOf":[{"type":"number","minimum":0,"exclusiveMinimum":true},{"$ref":"#/definitions/$data"}]},"maximum":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/$data"}]},"exclusiveMaximum":{"anyOf":[{"type":"boolean","default":false},{"$ref":"#/definitions/$data"}]},"minimum":{"anyOf":[{"type":"number"},{"$ref":"#/definitions/$data"}]},"exclusiveMinimum":{"anyOf":[{"type":"boolean","default":false},{"$ref":"#/definitions/$data"}]},"maxLength":{"anyOf":[{"$ref":"#/definitions/positiveInteger"},{"$ref":"#/definitions/$data"}]},"minLength":{"anyOf":[{"$ref":"#/definitions/positiveIntegerDefault0"},{"$ref":"#/definitions/$data"}]},"pattern":{"anyOf":[{"type":"string","format":"regex"},{"$ref":"#/definitions/$data"}]},"additionalItems":{"anyOf":[{"type":"boolean"},{"$ref":"#"},{"$ref":"#/definitions/$data"}],"default":{}},"items":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/schemaArray"}],"default":{}},"maxItems":{"anyOf":[{"$ref":"#/definitions/positiveInteger"},{"$ref":"#/definitions/$data"}]},"minItems":{"anyOf":[{"$ref":"#/definitions/positiveIntegerDefault0"},{"$ref":"#/definitions/$data"}]},"uniqueItems":{"anyOf":[{"type":"boolean","default":false},{"$ref":"#/definitions/$data"}]},"maxProperties":{"anyOf":[{"$ref":"#/definitions/positiveInteger"},{"$ref":"#/definitions/$data"}]},"minProperties":{"anyOf":[{"$ref":"#/definitions/positiveIntegerDefault0"},{"$ref":"#/definitions/$data"}]},"required":{"anyOf":[{"$ref":"#/definitions/stringArray"},{"$ref":"#/definitions/$data"}]},"additionalProperties":{"anyOf":[{"type":"boolean"},{"$ref":"#"},{"$ref":"#/definitions/$data"}],"default":{}},"definitions":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"properties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"patternProperties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"dependencies":{"type":"object","additionalProperties":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/stringArray"}]}},"enum":{"anyOf":[{"type":"array","minItems":1,"uniqueItems":true},{"$ref":"#/definitions/$data"}]},"type":{"anyOf":[{"$ref":"#/definitions/simpleTypes"},{"type":"array","items":{"$ref":"#/definitions/simpleTypes"},"minItems":1,"uniqueItems":true}]},"allOf":{"$ref":"#/definitions/schemaArray"},"anyOf":{"$ref":"#/definitions/schemaArray"},"oneOf":{"$ref":"#/definitions/schemaArray"},"not":{"$ref":"#"},"format":{"anyOf":[{"type":"string"},{"$ref":"#/definitions/$data"}]},"formatMaximum":{"anyOf":[{"type":"string"},{"$ref":"#/definitions/$data"}]},"formatMinimum":{"anyOf":[{"type":"string"},{"$ref":"#/definitions/$data"}]},"formatExclusiveMaximum":{"anyOf":[{"type":"boolean","default":false},{"$ref":"#/definitions/$data"}]},"formatExclusiveMinimum":{"anyOf":[{"type":"boolean","default":false},{"$ref":"#/definitions/$data"}]},"constant":{"anyOf":[{},{"$ref":"#/definitions/$data"}]},"contains":{"$ref":"#"},"patternGroups":{"type":"object","additionalProperties":{"type":"object","required":["schema"],"properties":{"maximum":{"anyOf":[{"$ref":"#/definitions/positiveInteger"},{"$ref":"#/definitions/$data"}]},"minimum":{"anyOf":[{"$ref":"#/definitions/positiveIntegerDefault0"},{"$ref":"#/definitions/$data"}]},"schema":{"$ref":"#"}},"additionalProperties":false},"default":{}},"switch":{"type":"array","items":{"required":["then"],"properties":{"if":{"$ref":"#"},"then":{"anyOf":[{"type":"boolean"},{"$ref":"#"}]},"continue":{"type":"boolean"}},"additionalProperties":false,"dependencies":{"continue":["if"]}}}},"dependencies":{"exclusiveMaximum":["maximum"],"exclusiveMinimum":["minimum"],"formatMaximum":["format"],"formatMinimum":["format"],"formatExclusiveMaximum":["formatMaximum"],"formatExclusiveMinimum":["formatMinimum"]},"default":{}}

/***/ }),

/***/ 554:
/***/ (function(module, exports) {

module.exports = {"id":"http://json-schema.org/draft-04/schema#","$schema":"http://json-schema.org/draft-04/schema#","description":"Core schema meta-schema","definitions":{"schemaArray":{"type":"array","minItems":1,"items":{"$ref":"#"}},"positiveInteger":{"type":"integer","minimum":0},"positiveIntegerDefault0":{"allOf":[{"$ref":"#/definitions/positiveInteger"},{"default":0}]},"simpleTypes":{"enum":["array","boolean","integer","null","number","object","string"]},"stringArray":{"type":"array","items":{"type":"string"},"minItems":1,"uniqueItems":true}},"type":"object","properties":{"id":{"type":"string","format":"uri"},"$schema":{"type":"string","format":"uri"},"title":{"type":"string"},"description":{"type":"string"},"default":{},"multipleOf":{"type":"number","minimum":0,"exclusiveMinimum":true},"maximum":{"type":"number"},"exclusiveMaximum":{"type":"boolean","default":false},"minimum":{"type":"number"},"exclusiveMinimum":{"type":"boolean","default":false},"maxLength":{"$ref":"#/definitions/positiveInteger"},"minLength":{"$ref":"#/definitions/positiveIntegerDefault0"},"pattern":{"type":"string","format":"regex"},"additionalItems":{"anyOf":[{"type":"boolean"},{"$ref":"#"}],"default":{}},"items":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/schemaArray"}],"default":{}},"maxItems":{"$ref":"#/definitions/positiveInteger"},"minItems":{"$ref":"#/definitions/positiveIntegerDefault0"},"uniqueItems":{"type":"boolean","default":false},"maxProperties":{"$ref":"#/definitions/positiveInteger"},"minProperties":{"$ref":"#/definitions/positiveIntegerDefault0"},"required":{"$ref":"#/definitions/stringArray"},"additionalProperties":{"anyOf":[{"type":"boolean"},{"$ref":"#"}],"default":{}},"definitions":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"properties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"patternProperties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"dependencies":{"type":"object","additionalProperties":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/stringArray"}]}},"enum":{"type":"array","minItems":1,"uniqueItems":true},"type":{"anyOf":[{"$ref":"#/definitions/simpleTypes"},{"type":"array","items":{"$ref":"#/definitions/simpleTypes"},"minItems":1,"uniqueItems":true}]},"allOf":{"$ref":"#/definitions/schemaArray"},"anyOf":{"$ref":"#/definitions/schemaArray"},"oneOf":{"$ref":"#/definitions/schemaArray"},"not":{"$ref":"#"}},"dependencies":{"exclusiveMaximum":["maximum"],"exclusiveMinimum":["minimum"]},"default":{}}

/***/ }),

/***/ 636:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wallet",attrs:{"id":"wallet"}},[_c('v-app',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card',{style:({ height: '100vh', backgroundImage: 'url(' + _vm.background_img + ')', backgroundRepeat: 'round;' })},[_c('v-container',{staticClass:"v-main paTop0",style:({backgroundImage: 'url(' + _vm.background_img + ')' })},[_c('v-card-actions',{staticClass:"padding0"},[_c('v-card-title'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('p',{staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(_vm.$props.version))])],1),_vm._v(" "),(_vm.wallet.undefined)?_c('v-card',{staticClass:"v-shadow transaction-undefined"},[_c('p',[_vm._v("申請を行っています。しばらくお待ち下さい。"),_c('br'),_vm._v("※この処理には数分かかる場合がございます。")])]):_vm._e(),_vm._v(" "),(_vm.wallet.top_page)?_c('v-card',{staticClass:"uq_card_shadow maBottom30 mosaic",attrs:{"flat":""}},[_c('v-card-text',{staticClass:"uq_board pa0"},[_vm._v("あなたのUQ残高")]),_vm._v(" "),_c('v-card-text',{staticClass:"pa5",attrs:{"id":"balance"}},[_vm._v(_vm._s(_vm.wallet.mosaic_balance)+" UQ")]),_vm._v(" "),_c('v-card-text',{staticClass:"uq_board pa0"},[_vm._v("取得可能な有給休暇は")]),_vm._v(" "),_c('v-card-text',{staticClass:"uq_day pa5"},[_vm._v(_vm._s(_vm.wallet.uq_day)+"日"),_c('span',{staticClass:"middle"},[_vm._v("と")]),_vm._v(_vm._s(_vm.wallet.uq_hours)+"時間"+_vm._s(_vm.wallet.uq_minutes)+"分")])],1):_vm._e()],1),_vm._v(" "),_c('v-container',{staticClass:"v-main pa0",attrs:{"fluid":""}},[_c('v-card',{staticClass:"v-shadow maBottom30 shinsei_form",attrs:{"flat":""}},[_c('span',{staticClass:"tile_board color_white pa10_0"},[_vm._v("有給申請")]),_vm._v(" "),_vm._l((_vm.validation),function(item,index){return _c('div',{key:index,staticClass:"errorLabel"},[(item!==true)?_c('div',[_vm._v(_vm._s(item))]):_vm._e()])}),_vm._v(" "),_c('div',{staticClass:"form-group v-card__title paTop20 back_092033 border-top-1px-274054"},[_c('div',{staticClass:"form-left"},[_c('label',{staticClass:"input_label"},[_vm._v("休暇予定日")])]),_vm._v(" "),_c('div',{staticClass:"form-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.toDate),expression:"toDate"}],staticClass:"form-control",attrs:{"name":"today","id":"today","type":"date"},domProps:{"value":(_vm.toDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.toDate=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group v-card__title back_092033"},[_c('div',{staticClass:"form-left"},[_c('label',{staticClass:"input_label"},[_vm._v("取得時間")])]),_vm._v(" "),_c('div',{staticClass:"form-time"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.day),expression:"day"}],attrs:{"type":"number","suffix":"日"},domProps:{"value":(_vm.day)},on:{"input":function($event){if($event.target.composing){ return; }_vm.day=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"suffix"},[_vm._v("日")])]),_vm._v(" "),_c('div',{staticClass:"color_white"},[_vm._v("と")]),_vm._v(" "),_c('div',{staticClass:"form-time"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hour),expression:"hour"}],attrs:{"type":"number","suffix":"時間"},domProps:{"value":(_vm.hour)},on:{"input":function($event){if($event.target.composing){ return; }_vm.hour=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"suffix"},[_vm._v("時間")])]),_vm._v(" "),_c('div',{staticClass:"form-time"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.min),expression:"min"}],attrs:{"type":"number","suffix":"分"},domProps:{"value":(_vm.min)},on:{"input":function($event){if($event.target.composing){ return; }_vm.min=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"suffix"},[_vm._v("分")])])]),_vm._v(" "),_c('div',{staticClass:"form-group v-card__title back_092033"},[_c('div',{staticClass:"form-left"},[_c('label',{staticClass:"input_label"},[_vm._v("備考")])]),_vm._v(" "),_c('div',{staticClass:"form-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.message),expression:"message"}],staticClass:"v-form",attrs:{"id":"v-model-message","counter":1024,"placeholder":"例：私用のため"},domProps:{"value":(_vm.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.message=$event.target.value}}})])]),_vm._v(" "),_c('v-flex',{staticClass:"paBottom10"},[_c('v-btn',{staticClass:"white--text f-bold shinsei-btn pa5_10per",on:{"click":function($event){_vm.openModal()}}},[_c('span',{staticClass:"color_092033"},[_vm._v("申請")])])],1)],2)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"example-modal-window"},[(_vm.modal)?_c('ConfirmationModal',{on:{"close":_vm.closeModal}},[_c('p',{attrs:{"id":"input_massage_text"}},[_vm._v("以下の内容で申請します。")]),_vm._v(" "),_c('div',[_c('p',[_vm._v("有給休暇日 :"+_vm._s(this.$data.toDate))]),_vm._v(" "),_c('p',[_vm._v("休暇期間 :"+_vm._s(this.amount_hd)),_c('span',{staticClass:"small"},[_vm._v("("+_vm._s(this.toAmount)+"UQ)")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(this.$data.message))])]),_vm._v(" "),_c('template',{slot:"footer"},[(_vm.mosaic.nonapproval)?_c('button',{on:{"click":_vm.doSend}},[_vm._v("送信")]):_vm._e(),_vm._v(" "),(_vm.mosaic.approval)?_c('button',{on:{"click":_vm.doSend}},[_vm._v("送信")]):_vm._e()])],2):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 637:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wallet",attrs:{"id":"wallet"}},[_c('v-app',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card',[(_vm.getAddress.login_page)?_c('div',[_c('Login',{attrs:{"address":_vm.getAddress.address,"public_key":_vm.getAddress.publicKey,"private_key":_vm.getAddress.privateKey,"version":_vm.version}})],1):_vm._e(),_vm._v(" "),(_vm.getAddress.waitting_page)?_c('div',[_c('Waitting',{attrs:{"version":_vm.version}})],1):_vm._e(),_vm._v(" "),(_vm.getAddress.top_page)?_c('div',[_c('Top',{attrs:{"version":_vm.version}})],1):_vm._e()])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 638:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('Wallet')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 639:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd97a0f4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Output_vue__ = __webpack_require__(641);
function injectStyle (ssrContext) {
  __webpack_require__(640)
}
var normalizeComponent = __webpack_require__(10)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bd97a0f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd97a0f4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Output_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 640:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 641:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"output"},[_c('v-container',{staticClass:"v-main paTop0",attrs:{"fluid":""}},[_c('br'),_vm._v(" "),_c('v-card',{staticClass:"v-shadow maBottom30 output_board",attrs:{"flat":""}},[_c('span',{staticClass:"tile_board uq_color boa"},[_vm._v("処理中です。"),_c('br'),_vm._v("しばらくお待ちください。")]),_vm._v(" "),_c('div',{staticClass:"pa10 uq_amount"},[_c('span',{attrs:{"id":"amount"}},[_vm._v(_vm._s(_vm.$route.params.amount))]),_vm._v("uq")]),_vm._v(" "),_c('div',{staticClass:"details"},[_c('p',{staticClass:"massage"},[_vm._v("有給休暇日："+_vm._s(_vm.$route.params.date))]),_vm._v(" "),_c('p',[_vm._v("休暇期間："+_vm._s(_vm.$route.params.amount_hd))]),_vm._v(" "),_c('p',[_vm._v("【備考】"),_c('br'),_vm._v(_vm._s(_vm.$route.params.massege))])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 642:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyTransaction_vue__ = __webpack_require__(259);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ab28493_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyTransaction_vue__ = __webpack_require__(644);
function injectStyle (ssrContext) {
  __webpack_require__(643)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ab28493"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyTransaction_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ab28493_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyTransaction_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 643:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 644:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my_transaction"},[_c('v-container',{staticClass:"v-main paTop0",attrs:{"fluid":""}},[_c('div',{attrs:{"id":"transfers"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 645:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__ = __webpack_require__(260);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8130fd6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__ = __webpack_require__(647);
function injectStyle (ssrContext) {
  __webpack_require__(646)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a8130fd6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8130fd6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 646:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 647:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"settings"}},[_c('ol',{staticClass:"sample1"},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'MyPage' }}},[_vm._v("マイページ")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'MyWalletInfo' }}},[_vm._v("マイウォレットの情報")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'MyAddress' }}},[_vm._v("マイアドレス")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'AccountList' }}},[_vm._v("所属グループのアカウント一覧")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'ReturnUq' }}},[_vm._v("UQの返却")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'RestoreWallet' }}},[_vm._v("アカウントの復元")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: '' }},nativeOn:{"click":function($event){return _vm.openModal($event)}}},[_vm._v("ログアウト")])],1),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"example-modal-window"},[(_vm.modal)?_c('ConfirmationModal',{on:{"close":_vm.closeModal}},[_c('p',{attrs:{"id":"input_massage_text f-bold"}},[_vm._v("ログアウトしますか？")]),_vm._v(" "),_c('div'),_vm._v(" "),_c('template',{slot:"footer"},[_c('button',{on:{"click":_vm.logout}},[_vm._v("ログアウト")])])],2):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"space"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"https://mgt.smart-uq.com/users/password/new"}},[_vm._v("パスワード再設定はこちら")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 648:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyAddress_vue__ = __webpack_require__(261);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d8a2459_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyAddress_vue__ = __webpack_require__(650);
function injectStyle (ssrContext) {
  __webpack_require__(649)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d8a2459"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyAddress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d8a2459_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyAddress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 649:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 650:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"my_wallet"}},[_c('h1',[_vm._v(_vm._s(this.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(this.wallet.address))]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'MyWalletPrivate' }}},[_vm._v("プライベートキーを表示")]),_vm._v(" "),_c('div',[(_vm.modal)?_c('ConfirmationModal',{on:{"close":_vm.closeModal}},[_c('p',{attrs:{"id":"input_massage_text f-bold"}}),_vm._v(" "),_c('div',[_vm._v("\n                アカウントの鍵情報を登録\n            ")]),_vm._v(" "),_c('template',{slot:"footer"},[_c('button',{on:{"click":_vm.sendInfo}},[_vm._v("送信")])])],2):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 651:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyWalletInfo_vue__ = __webpack_require__(262);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cc48cb1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyWalletInfo_vue__ = __webpack_require__(653);
function injectStyle (ssrContext) {
  __webpack_require__(652)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5cc48cb1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyWalletInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cc48cb1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyWalletInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 652:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 653:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"my_wallet_info"}},[_c('v-card',{staticClass:"maTop30",attrs:{"flat":""}},[_c('span',{staticClass:"tile_board"},[_vm._v("XEM残高")]),_vm._v(" "),_c('v-card-text',{staticClass:"pa10"},[_vm._v(_vm._s(_vm.wallet.balance)+" xem")]),_vm._v(" "),_c('span',{staticClass:"tile_board"},[_vm._v("アドレス")]),_vm._v(" "),_c('v-card-text',{staticClass:"pa10"},[_vm._v(_vm._s(_vm.wallet.address))]),_vm._v(" "),_c('qriously',{attrs:{"size":_vm.qrSize},model:{value:(_vm.qrJson),callback:function ($$v) {_vm.qrJson=$$v},expression:"qrJson"}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text f-bold",attrs:{"color":"blue"},on:{"click":function($event){_vm.openModalInfo()}}},[_vm._v("wallet情報")]),_vm._v(" "),_c('v-btn',{staticClass:"white--text f-bold",attrs:{"color":"blue"},on:{"click":function($event){_vm.openModalSingUp()}}},[_vm._v("アカウント登録")]),_vm._v(" "),(_vm.info_modal)?_c('ConfirmationModal',{on:{"close":_vm.closeModal}},[_c('p',[_vm._v("Walletの情報です。"),_c('br'),_vm._v("公開鍵、秘密鍵は必ずバックアップ下さい。")]),_vm._v(" "),_c('div',[_c('p',[_vm._v("公開鍵")]),_vm._v(" "),_c('p',{staticClass:"border_s_ddd"},[_vm._v(_vm._s(this.wallet.address))]),_vm._v(" "),_c('p',[_vm._v("秘密鍵")]),_vm._v(" "),_c('p',{staticClass:"border_s_ddd"},[_vm._v(_vm._s(this.wallet.privateKey))])])]):_vm._e(),_vm._v(" "),(_vm.signup_modal)?_c('ConfirmationModal',{on:{"close":_vm.closeModal}},[_c('p',[_vm._v("アカウントの登録をお願いします。")]),_vm._v(" "),_c('div',[_c('p',[_vm._v("アカウント名")]),_vm._v(" "),_c('v-text-field',{staticClass:"v-form",attrs:{"label":"アカウント名","placeholder":"アカウント名"},model:{value:(_vm.account_name),callback:function ($$v) {_vm.account_name=$$v},expression:"account_name"}}),_vm._v(" "),_c('v-text-field',{staticClass:"v-form",attrs:{"label":"メールアドレス","placeholder":"メールアドレス"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_vm._v(" "),_c('template',{slot:"footer"},[_c('button',{on:{"click":_vm.signupSend}},[_vm._v("アカウント登録")])])],2):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 654:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyWalletPrivate_vue__ = __webpack_require__(263);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e29f1ef2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyWalletPrivate_vue__ = __webpack_require__(656);
function injectStyle (ssrContext) {
  __webpack_require__(655)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e29f1ef2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyWalletPrivate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e29f1ef2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyWalletPrivate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 655:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 656:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"my_wallet_private"}},[_c('h1',[_vm._v(_vm._s(this.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(this.wallet.privateKey))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(this.description))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 657:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_History_vue__ = __webpack_require__(264);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22c08fe6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_History_vue__ = __webpack_require__(659);
function injectStyle (ssrContext) {
  __webpack_require__(658)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-22c08fe6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_History_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22c08fe6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_History_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 658:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 659:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"history"}},[(_vm.wallet.approval)?_c('div',_vm._l((_vm.wallet.application_logs),function(item,index){return _c('div',{key:index,staticClass:"errorLabel"},[_c('div',{staticClass:"transaction_card wauto"},[_c('div',{staticClass:"applying"},[_vm._v("申請中")]),_vm._v(" "),_c('p',{staticClass:"address_tag"},[_vm._v("申請日 : "),_c('span',{staticClass:"request_date"},[_vm._v(" "+_vm._s(item[0])+" ")]),_vm._v(" "),_c('span',{staticClass:"request_amount"},[_vm._v(" "+_vm._s(item[1])+" uq")])]),_vm._v(" "),_c('p',{staticClass:"uq_request"},[_c('span',{staticClass:"tag_name",attrs:{"id":""}},[_vm._v(" 申請時間")]),_vm._v(" "),_c('span',{staticClass:"uq_amount"},[_vm._v(" "+_vm._s(item[2])+" ")])]),_vm._v(" "),_c('p',{staticClass:"massage",domProps:{"innerHTML":_vm._s(item[3])}})])])})):_vm._e(),_vm._v(" "),_vm._l((_vm.wallet.transactions),function(item,index){return _c('div',{key:index,staticClass:"errorLabel"},[_c('div',{staticClass:"transaction_card wauto"},[_c('p',{staticClass:"address_tag"},[_vm._v("申請日 : "),_c('span',{staticClass:"request_date"},[_vm._v(" "+_vm._s(item[0])+" ")]),_vm._v(" "),_c('span',{staticClass:"request_amount"},[_vm._v(" "+_vm._s(item[1])+" uq")])]),_vm._v(" "),_c('p',{staticClass:"uq_request"},[_c('span',{staticClass:"tag_name",attrs:{"id":""}},[_vm._v(" 申請時間")]),_vm._v(" "),_c('span',{staticClass:"uq_amount"},[_vm._v(" "+_vm._s(item[2])+" ")])]),_vm._v(" "),_c('p',{staticClass:"massage",domProps:{"innerHTML":_vm._s(item[3])}})])])}),_vm._v(" "),_c('div',{staticClass:"space"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 660:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RestoreWallet_vue__ = __webpack_require__(265);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_254ce627_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RestoreWallet_vue__ = __webpack_require__(662);
function injectStyle (ssrContext) {
  __webpack_require__(661)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-254ce627"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RestoreWallet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_254ce627_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RestoreWallet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 661:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 662:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"restore_wallet"}},[_c('h1',[_vm._v(_vm._s(this.title))]),_vm._v(" "),_c('div',[_c('v-text-field',{staticClass:"v-form",attrs:{"id":"v-model-publickey","placeholder":"公開鍵を入力"},model:{value:(_vm.publickey),callback:function ($$v) {_vm.publickey=$$v},expression:"publickey"}}),_vm._v(" "),_c('v-text-field',{staticClass:"v-form",attrs:{"id":"v-model-secretkey","placeholder":"秘密鍵を入力"},model:{value:(_vm.secretkey),callback:function ($$v) {_vm.secretkey=$$v},expression:"secretkey"}}),_vm._v(" "),[_c('button',{staticClass:"save-btn",on:{"click":_vm.setData}},[_vm._v("復元")])]],2),_vm._v(" "),_c('br'),_c('p',[_vm._v(_vm._s(this.description))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 663:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyPage_vue__ = __webpack_require__(266);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cc953a6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyPage_vue__ = __webpack_require__(666);
function injectStyle (ssrContext) {
  __webpack_require__(664)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2cc953a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cc953a6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 664:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 665:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nem_sdk__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_nem_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nemWrapper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getAccountList__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mosaicTransfer__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper__ = __webpack_require__(28);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};






var others = /** @class */ (function () {
    function others() {
        var _this = this;
        /*account data */
        this.undefined = false;
        this.lastId = '';
        /*htmlにわたす */
        this.balance = 'loading...';
        this.balance_uq = 0;
        this.sum = 'loading...';
        this.sum_uq = 0;
        this.carry_over = "loading...";
        this.carry_over_uq = 0;
        this.expiration = "loading...";
        this.expiration_uq = 0;
        this.check5day = '';
        this.recieve_data_string = [];
        this.service_years = '';
        this.email = '';
        this.company_name = '';
        this.user_name = '';
        /*others*/
        this.recieve_this_year_uq = 0;
        this.recieve_last_year_uq = 0;
        this.nowY = 'tmp';
        this.nem = new __WEBPACK_IMPORTED_MODULE_1__nemWrapper__["a" /* default */]();
        this.nowd = new Date();
        this.recieve_data = [];
        this.getAccountList = new __WEBPACK_IMPORTED_MODULE_2__getAccountList__["a" /* default */]();
        this.mosaicTransfer = new __WEBPACK_IMPORTED_MODULE_3__mosaicTransfer__["a" /* default */]();
        this.helper = new __WEBPACK_IMPORTED_MODULE_5__helper__["a" /* default */]();
        //必要な有給
        this.gimu = 4000; //5日*8時間*100
        this.mosaicTransfer.load() //アドレス取得
            .then(function () {
            _this.set_nowY(); //年度セット
            _this.getAccountMo() //残高取得  
                .then(function () {
                _this.setUserInfo(); //勤続年数セット
                _this.getTransactions(_this.mosaicTransfer.address, ''); //トランザクション取得
                //this.getTransactions("NC5PTZ47JFGJP4SHNUDOGJKDTA6RQGOZXUTCUDLW",'')
            });
        }).catch(function (error) {
            console.error(error);
        });
    }
    //年度をセット
    others.prototype.set_nowY = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.getTerm(this.nowd.getFullYear(), this.nowd.getMonth() + 1)];
                    case 1:
                        _a.nowY = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    //nemのdate取得
    others.prototype.returnd = function (timeStamp) {
        return __awaiter(this, void 0, void 0, function () {
            var NEM_EPOCH;
            return __generator(this, function (_a) {
                NEM_EPOCH = Date.UTC(2015, 2, 29, 0, 6, 25, 0);
                return [2 /*return*/, new Date(timeStamp * 1000 + NEM_EPOCH)];
            });
        });
    };
    // モザイクの残高取得
    others.prototype.getAccountMo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var yourMosaicName, result, smart_uq_data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        yourMosaicName = this.mosaicTransfer.yourMosaicName;
                        return [4 /*yield*/, this.nem.getAccountMo(this.mosaicTransfer.address)
                            //let result = await this.nem.getAccountMo("NC5PTZ47JFGJP4SHNUDOGJKDTA6RQGOZXUTCUDLW")
                            /*smart-uq のデータだけ抽出*/
                        ];
                    case 1:
                        result = _a.sent();
                        smart_uq_data = result.data.filter(function (value) {
                            return value.mosaicId.name === yourMosaicName;
                        });
                        if (smart_uq_data[0] && smart_uq_data[0].quantity) {
                            this.balance_uq = smart_uq_data[0].quantity;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    //トランザクション履歴取得
    others.prototype.getTransactions = function (address, id) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                __WEBPACK_IMPORTED_MODULE_0_nem_sdk___default.a.com.requests.account.transactions.all(this.nem.endpoint, address, '', id)
                    .then(function (res) {
                    console.log(res.data);
                    if (res.data.length == 0) {
                        console.log("finish getting data");
                        _this.set();
                    }
                    for (var i = 0; i < res.data.length; i++) {
                        _this.cal(res.data[i]); //計算する
                        if (i == res.data.length - 1) { //次の25件取得
                            id = res.data[i].meta.id;
                            _this.getTransactions(address, id);
                        }
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    others.prototype.cal = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var flag_ThisTermSendUq, flag_kurikoshi, _a, _b, tran, signature, recipient, timestamp, amount, message;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.nem.checkRecieveUq(data.transaction, this.mosaicTransfer.yourMosaicName, this.mosaicTransfer.address)];
                    case 1:
                        if (!_c.sent()) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.checkThisTermSendUq(data.transaction.message.payload)];
                    case 2:
                        flag_ThisTermSendUq = _c.sent();
                        return [4 /*yield*/, this.checkKurikoshi(data.transaction.message.payload)];
                    case 3:
                        flag_kurikoshi = _c.sent();
                        if (!flag_ThisTermSendUq) return [3 /*break*/, 4];
                        this.recieve_this_year_uq += parseInt(data.transaction.mosaics[0].quantity);
                        return [3 /*break*/, 6];
                    case 4:
                        if (!flag_kurikoshi) return [3 /*break*/, 6];
                        //console.log("message:"+this.nem.utf8_hex_string_to_string(data.transaction.message.payload))
                        _a = this;
                        //console.log("message:"+this.nem.utf8_hex_string_to_string(data.transaction.message.payload))
                        _b = _a.recieve_last_year_uq;
                        return [4 /*yield*/, this.getKurikoshi(data.transaction.message.payload)];
                    case 5:
                        //console.log("message:"+this.nem.utf8_hex_string_to_string(data.transaction.message.payload))
                        _a.recieve_last_year_uq = _b + _c.sent();
                        _c.label = 6;
                    case 6: return [3 /*break*/, 10];
                    case 7:
                        if (!(data.transaction.mosaics !== undefined)) return [3 /*break*/, 10];
                        if (!(data.transaction.message.payload !== undefined)) return [3 /*break*/, 10];
                        tran = data.transaction;
                        signature = tran.signer;
                        recipient = tran.recipient;
                        return [4 /*yield*/, this.nem.dispTimeStamp(tran.timeStamp)];
                    case 8:
                        timestamp = _c.sent();
                        amount = tran.amount / 1000000;
                        return [4 /*yield*/, this.nem.utf8_hex_string_to_string(tran.message.payload)];
                    case 9:
                        message = _c.sent();
                        if (message != null && message.indexOf("[[[年次有給申請]]]") !== -1 && message.indexOf("有給休暇日：" + this.nowY + "-") !== -1) {
                            this.sum_uq += amount;
                        }
                        _c.label = 10;
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    //年次支給分か判定
    others.prototype.checkThisTermSendUq = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            var a;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.nem.utf8_hex_string_to_string(payload)];
                    case 1:
                        if (!_a.sent()) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.nem.utf8_hex_string_to_string(payload)];
                    case 2:
                        a = _a.sent();
                        //return (a.indexOf("[[["+this.nowY+"年次有給休暇]]]")!==-1)
                        if (a.indexOf("[[[" + this.nowY + "年次有給休暇]]]") !== -1) {
                            return [2 /*return*/, true];
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/, false];
                }
            });
        });
    };
    //繰越か判定
    others.prototype.checkKurikoshi = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            var a;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.nem.utf8_hex_string_to_string(payload)];
                    case 1:
                        if (!_a.sent()) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.nem.utf8_hex_string_to_string(payload)];
                    case 2:
                        a = _a.sent();
                        if (a.indexOf("[[[" + (this.nowY - 1) + "年度繰越分]]]") !== -1) {
                            return [2 /*return*/, true];
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/, false];
                }
            });
        });
    };
    //繰越UQを取得
    others.prototype.getKurikoshi = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            var a;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.nem.utf8_hex_string_to_string(payload)];
                    case 1:
                        a = _a.sent();
                        a = a.replace("[[[" + (this.nowY - 1) + "年度繰越分]]] ", "");
                        a = a.replace("UQ", "");
                        return [2 /*return*/, parseInt(a)];
                }
            });
        });
    };
    //年度を返す関数
    others.prototype.getTerm = function (Y, M) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (1 <= M && M <= 3)
                    return [2 /*return*/, Y - 1];
                else
                    return [2 /*return*/, Y];
                return [2 /*return*/];
            });
        });
    };
    //最後の処理
    others.prototype.set = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                //this.sum_uq = await this.getSum()
                console.log("this.sum_uq");
                console.log(this.sum_uq);
                this.calKurikoshi();
                this.checkGimu();
                this.allUqToTime();
                this.recieveDataToArray();
                return [2 /*return*/];
            });
        });
    };
    //使用合計計算
    others.prototype.getSum = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    /*uqを時間に*/
    others.prototype.allUqToTime = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.balance = this.nem.amount_hd(this.balance_uq);
                this.sum = this.nem.amount_hd(this.sum_uq);
                this.carry_over = this.nem.amount_hd(this.carry_over_uq);
                this.expiration = this.nem.amount_hd(this.expiration_uq);
                return [2 /*return*/];
            });
        });
    };
    //有給が５日以上取得できているかを判定して、OKか、残り時間を返す
    others.prototype.checkGimu = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.sum_uq > this.gimu)
                    this.check5day = "５日以上有給を取得しています。";
                else
                    this.check5day = "残り" + this.nem.amount_hd(this.gimu - this.sum_uq) + "の申請が必要です。";
                return [2 /*return*/];
            });
        });
    };
    //繰越分計算
    others.prototype.calKurikoshi = function () {
        return __awaiter(this, void 0, void 0, function () {
            var a;
            return __generator(this, function (_a) {
                a = this.recieve_last_year_uq - this.sum_uq //繰越分ー今年度取得分
                ;
                console.log("今年度配布分");
                console.log(this.recieve_this_year_uq);
                console.log("昨年度配布分");
                console.log(this.recieve_last_year_uq);
                console.log(a);
                if (a >= 0) {
                    this.expiration_uq = a; //失効
                    this.carry_over_uq = this.recieve_this_year_uq; //来年度繰越可能額　＝　年次有給休暇　
                }
                else if (this.recieve_this_year_uq + a > 0) { //年次有給休暇　＋　昨年度繰越分　ー　今年度取得分 
                    this.expiration_uq = 0; //失効なし
                    this.carry_over_uq = this.recieve_this_year_uq + a; //年次有給休暇　＋　昨年度繰越分　ー　今年度取得分　＝　来年度繰越可能額
                }
                else {
                    this.expiration_uq = 0; //失効なし
                    this.carry_over_uq = 0; //繰越なし
                }
                console.log(this.recieve_data);
                return [2 /*return*/];
            });
        });
    };
    others.prototype.recieveDataToArray = function () {
        return __awaiter(this, void 0, void 0, function () {
            var i, tmp;
            return __generator(this, function (_a) {
                for (i = 0; i < this.recieve_data.length; i++) {
                    tmp = {
                        timeStamp: this.nem.dispTimeStamp(this.recieve_data[i].timeStamp),
                        uq: this.recieve_data[i].mosaics[0].quantity / 1000,
                        time: this.nem.amount_hd(this.recieve_data[i].mosaics[0].quantity / 1000),
                        message: this.nem.utf8_hex_string_to_string(this.recieve_data[i].message.payload)
                    };
                    console.log(tmp);
                    this.recieve_data_string.push(tmp);
                }
                return [2 /*return*/];
            });
        });
    };
    //勤続年数計算
    others.prototype.getUserInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log("in getuserinfo");
                        return [4 /*yield*/, this.helper.load('User-Info')];
                    case 1:
                        data = _a.sent();
                        if (!(data === null || data === "")) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getUserInfofromAPI()];
                    case 2:
                        data = _a.sent();
                        this.helper.save('User-Info', data);
                        _a.label = 3;
                    case 3: return [2 /*return*/, data];
                }
            });
        });
    };
    /*ユーザー情報取得*/
    /*APIから */
    others.prototype.getUserInfofromAPI = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, url, headers, access_token, uid, client, response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.mosaicTransfer.address != "")) return [3 /*break*/, 3];
                        result = [];
                        url = this.helper.path + "auth_users/user_info/" + this.mosaicTransfer.address;
                        //let url = this.helper.path + "auth_users/user_info/NC5PTZ47JFGJP4SHNUDOGJKDTA6RQGOZXUTCUDLW"
                        console.log("in getuserinfo fromapi");
                        return [4 /*yield*/, this.helper.loadHeaders()];
                    case 1:
                        headers = _a.sent();
                        access_token = headers["access-token"];
                        uid = headers["uid"];
                        client = headers["client"];
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, {
                                headers: { "Content-Type": "application/json",
                                    "access-token": access_token,
                                    "uid": uid,
                                    "client": client },
                                data: {}
                            }).then(function (response) {
                                console.log('status:', response.status); // 200
                                console.log(response.data);
                                result = response.data.data;
                                // catchでエラー時の挙動を定義する
                            }).catch(function (error) {
                                if (error.response && error.response.status == "401") {
                                    console.log("please login");
                                    _this.helper.pleaseLogin();
                                }
                            })];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, result[0]];
                    case 3:
                        this.helper.pleaseLogin();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /*変数に代入 */
    others.prototype.setUserInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user_info;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUserInfo()];
                    case 1:
                        user_info = _a.sent();
                        return [4 /*yield*/, this.setVar(user_info)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /*変数に代入 */
    others.prototype.setVar = function (user_info) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (user_info == null || user_info.email == "")
                            this.helper.pleaseLogin();
                        this.email = user_info.email;
                        this.user_name = user_info.name;
                        this.company_name = user_info.company_name;
                        _a = this;
                        return [4 /*yield*/, this.getServiceYears(user_info.day, user_info.mon, user_info.year)];
                    case 1:
                        _a.service_years = _b.sent();
                        console.log(this.service_years + "this.service_years");
                        return [2 /*return*/];
                }
            });
        });
    };
    /*勤務年数計算 */
    others.prototype.getServiceYears = function (day, mon, year) {
        return __awaiter(this, void 0, void 0, function () {
            var myBirth, myMsec, myDay, DAYS_PER_MONTH, ageY, ageM, ageD;
            return __generator(this, function (_a) {
                if (day == 0) {
                    return [2 /*return*/, ""];
                }
                myBirth = new Date(year, mon - 1, day);
                myMsec = this.nowd.getTime() - myBirth.getTime();
                myDay = Math.floor(myMsec / (1000 * 60 * 60 * 24));
                DAYS_PER_MONTH = 365 / 12;
                ageY = Math.floor(myDay / 365);
                ageM = Math.floor((myDay - 365 * ageY) / DAYS_PER_MONTH);
                ageD = Math.floor((myDay - 365 * ageY - DAYS_PER_MONTH * ageM));
                return [2 /*return*/, "入社から" + ageY + "年" + ageM + "ヶ月" + ageD + "日"];
            });
        });
    };
    return others;
}());
/* harmony default export */ __webpack_exports__["a"] = (others);


/***/ }),

/***/ 666:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"my_page"}},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(this.user_title)),_c('v-btn',{attrs:{"fab":"","small":"","flat":""},on:{"click":_vm.updateStatus}},[_c('v-icon',[_vm._v("cached")])],1)],1),_vm._v(" "),_c('div',{staticClass:"box"},[_c('p',{staticClass:"sub-title"},[_vm._v("ユーザー名")]),_vm._v(" "),_c('p',{},[_vm._v(_vm._s(this.others.user_name))]),_vm._v(" "),_c('p',{staticClass:"sub-title"},[_vm._v("メールアドレス")]),_vm._v(" "),_c('p',{},[_vm._v(_vm._s(this.others.email))]),_vm._v(" "),_c('p',{staticClass:"sub-title"},[_vm._v("会社名")]),_vm._v(" "),_c('p',{},[_vm._v(_vm._s(this.others.company_name))]),_vm._v(" "),_c('p',{staticClass:"sub-title"},[_vm._v("勤務年数")]),_vm._v(" "),_c('p',{},[_vm._v(_vm._s(this.others.service_years))])]),_vm._v(" "),_c('p',{staticClass:"title"},[_c('span',{staticClass:"small"},[_vm._v(_vm._s(this.others.nowY)+"年度")]),_c('br'),_vm._v("\n        "+_vm._s(this.uq_title)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('p',{staticClass:"sub-title"},[_vm._v(_vm._s(this.sum_text))]),_vm._v(" "),_c('p',{staticClass:"time"},[_vm._v(_vm._s(this.others.sum))]),_vm._v(" "),_c('p',{staticClass:"uq"},[_vm._v(_vm._s(this.others.sum_uq)+" "+_vm._s(this.uq))]),_vm._v(" "),_c('p',{staticClass:"check5day"},[_vm._v(_vm._s(this.others.check5day))])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('p',{staticClass:"sub-title"},[_vm._v(_vm._s(this.balance_text))]),_vm._v(" "),_c('p',{staticClass:"time"},[_vm._v(_vm._s(this.others.balance))]),_vm._v(" "),_c('p',{staticClass:"uq"},[_vm._v(" "+_vm._s(this.others.balance_uq)+" "+_vm._s(this.uq))]),_vm._v(" "),(_vm.mosaic.show_kurikoshi)?_c('p',{staticClass:"small"},[_vm._v(_vm._s(this.expiration_text)),_c('br'),_vm._v("\n        "+_vm._s(this.others.expiration)+" ("+_vm._s(this.others.expiration_uq)+" "+_vm._s(this.uq)+")")]):_vm._e()]),_vm._v(" "),(_vm.mosaic.show_kurikoshi)?_c('div',{staticClass:"box"},[_c('p',{staticClass:"sub-title"},[_vm._v(_vm._s(this.carry_over_text))]),_vm._v(" "),_c('p',{staticClass:"time"},[_vm._v(_vm._s(this.others.carry_over)+" ")]),_vm._v(" "),_c('p',{staticClass:"uq"},[_vm._v(" "+_vm._s(this.others.carry_over_uq)+" "+_vm._s(this.uq))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"space"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 667:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountList_vue__ = __webpack_require__(268);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c32760c6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountList_vue__ = __webpack_require__(669);
function injectStyle (ssrContext) {
  __webpack_require__(668)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c32760c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c32760c6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 668:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 669:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"account_list"}},[_c('h1',[_vm._v("  "+_vm._s(this.title))]),_vm._v(" "),_c('p',{staticClass:"company"},[_vm._v(" 会社名： "),_c('span',{staticClass:"company_name"},[_vm._v(_vm._s(this.getAccountList.company))])]),_vm._v("\n            "+_vm._s(this.getAccountList.errorMessage)+"\n            "),_c('ul',_vm._l((this.getAccountList.accountList),function(value){return _c('li',[_c('span',{staticClass:"profile icon"}),_vm._v(" "+_vm._s(value)+"\n                ")])})),_vm._v(" "),_c('div',{staticClass:"space"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 670:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeCard_vue__ = __webpack_require__(269);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19fc4b38_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeCard_vue__ = __webpack_require__(678);
function injectStyle (ssrContext) {
  __webpack_require__(671)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-19fc4b38"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19fc4b38_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 671:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 672:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nemWrapper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper__ = __webpack_require__(28);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
//import nem from 'nem-sdk';
//import localForage from 'localforage';



var others = /** @class */ (function () {
    function others() {
        var _this = this;
        /*htmlにわたす */
        this.address = '';
        this.privateKey = '';
        this.publicKey = '';
        this.nem = new __WEBPACK_IMPORTED_MODULE_0__nemWrapper__["a" /* default */]();
        this.today = "";
        this.HH = "00";
        this.mm = "00";
        this.working_status = "";
        this.working_status_flag = false;
        this.in_at = "";
        this.out_at = "";
        this.last_data = [];
        this.helper = new __WEBPACK_IMPORTED_MODULE_2__helper__["a" /* default */]();
        this.setPlaceholder();
        this.load() //address取得
            .then(function () {
            _this.getStatus();
        }).catch(function (error) {
            console.error(error);
        });
    }
    // ローカルストレージから取得.
    /*async load() {
        let key = 'SmartUQ-Wallet'
        let result:any = await localForage.getItem(key)
        if (result !== null) {
            this.address = result.address
            this.privateKey = this.helper.Decrypt(result.privateKey)
            this.publicKey = result.publicKey
        }
        let key2 = 'Company-Info'
        let result2:any = await localForage.getItem(key2)
        if (result2 == null) {
            result2 = await this.nem.getCompanyInfoFromAPI(this.address)
        }

        return result
    }*/
    // ローカルストレージから取得.
    others.prototype.load = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        console.log("in kintaikanri load1");
                        return [4 /*yield*/, this.helper.load('SmartUQ-Wallet')];
                    case 1:
                        result = _b.sent();
                        if (!(result !== null)) return [3 /*break*/, 3];
                        this.address = result.address;
                        _a = this;
                        return [4 /*yield*/, this.helper.Decrypt(result.privateKey)];
                    case 2:
                        _a.privateKey = _b.sent();
                        this.publicKey = result.publicKey;
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    others.prototype.getStatus = function () {
        var _this = this;
        var key = 'TimeCard';
        console.log("in kintaikanri getstatus");
        //let result:any =  await this.helper.load(key)
        this.getStatusFromAPI().then(function (result) {
            if (result != undefined)
                _this.setStatus(result, key);
        });
    };
    others.prototype.setStatus = function (result, key) {
        this.working_status = result.working_status;
        if (this.working_status == "勤務中") {
            this.working_status_flag = true;
        }
        else {
            this.working_status_flag = false;
        }
        this.in_at = result.in_at;
        this.out_at = result.out_at;
        var y = result.in_at_y;
        var m = result.in_at_m;
        var d = result.in_at_d;
        var hh = parseInt(this.in_at.slice(2, 4));
        var mm = parseInt(this.in_at.slice(5, 7));
        this.in_at_date = new Date(y, m, d, hh, mm);
        console.log(this.in_at_date);
        this.last_data = result.last_data;
        //this.helper.save(key,result)
    };
    others.prototype.getStatusFromAPI = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, url, headers, access_token, uid, client, response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = [];
                        if (!(this.address != null && this.address != "")) return [3 /*break*/, 3];
                        url = this.helper.path + "auth_users/working_status/" + this.address;
                        console.log(url);
                        console.log("in kintaikanri getstatus from api");
                        return [4 /*yield*/, this.helper.loadHeaders()];
                    case 1:
                        headers = _a.sent();
                        access_token = headers["access-token"];
                        uid = headers["uid"];
                        client = headers["client"];
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url, {
                                headers: { "Content-Type": "application/json",
                                    "access-token": access_token,
                                    "uid": uid,
                                    "client": client },
                                data: {}
                            }).then(function (response) {
                                console.log('status:', response.status); // 200
                                console.log(response.data);
                                result = response.data.data[0];
                                // catchでエラー時の挙動を定義する
                            }).catch(function (error) {
                                if (error.response && error.response.status == "401") {
                                    console.log("please login");
                                    _this.helper.pleaseLogin();
                                }
                            })];
                    case 2:
                        response = _a.sent();
                        console.log(result);
                        return [2 /*return*/, result];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    others.prototype.setPlaceholder = function () {
        var today = new Date();
        var year = today.getFullYear();
        var month = ("0" + (today.getMonth() + 1)).slice(-2);
        var day = ("0" + today.getDate()).slice(-2);
        this.today = year + "-" + month + "-" + day;
        this.HH = ('0' + today.getHours()).slice(-2);
        this.mm = ('0' + today.getMinutes()).slice(-2);
    };
    return others;
}());
/* harmony default export */ __webpack_exports__["a"] = (others);


/***/ }),

/***/ 673:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Clock_vue__ = __webpack_require__(270);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc6a2484_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Clock_vue__ = __webpack_require__(675);
function injectStyle (ssrContext) {
  __webpack_require__(674)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dc6a2484"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Clock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc6a2484_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Clock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 674:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 675:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container"}},[_c('div',{attrs:{"id":"time"}},[_c('span',{attrs:{"id":"date"}},[_vm._v(_vm._s(_vm.month)+"月"+_vm._s(_vm.day)+"日 ("+_vm._s(_vm.dayOfWeek)+")")]),_vm._v(" "),_c('span',{staticClass:"time-item",attrs:{"id":"hours"}},[_vm._v(_vm._s(_vm.hours))]),_vm._v(" :\n    "),_c('span',{staticClass:"time-item",attrs:{"id":"minutes"}},[_vm._v(_vm._s(_vm.minutes))]),_vm._v(" "),_c('span',{staticClass:"time-item",attrs:{"id":"seconds"}},[_vm._v(_vm._s(_vm.seconds))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 677:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 678:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"time_card"}},[_c('h1',[_vm._v("  "+_vm._s(this.title)+" "),_c('v-btn',{attrs:{"fab":"","small":"","flat":""},on:{"click":_vm.updateStatus}},[_c('v-icon',[_vm._v("cached")])],1)],1),_vm._v(" "),_c('div',[_c('Clock',{attrs:{"location":"TOKYO","diff":0}})],1),_vm._v(" "),_c('div',{staticClass:"status"},[_vm._v("\n        現在\n        "),(this.kintai.working_status_flag === true)?_c('span',{staticClass:"f-bold f-color-green big"},[_vm._v("\n            "+_vm._s(this.kintai.working_status)+"\n        ")]):_c('span',{staticClass:"f-bold f-color-orange big"},[_vm._v("\n            "+_vm._s(this.kintai.working_status)+"\n        ")]),_vm._v("  \n        です\n    ")]),_vm._v(" "),_c('div',{staticClass:"working-info"},[_vm._v("\n        "+_vm._s(this.kintai.in_at)+"\n        "+_vm._s(this.kintai.out_at)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"btn-area"},[(this.kintai.working_status_flag === true)?_c('div',[_c('button',{staticClass:"tc-btn bgcolor-gray btn f-bold pa10_20 flat"},[_c('div',[_c('img',{attrs:{"src":_vm.icon_in}})]),_vm._v(" "),_c('p',{staticClass:"f-bold f-big"},[_vm._v("出社")]),_vm._v(" "),_c('span',{staticClass:"small"},[_vm._v("おはようございます")])]),_vm._v(" "),_c('button',{staticClass:"tc-btn bgcolor-orange f-bold pa10_20 btn orange-shadow",on:{"click":function($event){_vm.openOutModal()}}},[_c('div',[_c('img',{attrs:{"src":_vm.icon_out}})]),_vm._v(" "),_c('p',{staticClass:"f-bold"},[_vm._v("退社")]),_vm._v(" "),_c('span',{staticClass:"small"},[_vm._v("お疲れ様でした")])])]):_c('div',[_c('button',{staticClass:"tc-btn bgcolor-green f-bold pa10_20 btn green-shadow",on:{"click":function($event){_vm.openInModal()}}},[_c('div',[_c('img',{attrs:{"src":_vm.icon_in}})]),_vm._v(" "),_c('p',{staticClass:"f-bold f-color-white"},[_vm._v("出社")]),_vm._v(" "),_c('span',{staticClass:"small f-color-white"},[_vm._v("おはようございます")])]),_vm._v(" "),_c('button',{staticClass:"tc-btn bgcolor-gray btn f-bold pa10_20 flat"},[_c('div',[_c('img',{attrs:{"src":_vm.icon_out}})]),_vm._v(" "),_c('p',{staticClass:"f-bold f-color-white"},[_vm._v("退社")]),_vm._v(" "),_c('span',{staticClass:"small f-color-white"},[_vm._v("お疲れ様でした")])])])]),_vm._v(" "),_c('div',{staticClass:"history"},[_c('p',[_vm._v("履歴")]),_vm._v(" "),(this.kintai.last_data[0])?_c('table',[_vm._m(0),_vm._v(" "),_c('tr',[_c('td',{staticClass:"date"},[_vm._v(_vm._s(this.kintai.last_data[0].date))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(this.kintai.last_data[0].in_at))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(this.kintai.last_data[0].out_at))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(this.kintai.last_data[0].time))])]),_vm._v(" "),(this.kintai.last_data[1])?_c('tr',[_c('td',{staticClass:"date"},[_vm._v(_vm._s(this.kintai.last_data[1].date))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(this.kintai.last_data[1].in_at))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(this.kintai.last_data[1].out_at))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(this.kintai.last_data[1].time))])]):_vm._e(),_vm._v(" "),(this.kintai.last_data[2])?_c('tr',[_c('td',{staticClass:"date"},[_vm._v(_vm._s(this.kintai.last_data[2].date))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(this.kintai.last_data[2].in_at))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(this.kintai.last_data[2].out_at))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(this.kintai.last_data[2].time))])]):_vm._e(),_vm._v(" "),(this.kintai.last_data[3])?_c('tr',[_c('td',{staticClass:"date"},[_vm._v(_vm._s(this.kintai.last_data[3].date))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(this.kintai.last_data[3].in_at))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(this.kintai.last_data[3].out_at))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(this.kintai.last_data[3].time))])]):_vm._e(),_vm._v(" "),(this.kintai.last_data[4])?_c('tr',[_c('td',{staticClass:"date"},[_vm._v(_vm._s(this.kintai.last_data[4].date))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(this.kintai.last_data[4].in_at))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(this.kintai.last_data[4].out_at))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(this.kintai.last_data[4].time))])]):_vm._e(),_vm._v(" "),(this.kintai.last_data[5])?_c('tr',[_c('td',{staticClass:"date"},[_vm._v(_vm._s(this.kintai.last_data[5].date))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(this.kintai.last_data[5].in_at))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(this.kintai.last_data[5].out_at))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(this.kintai.last_data[5].time))])]):_vm._e(),_vm._v(" "),(this.kintai.last_data[6])?_c('tr',[_c('td',{staticClass:"date"},[_vm._v(_vm._s(this.kintai.last_data[6].date))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(this.kintai.last_data[6].in_at))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(this.kintai.last_data[6].out_at))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(this.kintai.last_data[6].time))])]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('router-link',{staticClass:"btn c-btn",attrs:{"to":{ name: 'TimeCardHistory' }}},[_vm._v("履歴確認はこちら")]),_vm._v(" "),_c('div',{staticClass:"space"}),_vm._v(" "),_c('div',{staticClass:"example-modal-window"},[(_vm.in_modal)?_c('ConfirmationModal',{on:{"close":_vm.closeModal}},[_c('p',{attrs:{"id":"input_massage_text f-bold"}},[_vm._v("出社時間")]),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.in_date),expression:"in_date"}],staticClass:"form-control date-form",attrs:{"name":"today","id":"today","type":"date","disabled":_vm.forgetting_flag==false},domProps:{"value":(_vm.in_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.in_date=$event.target.value}}}),_vm._v(" "),_c('vue-timepicker',{staticClass:"time-form",attrs:{"hour-label":"時","minute-label":"分","format":"HH:mm","disabled":_vm.forgetting_flag==false},model:{value:(_vm.in_time),callback:function ($$v) {_vm.in_time=$$v},expression:"in_time"}}),_vm._v(" "),_c('div',[_c('label',{attrs:{"for":"checkbox"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.forgetting_flag),expression:"forgetting_flag"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.forgetting_flag)?_vm._i(_vm.forgetting_flag,null)>-1:(_vm.forgetting_flag)},on:{"click":_vm.changeCheckbox,"change":function($event){var $$a=_vm.forgetting_flag,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.forgetting_flag=$$a.concat([$$v]))}else{$$i>-1&&(_vm.forgetting_flag=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.forgetting_flag=$$c}}}}),_vm._v("\n                        押し忘れ\n                    ")])])],1),_vm._v(" "),_c('template',{slot:"footer"},[_c('button',{on:{"click":_vm.sendIn}},[_vm._v("出社")])])],2):_vm._e(),_vm._v(" "),(_vm.out_modal)?_c('ConfirmationModal',{on:{"close":_vm.closeModal}},[_c('p',{attrs:{"id":"input_massage_text f-bold"}},[_vm._v("退社時間")]),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.out_date),expression:"out_date"}],staticClass:"form-control date-form",attrs:{"name":"today","id":"today","type":"date","disabled":_vm.forgetting_flag==false},domProps:{"value":(_vm.out_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.out_date=$event.target.value}}}),_vm._v(" "),_c('vue-timepicker',{staticClass:"time-form",attrs:{"hour-label":"時","minute-label":"分","format":"HH:mm","disabled":_vm.forgetting_flag==false},model:{value:(_vm.out_time),callback:function ($$v) {_vm.out_time=$$v},expression:"out_time"}}),_vm._v(" "),_c('div',[_c('label',{attrs:{"for":"checkbox"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.forgetting_flag),expression:"forgetting_flag"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.forgetting_flag)?_vm._i(_vm.forgetting_flag,null)>-1:(_vm.forgetting_flag)},on:{"click":_vm.changeCheckbox,"change":function($event){var $$a=_vm.forgetting_flag,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.forgetting_flag=$$a.concat([$$v]))}else{$$i>-1&&(_vm.forgetting_flag=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.forgetting_flag=$$c}}}}),_vm._v("\n                        押し忘れ\n                    ")])])],1),_vm._v(" "),_c('template',{slot:"footer"},[_c('button',{on:{"click":_vm.checkSendOut}},[_vm._v("退社")])])],2):_vm._e(),_vm._v(" "),(_vm.result_modal)?_c('ConfirmationModal',{on:{"close":_vm.closeModal}},[_c('div',[_vm._v("\n                "+_vm._s(this.result)+"\n            ")]),_vm._v(" "),_c('template',{slot:"footer"})],2):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"date"}),_vm._v(" "),_c('th',[_vm._v("出社")]),_vm._v(" "),_c('th',[_vm._v("退社")]),_vm._v(" "),_c('th',[_vm._v("勤務時間")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 679:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeCardHistory_vue__ = __webpack_require__(271);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18f37664_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeCardHistory_vue__ = __webpack_require__(681);
function injectStyle (ssrContext) {
  __webpack_require__(680)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18f37664"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeCardHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18f37664_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeCardHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 680:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 681:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"time_card_history"}},[_c('h1',[_vm._v("勤怠履歴確認")]),_vm._v(" "),_c('div',[_c('button',{staticClass:"tc-btn bgcolor-green f-bold pa10_20 btn green-shadow",on:{"click":function($event){_vm.getLastMonth()}}},[_vm._v("←前の月")]),_vm._v(" "),_c('span',{staticClass:"month"},[_vm._v(_vm._s(this.month)+"月")]),_vm._v(" "),_c('button',{staticClass:"tc-btn bgcolor-green f-bold pa10_20 btn green-shadow",on:{"click":function($event){_vm.getNextMonth()}}},[_vm._v("次の月→")])]),_vm._v(" "),_c('table',[_vm._m(0),_vm._v(" "),_vm._l((this.time_card_list),function(value){return _c('tr',[_c('td',[_vm._v(_vm._s(value.day))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(value.weekday))]),_vm._v(" "),(value.in_forgetting_flag==1)?_c('td',{staticClass:"red"},[_vm._v(_vm._s(value.in_at))]):_c('td',{},[_vm._v(_vm._s(value.in_at))]),_vm._v(" "),(value.out_forgetting_flag==1)?_c('td',{staticClass:"red"},[_vm._v(_vm._s(value.out_at))]):_c('td',{},[_vm._v(_vm._s(value.out_at))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(value.time))])])})],2),_vm._v(" "),_c('router-link',{staticClass:"white--text f-bold login-btn pa5_10per",attrs:{"to":{ name: 'TimeCard' }}},[_c('span',{staticClass:"color_092033"},[_vm._v("戻る")])]),_vm._v(" "),_c('p',{staticClass:"caution"},[_vm._v("※押し忘れは赤字で表示されます")]),_vm._v(" "),_c('div',{staticClass:"space"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"date"},[_vm._v(" 日付")]),_vm._v(" "),_c('th',{staticClass:"wday"},[_vm._v(" 曜日")]),_vm._v(" "),_c('th',{staticClass:"time"},[_vm._v("出社")]),_vm._v(" "),_c('th',{staticClass:"time"},[_vm._v("退社")]),_vm._v(" "),_c('th',{staticClass:"time"},[_vm._v("勤務時間")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 682:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__ = __webpack_require__(272);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_548b30ae_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__ = __webpack_require__(684);
function injectStyle (ssrContext) {
  __webpack_require__(683)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-548b30ae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_548b30ae_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 683:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 684:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"register"}},[_c('v-container',{staticClass:"v-main paTop0",style:({ backgroundImage: 'url(' + _vm.background_img + ')' })},[_c('v-card-actions',{staticClass:"padding0"},[_c('v-card-title'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('p',{staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(_vm.$route.params.version))])],1)],1),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"0"}},[_vm._v("アカウントの登録")]),_vm._v(" "),_c('div',{staticClass:"register-field"},[_c('div',{staticClass:"rForm"},[_c('div',{staticClass:"rLabel"},[_vm._v("お名前")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.account_name),expression:"account_name"}],staticClass:"v-form rInput",attrs:{"label":"お名前","placeholder":"(例)山田 太郎"},domProps:{"value":(_vm.account_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.account_name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"rForm"},[_c('div',{staticClass:"rLabel"},[_vm._v("メールアドレス")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"v-form rInput",attrs:{"label":"メールアドレス","placeholder":"(例)test@mail.com"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"rForm"},[_c('div',{staticClass:"rLabel"},[_vm._v("企業コード")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.company_code),expression:"company_code"}],staticClass:"v-form rInput",attrs:{"label":"企業コード","placeholder":"企業コード番号を入力"},domProps:{"value":(_vm.company_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.company_code=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"rForm"},[_c('div',{staticClass:"rLabel"},[_vm._v("入社日")]),_vm._v(" "),_c('div',{staticClass:"rDInput"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hire_year),expression:"hire_year"}],staticClass:"v-form",attrs:{"label":"入社日","placeholder":"2010","type":"number","suffix":"年"},domProps:{"value":(_vm.hire_year)},on:{"input":function($event){if($event.target.composing){ return; }_vm.hire_year=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"suffix"},[_vm._v("年")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hire_month),expression:"hire_month"}],staticClass:"v-form",attrs:{"placeholder":"4","type":"number","suffix":"月"},domProps:{"value":(_vm.hire_month)},on:{"input":function($event){if($event.target.composing){ return; }_vm.hire_month=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"suffix"},[_vm._v("月")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hire_day),expression:"hire_day"}],staticClass:"v-form",attrs:{"placeholder":"1","type":"number","suffix":"日"},domProps:{"value":(_vm.hire_day)},on:{"input":function($event){if($event.target.composing){ return; }_vm.hire_day=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"suffix"},[_vm._v("日")])])]),_vm._v(" "),_c('div',{staticClass:"rForm"},[_c('div',{staticClass:"rLabel"},[_vm._v("パスワード(6文字以上)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"v-form rInput",attrs:{"label":"パスワード(6文字以上)","type":"password","placeholder":"パスワード"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password_confirmation),expression:"password_confirmation"}],staticClass:"v-form rInput",attrs:{"label":"パスワード確認","type":"password","placeholder":"パスワード確認"},domProps:{"value":(_vm.password_confirmation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password_confirmation=$event.target.value}}})])]),_vm._v(" "),_c('div',[_c('v-btn',{staticClass:"white--text f-bold login-btn pa5_10per",on:{"click":function($event){_vm.signupSend()}}},[_c('span',{staticClass:"color_092033"},[_vm._v("アカウント登録")])])],1),_vm._v(" "),_c('v-btn',{staticClass:"white--text f-bold login-btn pa5_10per",attrs:{"to":{ name: 'Hello' }}},[_c('span',{staticClass:"color_092033"},[_vm._v("戻る")])]),_vm._v(" "),_c('div',{staticClass:"space"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 685:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReturnUq_vue__ = __webpack_require__(273);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ba7cf74_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReturnUq_vue__ = __webpack_require__(687);
function injectStyle (ssrContext) {
  __webpack_require__(686)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ba7cf74"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReturnUq_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ba7cf74_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReturnUq_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 686:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 687:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"return_uq",attrs:{"id":"return_uq"}},[_c('h1',[_vm._v("UQの返却")]),_vm._v(" "),_c('div',{staticClass:"return_form"},[_c('div',{staticClass:"form-group v-card__title"},[_c('div',{staticClass:"return-form"},[_c('v-text-field',{attrs:{"type":"number","suffix":"日"},model:{value:(_vm.day),callback:function ($$v) {_vm.day=$$v},expression:"day"}})],1),_vm._v(" "),_c('span',{staticClass:"f13 f-bold"},[_vm._v("と")]),_vm._v(" "),_c('div',{staticClass:"return-form"},[_c('v-text-field',{attrs:{"type":"number","suffix":"時間"},model:{value:(_vm.hour),callback:function ($$v) {_vm.hour=$$v},expression:"hour"}})],1),_vm._v(" "),_c('div',{staticClass:"return-form"},[_c('v-text-field',{attrs:{"type":"number","suffix":"分"},model:{value:(_vm.min),callback:function ($$v) {_vm.min=$$v},expression:"min"}})],1)])]),_vm._v(" "),_c('v-flex',{staticClass:"paBottom10"},[_c('v-btn',{staticClass:"white--text f-bold btn pa5_10per",on:{"click":function($event){_vm.openModal()}}},[_c('span',{staticClass:"color_092033"},[_vm._v("返却")])])],1),_vm._v(" "),_c('div',{staticClass:"balance-area"},[_c('p',{staticClass:"uq_board pa0 f15"},[_vm._v("UQ残高 ")]),_c('p'),_c('p',{staticClass:"uq_board pa0 f18"},[_c('span',{staticClass:"blue"},[_vm._v(_vm._s(_vm.wallet.mosaic_balance)+" UQ")])]),_c('p'),_c('p',{staticClass:"uq_board pa0 f15"},[_vm._v("取得可能な有給休暇")]),_vm._v(" "),_c('p',{staticClass:"uq_day pa0 f18"},[_vm._v(_vm._s(_vm.wallet.uq_day)+"日"),_c('span',{staticClass:"middle"},[_vm._v("と")]),_vm._v(_vm._s(_vm.wallet.uq_hours)+"時間"+_vm._s(_vm.wallet.uq_minutes)+"分")])]),_vm._v(" "),_c('div',{staticClass:"example-modal-window"},[(_vm.modal)?_c('ConfirmationModal',{on:{"close":_vm.closeModal}},[_c('p',{attrs:{"id":"input_massage_text"}},[_vm._v("以下の内容で返却します。")]),_vm._v(" "),_c('div',[_c('p',[_vm._v(_vm._s(this.toAmount)+"UQ")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(this.amount_hd))])]),_vm._v(" "),_c('template',{slot:"footer"},[_c('button',{on:{"click":_vm.doSend}},[_vm._v("送信")])])],2):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 690:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 694:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[275]);


// WEBPACK FOOTER //
// static/js/app.6df04846a15841be3b51.js